/* Generated by frontend/cli/openapi.ts from fact2server's OpenAPI schema — do not edit. Regenerate with `make typescript-types`. */

export interface AccessTokenListItem {
    artkey: number
    created_on: string
    label: string
    last_used_on: string
}

export enum AccountSlug {
    A2Bc = 'a2bc',
    Msi = 'msi',
    Msp = 'msp',
    Etr = 'etr',
}

export interface Action {
    label: string
    uri: string | null
    method: HTTPMethod | null
}

export interface AddAlternativeNameRequest {
    alternative_name: string
}

export interface AddHiddenCountryCodeRequest {
    country_code: string
}

export interface AddHiddenRelationRequest {
    relation_artkey: number
}

export interface AdditionalSalesOrderDetailsResponse {
    vat_code: number
    supplier: Fact2ServerApiPortalOrderAdditionalDetailsAdditionalSalesOrderDetailsResponseSupplier
    was_created_by: PortalUser | null
    destination: Destination | null
}

export interface AfvalfondsRequest {
    year: number
}

export enum AgeLastPortalLogin {
    Value30Days = '> 30 days',
    Value180Days = '> 180 days',
    Value360Days = '> 360 days',
    Value720Days = '> 720 days',
}

export enum AgeLastSalesOrder {
    Value30Days = '> 30 days',
    Value180Days = '> 180 days',
    Value360Days = '> 360 days',
    Value720Days = '> 720 days',
}

export enum AlcoholFormatting {
    Percentage = 'percentage',
    Decimal = 'decimal',
}

export interface AlcoholStatistic {
    alcohol_percentage: number
    count: number
}

export enum ArticleValueType {
    String = 'string',
    Number = 'number',
    Boolean = 'boolean',
}

export interface AssistantBody {
    message?: string
    session_id?: string | null
    images?: AssistantImage[]
}

export interface AssistantImage {
    media_type: 'image/jpeg' | 'image/png' | 'image/gif' | 'image/webp'
    data: string
}

export interface AssistantTranscript {
    model: string
    session: AssistantUsagePayload
    timeline: AssistantTranscriptItem[]
}

export interface AssistantTranscriptItem {
    kind: 'user' | 'assistant' | 'tool'
    text?: string
    image_count?: number
    name?: string | null
    result?: {[key: string]: unknown} | null
    result_tokens?: number
    tool_use_id?: string | null
}

export interface AssistantUsagePayload {
    input_tokens: number
    output_tokens: number
    cache_creation_input_tokens: number
    cache_read_input_tokens: number
    prompt_tokens: number
    total_tokens: number
    cached_fraction: number
    cost_usd: number | null
    costs_usd: {[key: string]: number} | null
}

export enum AttachmentType {
    ItemMutation = 'Item Mutation',
    PurchaseOrder = 'Purchase Order',
    Relation = 'Relation',
    SalesOrder = 'Sales Order',
    Warehouse = 'Warehouse',
    Lead = 'Lead',
    Campaign = 'Campaign',
}

export interface AuditLog {
    artkey: number
    type: SPLAuditLogType
    message: string
}

export interface Availability {
    country_of_origin: string | null
    number_of_cases_available: number
}

export interface AvailabilityChild {
    offer_item_type: TBODeliveryPeriod
    count: number
}

export interface AvailabilityStatistic {
    offer_item_type: AvailabilityType
    count: number
    children: AvailabilityChild[]
}

export enum AvailabilityType {
    Stock = 'stock',
    Tbo = 'tbo',
    Purchase = 'purchase',
    Unavailable = 'unavailable',
}

export interface BodyCmsBackupImportFragmentsDiscoverCmsBackupFragmentsImportPost {
    file: string
}

export interface BodyCmsBackupImportFragmentsDryRunDiscoverCmsBackupFragmentsImportDryRunPost {
    file: string
}

export interface BodyCmsBackupImportMediaDiscoverCmsBackupMediaImportPost {
    file: string
    update_existing?: boolean
}

export interface BodyCmsBackupImportPagesDiscoverCmsBackupPagesImportPost {
    file: string
}

export interface BodyCmsBackupImportPagesDryRunDiscoverCmsBackupPagesImportDryRunPost {
    file: string
}

export interface BodyCmsBackupImportPlaceholdersDiscoverCmsBackupPlaceholdersImportPost {
    file: string
}

export interface BodyCmsImportDryRunDiscoverCmsBackupMediaImportDryRunPost {
    file: string
    update_existing?: boolean
}

export interface BodyCmsMediaFileUploadDiscoverCmsMediaFilesUploadPost {
    file: string
    folder_artkey: number
}

export interface BodyCmsMediaReplaceFileContentDiscoverCmsMediaFilesArtkeyContentPut {
    file: string
}

export interface BodyExactTokenDiscoverMockServicesExactApiOauth2TokenPost {
    grant_type: string
    client_id: string
    client_secret: string
    code?: unknown
    redirect_uri?: unknown
}

export interface BodyUploadGitlabMediaDiscoverMockServicesGitlabProjectsProjectIdUploadsPost {
    file: string
}

export interface Bottle {
    product: Product
    volume: string
    alcohol_percentage: string
    refill_status: string
}

export interface BottleByGTINResp {
    artkey: number
    alcohol_percentage: string
    default_country_code: string | null
    product_category_artkey: number
    product_category_name: string
    product_artkey: number
    product_name: string
    refill_status: string
    volume: string
}

export interface BottleData {
    artkey?: number | null
    alcohol_percentage?: number | string | null
    volume?: number | string | null
    refill_status?: RefillStatus | null
    product: ProductData
}

export interface BottleMarketResponse {
    artkey: number
    entity_type: EntityAlt
    currency: Currency
    price_per_case: string
    euro_price_per_bottle: string
    offer_item_type: OfferItemType | null
    is_active: boolean
    case_excise_nl: string
    number_of_bottles_per_case?: number | null
    customs_status?: CustomsStatus | null
    gift_box_type?: GiftBoxType | null
    cases_per_pallet_layer?: number | null
    cases_per_pallet?: number | null
    best_before_date?: string | null
    tax_label?: string | null
    serialized_is_tagged_with?: string | null
    incoterm?: string | null
    start_date?: string | null
    end_date?: string | null
    delivery_period?: number | null
    is_tbo_price_list?: boolean
    offer_artkey?: number | null
    aux_info?: string | null
    bottle_artkey: number
    volume: string
    alcohol_percentage: string
    refill_status: RefillStatus
    bottle_excise_nl: string
    product_artkey: number
    product_name: string
    product_default_country_code?: string | null
    supplier_artkey: number | null
    supplier_name: string | null
    supplier_company_type?: string | null
    account_artkey: number | null
    account_slug: AccountSlug | null
    account_name: string | null
    supplier_price_list_artkey?: number | null
    supplier_price_list_description?: string | null
    supplier_price_list_status?: string | null
    is_available?: boolean | null
    availability_status?: string | null
    sl_product_name?: string | null
    bottle_gtin_code?: string | null
    hidden_reasons: string[] | null
}

export interface BottleMarketResult {
    result: BottleMarketResponse[]
    total_count: number
}

export interface BottleResponse {
    artkey: number
    volume: string | null
    refill_status: RefillStatus | null
    alcohol_percentage: string | null
    product: ProductResponse
}

export interface BottleStockResponse {
    stock_type: BottleStockType
    artkey: number
    reference: string
    account_slug: string
    account_name: string
    lot: string | null
    purchase_order_artkey: number
    warehouse_name: string
    entry_date: string | null
    number_of_cases_in_stock: number
    number_of_cases_in_purchase: number
    number_of_cases_in_sales: number
    number_of_cases_available: number
    item_throughput: string | null
    was_bought_for: string
    refill_status: string
    number_of_bottles: number
    gift_box_type: GiftBoxType | null
    tax_label: string | null
    customs_status: CustomsStatus
    case_excise_nl: string
    was_bought_in: Currency
    bought_against_rate: string
}

export enum BottleStockType {
    Item = 'item',
    PurchaseOrderItem = 'purchase_order_item',
}

export interface BottleThroughputResponse {
    last_month: number
    last_quarter: number
    last_year: number
}

export interface BrandCollectionResponse {
    artkey: number
    name: string
    match_text: string
    brand_holder_name: string
}

export interface BrandHolderCollectionViewResponse {
    artkey: number
    name: string
    full_name: string | null
    requires_import_statement: boolean
    brand_count: number
}

export interface BrandHolderStatistic {
    artkey: number
    name: string
    count: number
}

export interface BrandHoldersResponse {
    artkey: number
    name: string
    number_of_products: number
}

export interface BrandStatistic {
    artkey: number
    name: string
    count: number
}

export interface BulkTranslateRequest {
    translate: TranslateRequest[]
}

export interface BulkTranslateResponse {
    translated: Translated[]
}

export interface BuyFromAccountSalesOrder {
    artkey: number
    reference: string
    is_invoiced_on: string | null
    account: Fact2ServerApiDiscoverPurchaseOrderGetGetPurchaseOrderResponseBuyFromAccountSalesOrderAccount
}

export enum BuyerSupplier {
    Buyers = 'Buyers',
    Suppliers = 'Suppliers',
    NoSuppliers = 'No Suppliers',
    OperatesOnline = 'Operates online',
    NeverInvoicedOrder = 'Never invoiced Order',
    PortalAccountNeverUsed = 'Portal account never used',
}

export interface CalculationDetails {
    number_of_cases: number
    number_of_lines: number
    incoterm: string
    target_is_loendersloot: boolean
    is_loendersloot_calculation: boolean
    euro_was_bought_for: string
    has_waste_fund_costs_nl: boolean
    warehouse_costs_per_case: string | null
    diesel_surcharge_percentage: string
    additional_per_case: string | null
    exw_handover_costs: string | null
    spirits_costs_per_case: string | null
    spirits_maximum_cases: number | null
    spirits_maximum_costs: string | null
    spirits_minimum_cases: number | null
    spirits_minimum_costs: string | null
    inspection_costs_first_item: string | null
    inspection_costs_per_item: string | null
    has_duty_drawback: boolean | null
    duty_drawback: string | null
    duty_drawback_per_case: string | null
    non_spirits_minimum_pallets: number | null
    non_spirits_minimum_costs: string | null
    non_spirits_costs_per_pallet: string | null
}

export interface CampaignActionRequest {
    action: CampaignActionType
    is_suspended?: boolean | null
}

export interface CampaignActionResponse {
    is_suspended_by_artkey?: number | null
    next_run?: string | null
    action: CampaignActionType
}

export enum CampaignActionType {
    ARCHIVE = 'archive',
    SUSPEND = 'suspend',
    FORCE_RUN = 'force_run',
}

export enum CampaignMnemonic {
    StartOfWeek = 'start_of_week',
    Wysiwyg = 'wysiwyg',
    ArrivingSoon = 'arriving_soon',
    NewInStock = 'new_in_stock',
    PalletDeals = 'pallet_deals',
}

export interface CampaignPlaceholderTranslation {
    artkey: number
    language_code: string
    translation: string
}

export interface CampaignRef {
    artkey: number
    name: string
}

export enum CartValidation {
    STEP_SIZE = 'STEP_SIZE',
    QUANTITY = 'QUANTITY',
    MIN_QUANTITY = 'MIN_QUANTITY',
    PRICE_WAS_RAISED = 'PRICE_WAS_RAISED',
}

export interface CartValidationError {
    case_artkey: number
    validation_error: CartValidation
    invalid_value: string
    valid_value: string
    step_size_quantity: number | null
    minimum_quantity: number
}

export interface CartValidationResponse {
    total: number
    errors: CartValidationError[]
}

export interface Case {
    case_number_of_bottles: number
    tax_label: string | null
    gift_box_type: GiftBoxType | null
    product_artkey: number
    name: string
    alcohol_percentage: string
    volume: string
    refill_status: RefillStatus
}

export interface CaseAndSupplierResponse {
    supplier?: Fact2ServerApiDiscoverMarketExploreCaseAndSupplierCaseAndSupplierResponseSupplier | null
    case?: Case | null
}

export interface CaseUpdateRequest {
    cases_per_pallet: number | null
    cases_per_pallet_layer: number | null
}

export enum CasesOrBottles {
    Cases = 'cases',
    Bottles = 'bottles',
}

export interface CategoriesResponse {
    categories: PortalMenuCategory[]
}

export interface Category {
    artkey: number
    name: string
    priority?: number | null
    children: Category[]
}

export interface CategoryStatistic {
    artkey: number
    name: string
    count: number
}

export interface ChangePasswordRequest {
    new_password: string
    current_password: string
}

export interface CheckVatRequest {
    countryCode?: string | null
    vatNumber?: string | null
    requesterMemberStateCode?: string | null
    requesterNumber?: string | null
    traderName?: string | null
    traderStreet?: string | null
    traderPostalCode?: string | null
    traderCity?: string | null
    traderCompanyType?: string | null
}

export interface CheckVatResponse {
    countryCode?: string | null
    vatNumber?: string | null
    requestDate?: string | null
    valid?: boolean | null
    requestIdentifier?: string | null
    name?: string | null
    address?: string | null
    traderName?: string | null
    traderStreet?: string | null
    traderPostalCode?: string | null
    traderCity?: string | null
    traderCompanyType?: string | null
    traderNameMatch?: MatchModel | null
    traderStreetMatch?: MatchModel | null
    traderPostalCodeMatch?: MatchModel | null
    traderCityMatch?: MatchModel | null
    traderCompanyTypeMatch?: MatchModel | null
}

export interface ClearPortalCacheResponse {
    cleared?: string[] | null
    error?: string | null
}

export interface CmsAllPlaceholdersResourcesResponse {
    resources: {[key: string]: CmsLocaleTranslationBundle}
}

export interface CmsCacheClearBody {
    name?: string | null
}

export interface CmsFragmentCreateRequest {
    account_slugs?: string[]
    jsx_source: string
    name: string
}

export interface CmsFragmentDetail {
    account_slugs?: string[]
    artkey: number
    compiled_js: string | null
    is_published_on: string | null
    jsx_source: string
    name: string
}

export interface CmsFragmentImport {
    name: string
    account_slugs?: string[]
}

export interface CmsFragmentImportResponse {
    fragments_created?: CmsFragmentImport[]
    fragments_replaced?: CmsFragmentImport[]
}

export interface CmsFragmentListItem {
    account_slugs?: string[]
    artkey: number
    is_published_on: string | null
    name: string
}

export interface CmsFragmentNameAvailabilityResponse {
    available: boolean
    conflict_artkey?: number | null
}

export interface CmsFragmentPlaceholderLinkBody {
    placeholder_artkeys: number[]
}

export interface CmsFragmentPlaceholderUnlinkBody {
    placeholder_artkeys: number[]
    on_last_link: UnlinkedFragmentKeyAction
}

export interface CmsFragmentRef {
    artkey: number
    name: string
    account_slugs?: string[]
}

export interface CmsFragmentRuntimeItem {
    name: string
    compiled_js: string
}

export interface CmsFragmentUpdateBody {
    account_slugs?: string[]
    jsx_source: string | null
    name: string
}

export enum CmsHeroMode {
    Full = 'full',
    Collapsed = 'collapsed',
    CollapsedAuthenticated = 'collapsed-authenticated',
}

export interface CmsImportMediaFile {
    name: string
    path: string
}

export interface CmsImportMediaFolder {
    name: string
    path: string
}

export interface CmsLocaleTranslationBundle {
    translation: {[key: string]: string | {[key: string]: unknown}}
}

export interface CmsMediaCleanupRequest {
    dry_run?: boolean
    delete_artkeys?: number[]
}

export interface CmsMediaCleanupResponse {
    unused: UnusedMediaFileResponse[]
    deleted: string[]
    used_count: number
    ignored_count: number
    locked_count: number
    total_count: number
    unused_bytes: number
    scanned_file_count: number
    source_available: boolean
    dry_run: boolean
}

export interface CmsMediaDescribeBody {
    file_artkeys: number[]
}

export interface CmsMediaDescribeResult {
    artkey: number
    description?: string | null
    error?: string | null
}

export interface CmsMediaFileCopy {
    folder_artkey: number
    file_name?: string | null
}

export interface CmsMediaFileLock {
    file_artkeys: number[]
    is_locked: boolean
}

export interface CmsMediaFileMove {
    folder_artkey: number
    file_name?: string | null
}

export interface CmsMediaFileResponse {
    artkey: number
    folder_artkey: number
    original_filename: string
    content_type: string
    byte_size: number
    uri: string
    description: string | null
    width: number | null
    height: number | null
    exif: {[key: string]: unknown} | null
    is_locked: boolean
}

export interface CmsMediaFileSearchResponse {
    artkey: number
    folder_artkey: number
    original_filename: string
    content_type: string
    byte_size: number
    uri: string
    description: string | null
    width: number | null
    height: number | null
    exif: {[key: string]: unknown} | null
    is_locked: boolean
    folder_artkeys: number[]
    folder_path: string
}

export interface CmsMediaFileStorageKey {
    uri: string
}

export interface CmsMediaFolderCopy {
    parent_artkey: number
}

export interface CmsMediaFolderCreate {
    name: string
    parent_artkey: number
}

export interface CmsMediaFolderLock {
    folder_artkeys: number[]
    is_locked: boolean
    recursive?: boolean
}

export interface CmsMediaFolderMove {
    parent_artkey: number
    name: string
}

export interface CmsMediaFolderResponse {
    artkey: number
    parent_artkey: number | null
    name: string
    path: string
    is_locked: boolean
}

export interface CmsMediaImportResponse {
    media_created?: CmsImportMediaFile[]
    media_updated?: CmsImportMediaFile[]
    media_skipped?: CmsImportMediaFile[]
    media_locked?: CmsImportMediaFile[]
    folders_created?: CmsImportMediaFolder[]
    folders_skipped?: CmsImportMediaFolder[]
}

export interface CmsMediaResizeBody {
    width: number
}

export interface CmsMediaResizeResult {
    artkey: number
    width: number
    height: number
    byte_size: number
}

export interface CmsMediaStripExifBody {
    file_artkeys: number[]
}

export interface CmsMediaStripExifResult {
    artkey: number
    stripped?: boolean
    error?: string | null
}

export interface CmsPageCreateRequest {
    account_slug: string
    hero_background?: string
    hero_mode?: CmsHeroMode
    jsx_source: string
    path: string
}

export interface CmsPageDetail {
    account_slug: string
    artkey: number
    compiled_js: string | null
    hero_background: string
    is_published_on: string | null
    jsx_source: string
    path: string
    hero_mode: string
    account_scopes?: string[]
}

export interface CmsPageImport {
    path: string
}

export interface CmsPageImportResponse {
    pages_created?: CmsPageImport[]
    pages_replaced?: CmsPageImport[]
}

export interface CmsPageListItem {
    account_slug: string
    artkey: number
    is_published_on: string | null
    path: string
}

export interface CmsPagePlaceholderLinkBody {
    placeholder_artkeys: number[]
}

export interface CmsPagePlaceholderUnlinkBody {
    placeholder_artkeys: number[]
    on_last_link: UnlinkedKeyAction
}

export interface CmsPagePublicListItem {
    path: string
    title: string | null
    description: string | null
}

export interface CmsPageRef {
    artkey: number
    path: string
    account_slug: string
}

export interface CmsPageUpdateBody {
    account_slug: string
    hero_background?: string
    hero_mode?: CmsHeroMode
    jsx_source: string | null
    path: string
}

export interface CmsPathAvailabilityResponse {
    available: boolean
    conflict_artkey?: number | null
}

export interface CmsRuntimeViewResponse {
    path: string
    compiled_js: string
    hero_background: string
    hero_mode: string
}

export interface CmsTranspileBody {
    jsx_source: string
}

export interface CollectionLoenderslootMessageResponse {
    artkey: number
    status: string
    created_on: string
    message_type: string
    action_type?: string | null
    header_type?: string | null
    shipment_id?: string | null
}

export interface CollectionViewMeta {
    sort_definition: SortDefinition
    filter_definitions: (TextFilter | SelectWorkflow | SelectSingle | SelectMultiple | ToggleFilter | SelectRange)[]
    endpoints: {[key: string]: Endpoint}
}

export interface CollectionViewResultBrandHolderCollectionViewResponse {
    total_count: number
    items: BrandHolderCollectionViewResponse[]
}

export interface CollectionViewResultCmsFragmentListItem {
    total_count: number
    items: CmsFragmentListItem[]
}

export interface CollectionViewResultCmsPageListItem {
    total_count: number
    items: CmsPageListItem[]
}

export interface CollectionViewResultGetArticleCollectionViewResponse {
    total_count: number
    items: GetArticleCollectionViewResponse[]
}

export interface CollectionViewResultGetAttachmentCollectionViewResponse {
    total_count: number
    items: GetAttachmentCollectionViewResponse[]
}

export interface CollectionViewResultGetCBSCodeResponse {
    total_count: number
    items: GetCBSCodeResponse[]
}

export interface CollectionViewResultGetCampaignCollectionViewResponse {
    total_count: number
    items: GetCampaignCollectionViewResponse[]
}

export interface CollectionViewResultGetCampaignPlaceholdersResponse {
    total_count: number
    items: GetCampaignPlaceholdersResponse[]
}

export interface CollectionViewResultGetCampaignRecipientsCollectionViewResponse {
    total_count: number
    items: GetCampaignRecipientsCollectionViewResponse[]
}

export interface CollectionViewResultGetCandidatesCollectionResponse {
    total_count: number
    items: GetCandidatesCollectionResponse[]
}

export interface CollectionViewResultGetCmsPlaceholdersResponse {
    total_count: number
    items: GetCmsPlaceholdersResponse[]
}

export interface CollectionViewResultGetEmailCollectionViewResponse {
    total_count: number
    items: GetEmailCollectionViewResponse[]
}

export interface CollectionViewResultGetItemCollectionViewResponse {
    total_count: number
    items: GetItemCollectionViewResponse[]
}

export interface CollectionViewResultGetLocationsCollectionViewResult {
    total_count: number
    items: GetLocationsCollectionViewResult[]
}

export interface CollectionViewResultGetOfferItemCompareWithMarketResponse {
    total_count: number
    items: GetOfferItemCompareWithMarketResponse[]
}

export interface CollectionViewResultGetOfferItemsCollectionViewResponse {
    total_count: number
    items: GetOfferItemsCollectionViewResponse[]
}

export interface CollectionViewResultGetOrderCollectionViewResponse {
    total_count: number
    items: GetOrderCollectionViewResponse[]
}

export interface CollectionViewResultGetPlaceholdersResponse {
    total_count: number
    items: GetPlaceholdersResponse[]
}

export interface CollectionViewResultGetPortalOfferItemResponse {
    total_count: number
    items: GetPortalOfferItemResponse[]
}

export interface CollectionViewResultGetProductCategoryCollectionResponse {
    total_count: number
    items: GetProductCategoryCollectionResponse[]
}

export interface CollectionViewResultGetPurchaseOrderItemsCollectionViewResponse {
    total_count: number
    items: GetPurchaseOrderItemsCollectionViewResponse[]
}

export interface CollectionViewResultGetRelationPurchaseOrderResponse {
    total_count: number
    items: GetRelationPurchaseOrderResponse[]
}

export interface CollectionViewResultGetReviewableProductPhotoResponse {
    total_count: number
    items: GetReviewableProductPhotoResponse[]
}

export interface CollectionViewResultGetSalesOrderItemsCollectionViewResponse {
    total_count: number
    items: GetSalesOrderItemsCollectionViewResponse[]
}

export interface CollectionViewResultGetSalesOrdersCollectionViewResponse {
    total_count: number
    items: GetSalesOrdersCollectionViewResponse[]
}

export interface CollectionViewResultGetSellableItemCollectionViewResponse {
    total_count: number
    items: GetSellableItemCollectionViewResponse[]
}

export interface CollectionViewResultGetSupplierPriceListItemCollectionResponse {
    total_count: number
    items: GetSupplierPriceListItemCollectionResponse[]
}

export interface CollectionViewResultGetTBOCollectionViewResponse {
    total_count: number
    items: GetTBOCollectionViewResponse[]
}

export interface CollectionViewResultGetUnresolvedItemsResponse {
    total_count: number
    items: GetUnresolvedItemsResponse[]
}

export interface CollectionViewResultGetUserCollectionResponse {
    total_count: number
    items: GetUserCollectionResponse[]
}

export interface CollectionViewResultGetVoucherRelationCollectionViewResult {
    total_count: number
    items: GetVoucherRelationCollectionViewResult[]
}

export interface CollectionViewResultJsxComponent {
    total_count: number
    items: JsxComponent[]
}

export interface CollectionViewResultPortalUserCollectionViewResponse {
    total_count: number
    items: PortalUserCollectionViewResponse[]
}

export interface CollectionViewResultProductGroupMetaResponse {
    total_count: number
    items: ProductGroupMetaResponse[]
}

export interface CollectionViewResultProductGroupResponse {
    total_count: number
    items: ProductGroupResponse[]
}

export interface CollectionViewResultRelationFavouriteResult {
    total_count: number
    items: RelationFavouriteResult[]
}

export interface CollectionViewResultSalesOrderItemByBottle {
    total_count: number
    items: SalesOrderItemByBottle[]
}

export interface CollectionViewResultSupplierPriceListCollectionResponse {
    total_count: number
    items: SupplierPriceListCollectionResponse[]
}

export interface CollectionViewResultSuppressionListResponse {
    total_count: number
    items: SuppressionListResponse[]
}

export interface CollectionViewResultTBOOfferItemCollectionViewResponse {
    total_count: number
    items: TBOOfferItemCollectionViewResponse[]
}

export enum CombinedOrderStatus {
    New = 'New',
    Pending = 'Pending',
    Finalized = 'Finalized',
    Saved = 'Saved',
    Confirmed = 'Confirmed',
    Invoiced = 'Invoiced',
    Cancelled = 'Cancelled',
}

export interface ConfirmOrderRequest {
    request_delivery: boolean
    requested_delivery_date?: string | null
    promotion_choice?: string | null
}

export interface ConfirmSettingsRequest {
    origin_artkey: number
    destination_artkey: number
    includes_excise: boolean
    incoterm: string
    incoterm_location: string
    insurance_type_artkey: number
}

export interface ContactPerson {
    name: string
}

export enum CostType {
    LOENDERSLOOT = 'LOENDERSLOOT',
    WAREHOUSE_BASE_COSTS = 'WAREHOUSE_BASE_COSTS',
}

export interface CountriesOfOriginRequest {
    offer_item_artkeys: number[]
}

export interface CountriesOfOriginResponse {
    artkey: number
    country_of_origin: string
    number_of_cases_available: number
}

export type CountryStatusModel = unknown

export interface CreateAccessTokenRequest {
    label: string
}

export interface CreateAccessTokenResponse {
    artkey: number
    label: string
    token: string
}

export interface CreateAttachmentRequest {
    file_name: string
    contents_base64_encoded: string
    description?: string | null
    category?: string | null
}

export interface CreateEntityResponse {
    artkey: number
    entity_alt: string | null
}

export interface CreateGTINRequest {
    gtin: string
}

export interface CreateIssueRequest {
    description: string
    media: Media
    title: string
    url: string
    sentry_replay_id: string
}

export interface CreateIssueResponse {
    web_url: string
    detail: string
}

export interface CreateLoenderslootTagRequest {
    code: string
    description: string
    unapprove_when_added: boolean
    show_as_feature: boolean
    is_portal_filter: boolean
    forbid_in_stock: boolean
    item_tag_artkey: number
    gift_box_type: GiftBoxType | null
}

export interface CreateOrUpdateAdditionalRequest {
    description: string
    value_type: SalesOrderAdditionalValueType
    value_per_quantity: number | string
    quantity: number
    sales_order_additional_type: SalesOrderAdditionalType
}

export interface CreateOrUpdateCampaignRequest {
    body: string
    contacts_filter?: EmailBatchContactsFilter | null
    email_batch_type: EmailBatchType
    name: string
    offer_artkey: number | null
    schedule_type: EmailBatchScheduleType
    scheduled_at_datetime: string | null
    scheduled_weekday: WeekDay | null
    scheduled_time: string | null
    subject: string
    use_sent_from_user_artkey: number | null
    use_timezone: boolean
}

export interface CreateOrUpdateItemTagRequest {
    name: string
    abbreviation: string
    item_tag_category_artkey: number
}

export interface CreateOrUpdateLocationRequest {
    name: string
    destination_type?: LocationType | null
    can_handle_our_stock: boolean
    is_third_party_warehouse: boolean
    memo: string | null
    street_address: string | null
    zip_code: string
    city: string
    country_code: string
    region_code: string | null
    warehouse_id: string
    emailaddress: string | null
    excise_id: string | null
    vat_id: string | null
    warehouse_base_costs: number | string | null
    warehouse_costs_per_case: number | string | null
    currency: Currency
}

export interface CreateOrUpdateOrderRatingRequest {
    rating: number
    comment?: string | null
}

export interface CreateOrUpdateProductCategoryRequest {
    name: string
    parent_artkey: number | null
    priority: number | null
    be_vat_rate_artkey: number
    nl_vat_rate_artkey: number
    de_vat_rate_artkey: number
    is_spirit: boolean
    default_product_bottle_type: ProductBottleType
}

export interface CreateOrUpdateSupplierPriceListConfig {
    header: string[]
    column_mapping: {[key: string]: string}
}

export interface CreateOrUpdateSupplierPriceListItemRequest {
    bottle: BottleData
    source_line_artkey?: number | null
    artkey?: number | null
    bottle_artkey?: number | null
    supplier_price_list_artkey: number
    gift_box_type: GiftBoxType | null
    aux_info?: string | null
    number_of_bottles_per_case: number
    number_of_bottles?: number | null
    number_of_cases?: number | null
    price_per_bottle?: number | string | null
    currency: Currency
    bottle_gtin_code?: string | null
    case_gtin_code?: string | null
    incoterm: string
    incoterm_location: string | null
    customs_status: CustomsStatus
    availability_status?: string | null
    country_of_origin?: string | null
    cases_per_pallet_layer?: number | null
    cases_per_pallet?: number | null
}

export interface CreateOrderForPromotionRequest {
    orders: PromotionalOrder[]
}

export interface CreateProductCategoryRequest {
    name: string
    parent_artkey: number | null
    priority: number | null
    be_vat_rate_artkey: number
    nl_vat_rate_artkey: number
    de_vat_rate_artkey: number
    is_spirit: boolean
    default_product_bottle_type: ProductBottleType
    product_group_artkey: number
}

export interface CreateProductPhotoRequest {
    is_internal: boolean
    is_primary: boolean
    contents_base64_encoded: string
}

export interface CreateProductPhotoResponse {
    artkey: number
    item_artkey?: number | null
    offer_item_artkey?: number | null
    product_category_artkey?: number | null
    file_name: string
    s3_location?: string | null
    s3_location_thumbnail?: string | null
    original_location: string
}

export interface CreateRelationLogBookEntryRequest {
    message: string
    log_type: RelationLogType
}

export interface CreateSalesOrderCreditItem {
    sales_order_item_artkey: number
    number_of_cases: number
}

export interface CreateSalesOrderItemRequest {
    case_artkey: number
    item_artkey?: number | null
    country_of_origin?: string | null
    number_of_cases: number
    price_per_case: number | string
    description?: string | null
}

export interface CreateSalesOrderTBOItemRequest {
    offer_item_artkey?: number | null
    purchase_order_item_artkey?: number | null
    supplier_price_list_item_artkey?: number | null
    number_of_cases: number
    price_per_case: number | string
}

export interface CreateVoucherRequest {
    relation_voucher_artkey: number
}

export interface CreateWorkflowSnoozeRequest {
    workflow_id: string
    duration_in_days?: number | null
    item_artkey?: number | null
}

export interface CreatedPlaceholder {
    placeholder: string
    page?: string | null
}

export enum Currency {
    EUR = 'EUR',
    USD = 'USD',
    GBP = 'GBP',
    JPY = 'JPY',
}

export interface CurrencyExchangeRequest {
    currency?: string
    date: string
    language?: string
}

export interface Currencyexchangerate {
    baseCurrency: string
    quoteCurrency: string
    name: string
    country: string
    bidRate: string
    askRate: string
    midRate: string
    buyOnlyCurrency: string
    sellOnlyCurrency: string
}

export enum CustomsStatus {
    T1 = 'T1',
    T2 = 'T2',
}

export interface DashboardStatisticsResponse {
    statistics: SupplierStatistic[]
}

export enum DeeplFormality {
    DEFAULT = 'default',
    MORE = 'more',
    LESS = 'less',
    PREFER_MORE = 'prefer_more',
    PREFER_LESS = 'prefer_less',
}

export enum DeeplModelType {
    PreferQualityOptimized = 'prefer_quality_optimized',
    QualityOptimized = 'quality_optimized',
    LatencyOptimized = 'latency_optimized',
}

export enum DeeplWritingStyle {
    SIMPLE = 'simple',
    BUSINESS = 'business',
    ACADEMIC = 'academic',
    CASUAL = 'casual',
    DEFAULT = 'default',
    PREFER_SIMPLE = 'prefer_simple',
    PREFER_BUSINESS = 'prefer_business',
    PREFER_ACADEMIC = 'prefer_academic',
    PREFER_CASUAL = 'prefer_casual',
}

export enum DeeplWritingTone {
    ENTHUSIASTIC = 'enthusiastic',
    FRIENDLY = 'friendly',
    CONFIDENT = 'confident',
    DIPLOMATIC = 'diplomatic',
    DEFAULT = 'default',
    PREFER_ENTHUSIASTIC = 'prefer_enthusiastic',
    PREFER_FRIENDLY = 'prefer_friendly',
    PREFER_CONFIDENT = 'prefer_confident',
    PREFER_DIPLOMATIC = 'prefer_diplomatic',
}

export interface DeletePlaceholdersRequest {
    artkeys: number[]
}

export interface DeletePlaceholdersResponse {
    deleted_artkeys: number[]
    failed_artkeys: number[]
    failed_reasons: string[]
}

export interface Delivery {
    artkey: number
    number_of_block_pallets: number
    number_of_euro_pallets: number
    weight_in_kilos?: string | null
}

export enum DeliveryStatus {
    Created = 'Created',
    Confirmed = 'Confirmed',
}

export interface Destination {
    artkey: number
    name: string
    street_address: string
    zip_code: string
    city: string
    country_code: string
    warehouse_id: string
    excise_id: string | null
    vat_id: string | null
}

export interface DiscoGetUserSubscriptionResponse {
    start_of_week: boolean
    start_of_week_on: string | null
    start_of_week_by_artkey: number | null
    start_of_week_by_name: string | null
    start_of_week_reason: UnsubscribeReason | null
    start_of_week_comment: string | null
    wysiwyg: boolean
    wysiwyg_on: string | null
    wysiwyg_by_artkey: number | null
    wysiwyg_by_name: string | null
    wysiwyg_reason: UnsubscribeReason | null
    wysiwyg_comment: string | null
    arriving_soon: boolean
    arriving_soon_on: string | null
    arriving_soon_by_artkey: number | null
    arriving_soon_by_name: string | null
    arriving_soon_reason: UnsubscribeReason | null
    arriving_soon_comment: string | null
    pallet_deals: boolean
    pallet_deals_on: string | null
    pallet_deals_by_artkey: number | null
    pallet_deals_by_name: string | null
    pallet_deals_reason: UnsubscribeReason | null
    pallet_deals_comment: string | null
    new_in_stock: boolean
    new_in_stock_on: string | null
    new_in_stock_by_artkey: number | null
    new_in_stock_by_name: string | null
    new_in_stock_reason: UnsubscribeReason | null
    new_in_stock_comment: string | null
}

export interface DiscoUpdateCampaignSubscriptionRequest {
    is_unsubscribed: boolean
    reason?: UnsubscribeReason | null
    comment?: string | null
}

export interface DownloadAttachmentResponse {
    download_url: string
}

export interface DuplicateNamePlaceholder {
    placeholder: string
    packages: string[]
}

export interface EditSalesOrderTBOItemRequest {
    number_of_cases: number
    price_per_case: number | string
    purchase_order_item_artkey?: number | null
}

export enum EmailBatchContactsFilter {
    StartOfWeek = 'Start of week',
    WhatYouSeeIsWhatYouGet = 'What you see is what you get',
    ArrivingSoon = 'Arriving soon',
    PalletDeals = 'Pallet deals',
    NewInStock = 'New in stock',
    Recap = 'Recap',
    NewPrices = 'New prices',
}

export enum EmailBatchScheduleType {
    AsSoonAsPossible = 'As Soon as Possible',
    Scheduled = 'Scheduled',
    Monthly = 'Monthly',
    BiWeekly = 'Bi-Weekly',
    OnceAWeek = 'Once a Week',
    MondayTillFriday = 'Monday till Friday',
    Daily = 'Daily',
}

export enum EmailBatchStatus {
    Sent = 'Sent',
    Sending = 'Sending',
    Suspended = 'Suspended',
    Draft = 'Draft',
    Pending = 'Pending',
    Archived = 'Archived',
}

export enum EmailBatchType {
    EntirePriceList = 'Entire price list',
    SpecialOnly = 'Special only',
    CustomOffer = 'Custom offer',
    Nothing = 'Nothing',
    PurchaseEnquiry = 'Purchase enquiry',
}

export enum EmailBounceEventType {
    Bounce = 'bounce',
    DeliveryDelay = 'delivery delay',
    Complaint = 'complaint',
}

export enum EmailFixedPlaceholders {
    ARRIVING_SOON_TABLE = 'arriving_soon.table',
    CONTACT_FIRST_NAME = 'contact.first_name',
    CONTACT_FULL_NAME = 'contact.full_name',
    CONTACT_SALES_MANAGER = 'contact.sales_manager',
    CONTACT_SALES_MANAGER_PHOTO = 'contact.sales_manager.photo',
    CONTACT_SALES_MANAGER_USER_NAME = 'contact.sales_manager.user_name',
    CONTACT_SALES_MANAGER_TELEPHONE_NUMBER = 'contact.sales_manager_telephone_number',
    CONTACT_SALUTATION = 'contact.salutation',
    DISCOVER_URL = 'discover_url',
    NEW_IN_STOCK_TABLE = 'new_in_stock.table',
    OFFER_DOWNLOAD_BUTTON = 'offer.download_button',
    OFFER_DOWNLOAD_URL = 'offer.download_url',
    OFFER_OFFER_HASH = 'offer.offer_hash',
    OFFER_PORTAL_LINK = 'offer.portal_link',
    OFFER_TABLE = 'offer.table',
    ORDER_PORTAL_REFERENCE = 'order_portal_reference',
    PORTAL_URL = 'portal_url',
    PRICE_LIST_DOWNLOAD_BUTTON = 'price_list.download_button',
    PRICE_LIST_DOWNLOAD_URL = 'price_list.download_url',
    PRICE_LIST_UUID = 'price_list_uuid',
    SALUTATION_GENERAL = 'salutation.general',
    RELATION_MAILED_COLLEAGUES_TEXT = 'relation.mailed_colleagues_text',
    RELATION_INCOTERM = 'relation.incoterm',
    UTM_PARAMETERS = 'utm_parameters',
}

export enum EmailSentState {
    Failed = 'Failed',
    Pending = 'Pending',
    Created = 'Created',
    Sent = 'Sent',
}

export interface Endpoint {
    supported_methods: HTTPMethod[]
    endpoint: string
}

export enum EntityAlt {
    SOI = 'SOI',
    SOTI = 'SOTI',
    SOA = 'SOA',
    VOUCHER = 'VOUCHER',
    SOCI = 'SOCI',
    SOHI = 'SOHI',
    SOBI = 'SOBI',
    SPL = 'SPL',
    SPLI = 'SPLI',
    SPLSL = 'SPLSL',
    BT = 'BT',
    CS = 'CS',
    PROD_SUGGESTION = 'PROD_SUGGESTION',
    DG_SUGGESTION = 'DG_SUGGESTION',
    COI = 'COI',
    OI = 'OI',
}

export interface ErrorResponse {
    detail: string
}

export interface ExcelFormatting {
    alcohol: AlcoholFormatting
    volume: VolumeFormatting
}

export interface ExplorePricelistResponse {
    artkey: number
    availability_status: string | null
    bottle_alcohol_percentage: string
    bottle_artkey: number
    bottle_refill_status: RefillStatus
    bottle_volume: string
    case_gift_box_type: string | null
    case_number_of_bottles: number | null
    currency: Currency
    customs_status: string
    euro_price_per_case: string | null
    incoterm: string
    is_available: boolean | null
    number_of_cases: number | null
    price_per_case: string | null
    product_artkey: number
    product_category: string
    product_name: string
    supplier_client_status: string | null
    supplier_company_type: string | null
    supplier_name: string
    supplier_price_list_artkey: number
    supplier_price_list_end_date: string | null
    supplier_price_list_start_date: string | null
    supplier_price_list_supplier_price_list_description: string
}

export interface ExplorePricelistTotalsResponse {
    count: number
}

export enum ExploreSalesHistoryType {
    SOI = 'SOI',
    TBO = 'TBO',
}

export interface ExploreStockResponse {
    account_name: string
    account_slug: string
    artkey: number
    bottle_alcohol_percentage: string
    bottle_artkey: number
    bottle_refill_status: RefillStatus
    bottle_volume: string
    case_customs_status: string
    case_excise_nl: string
    case_gift_box_type: GiftBoxType | null
    case_number_of_bottles: number
    case_tax_label: string | null
    item_entry_date: string | null
    item_euro_total_stock_value: string
    item_euro_was_bought_for: string
    item_euro_was_bought_for_plus_costs: string
    item_is_target_in: number | null
    item_lot: string
    item_mutation_reference: string | null
    item_number_of_cases_available: number
    item_number_of_cases_in_purchase: number
    item_number_of_cases_in_sales: number
    item_number_of_cases_in_stock: number
    item_reference: string
    item_was_bought_for: string
    product_name: string
    purchase_order_artkey: number
    purchase_order_bought_against_rate: string
    expected_delivery_date: string | null
    purchase_order_item_artkey: number
    purchase_order_reference: string
    purchase_order_was_bought_in: string
    sales_order_credit_item_artkey: number | null
    supplier_name: string
    warehouse_name: string
}

export interface ExploreStockTotalsResponse {
    count: number
    in_stock: number
    in_purchase: number
    in_sales: number
    available: number
}

export interface ExportCBSRequest {
    month: number
    year: number
}

export interface ExportLeadsRequest {
    lead_artkeys: number[]
}

export interface ExportPortalPriceListRequest {
    offer_item_artkeys?: number[] | null
    search_terms?: string[]
    offer_hash?: string | null
    offer_item_type?: OfferItemFilterType | null
    category_artkeys?: number[]
    availabilities?: (AvailabilityType | TBODeliveryPeriod)[]
    volume?: number | null
    alcohol_percentage?: number | null
    packaging?: string[]
    gift_box_type?: GiftBoxType[]
    refill_status?: string | null
    brand_holder?: number | null
    brand?: number | null
    include_case_artkeys?: number[]
    exclude_case_artkeys?: number[]
    formatting?: ExcelFormatting | null
}

export interface FavouritesStatisticsResponse {
    total_favourites: number
    updated_favourites: number
}

export interface FileHolder {
    file_contents: string | null
    file_name: string | null
}

export enum FilterType {
    TOGGLE = 'TOGGLE',
    SELECT_SINGLE = 'SELECT_SINGLE',
    SELECT_MULTIPLE = 'SELECT_MULTIPLE',
    SELECT_RANGE = 'SELECT_RANGE',
    TEXT = 'TEXT',
    WORKFLOW = 'WORKFLOW',
}

export interface ForgotPasswordRequest {
    email_address: string
}

export interface FuelPriceSurchargeResponse {
    surcharge: string
    start_date: string
}

export interface GeneratePortalUserInviteResponse {
    invite_code: string
}

export interface GeneratedLabel {
    placeholder: string
    label?: string | null
}

export interface GetAccountResponse {
    slug: string
    domain: string
    informal_name: string
    name: string
    address: string
    zip_code: string
    city: string
    country_code: string
    telephone_number: string
    emailaddress: string
    iban_eur: string | null
    iban_usd: string | null
    iban_gbp: string | null
    chamber_of_commerce_number: string
    vat_id: string
}

export interface GetActivePromotionResponse {
    artkey: number
    start_date: string
    end_date: string
    grace_date: string
    name: string
    active: boolean
    turnover_draft?: number | null
    turnover_redeemable?: number | null
    gifts?: unknown[] | null
    max_items: number
    slogan?: string | null
    token_value: number
    token_icon: string
    type?: string | null
}

export interface GetActiveVoucherResponse {
    artkey: number
    code: string
    value: string
    voucher_value_type: VoucherValueType
}

export interface GetActiveVouchersResponse {
    artkey: number
    code: string
    value: string
    voucher_value_type: VoucherValueType
}

export interface GetAllAccountResponse {
    artkey: number
    slug: string
    name: string
    informal_name: string
    website_url: string
    domain: string
    emailaddress: string
    address: string
    zip_code: string
    city: string
    country_code: string
    iban_eur: string
    iban_usd: string | null
    iban_gbp: string | null
    telephone_number: string
    chamber_of_commerce_number: string
    vat_id: string
}

export interface GetAllCurrenciesResponse {
    artkey: number
    currency: Currency
    exchange_rate: string
    date: string
    portal_exchange_rate: string
}

export interface GetAllUsersResponse {
    artkey: number
    name: string
    email_address: string
}

export interface GetArticleCollectionViewResponse {
    artkey: string
    case_artkey: number | null
    bottle_artkey: number
    product_artkey: number
    article_code: string | null
    product_name: string
    default_country_code: string | null
    product_category_name: string
    alcohol_percentage: string
    volume: string
    refill_status: RefillStatus
    cbs_code: string | null
    bottle_gtins_as_joined_str: string | null
    best_before_date: string | null
    serialized_item_tags: string | null
    number_of_bottles: number | null
    gift_box_type: GiftBoxType | null
    tax_label: string | null
    customs_status: CustomsStatus | null
    cases_per_pallet: number | null
    cases_per_pallet_layer: number | null
    length: string | null
    height: string | null
    width: string | null
    weight: string | null
}

export interface GetArticleResponse {
    artkey: string
    article_code: string | null
    bottle_artkey: number
    case_artkey: number | null
    product_artkey: number
    product_name: string
    product_category_name: string
    product_category_artkey: number
    default_country_of_origin: string | null
    number_of_offer_items: number
    number_of_purchase_order_items: number
    number_of_available_stock_items: number
    number_of_item_tags: number
    number_of_splis: number
    number_of_bottles_for_product: number
    number_of_cases_for_bottle: number
    alcohol_percentage: string
    volume: string
    refill_status: RefillStatus
    cbs_code: string | null
    cbs_code_description: string | null
    bottle_gtins_as_joined_str: string | null
    best_before_date: string | null
    serialized_item_tags: string | null
    number_of_bottles: number | null
    gift_box_type: GiftBoxType | null
    tax_label: string | null
    customs_status: CustomsStatus | null
    cases_per_pallet: number | null
    cases_per_pallet_layer: number | null
    length: string | null
    height: string | null
    width: string | null
    weight: string | null
}

export interface GetAttachmentCategoryResponse {
    artkey: number
    name: string
    loendersloot_document_types: string | null
    attachment_type: AttachmentType
}

export interface GetAttachmentCollectionViewResponse {
    artkey: number
    category: string | null
    description: string | null
    created_on: string
    file_name: string
    file_size: number
    mime_type: string
    expires_on: string | null
    valid_until: string | null
    created_by: string
    created_by_user_artkey: number
}

export interface GetAvailablePurchaseOrderItemsResponse {
    artkey: number
    po_reference: string
    number_of_cases_available: number
    supplier_name: string
}

export interface GetBottleCasesResponse {
    artkey: number
    number_of_bottles: number
    tax_label: string | null
    gift_box_type: GiftBoxType | null
    customs_status: CustomsStatus
    best_before_date: string | null
    cases_per_pallet: number | null
    cases_per_pallet_layer: number | null
    created_on: string
    was_last_updated_on: string
}

export interface GetBrandHolderResponse {
    artkey: number
    name: string
    full_name: string | null
    requires_import_statement: boolean | null
}

export interface GetBuyFromAccountPurchaseOrderResponse {
    artkey: number
    reference: string
    status: PurchaseOrderStatus
    has_supplier_invoice: boolean
    account_artkey: number
    account_slug: string
    account_name: string
}

export interface GetBuyFromAccountSalesOrderResponse {
    artkey: number
    reference: string
    sales_order_status: SalesOrderStatus
    account_artkey: number
    account_slug: string
    account_name: string
}

export interface GetCBSCodeResponse {
    cbs_code: string
    description: string
}

export interface GetCampaignCollectionViewResponse {
    artkey: number
    contacts_filter: EmailBatchContactsFilter | null
    created_by_name: string
    created_by_artkey: number
    created_on: string
    cron_expression: string
    dispatched_on: string | null
    email_batch_type: EmailBatchType
    is_completed: boolean
    is_deleted: boolean
    is_suspended_by_artkey: number | null
    is_pending: boolean
    name: string
    next_run: string | null
    number_of_mails: number
    number_of_unsent_mails: number
    schedule_type: EmailBatchScheduleType
    status: EmailBatchStatus
    subject: string
    use_timezone: boolean
    offer_title: string | null
}

export interface GetCampaignEmailResponse {
    artkey: number
    subject: string
    body?: string | null
    number_of_attachments: number
    attachment_file_names: string[]
}

export interface GetCampaignPlaceholdersResponse {
    artkey: number
    placeholder: string
    description: string
    created_by_user_artkey: number
    created_by_user_name: string
    is_system_placeholder: boolean
    package: string
    source_variants?: PlaceholderSourceVariantResponse[]
    was_last_updated_on: string
    used_in_pending_batches?: number | null
    campaigns?: CampaignRef[]
}

export interface GetCampaignRecipientsCollectionViewResponse {
    artkey: number
    relation_name: string
    relation_artkey: number
    contact_person_name: string
    email_address: string
    timezone: string
    language: SupportedLanguage
}

export interface GetCampaignResponse {
    artkey: number
    body: string
    contacts_filter: EmailBatchContactsFilter | null
    created_by_artkey: number
    created_by_name: string
    created_on: string
    cron_expression: string | null
    dispatched_on: string | null
    email_batch_type: EmailBatchType
    is_pending: boolean
    is_deleted: boolean
    is_suspended_by_artkey: number | null
    offer_artkey: number | null
    name: string
    number_of_mails: number
    number_of_unsent_mails: number
    next_run: string | null
    schedule_type: EmailBatchScheduleType
    status: EmailBatchStatus
    subject: string
    use_sent_from_user_artkey: number | null
    use_sent_from_user_name: string | null
    use_timezone: boolean
}

export interface GetCandidatesCollectionResponse {
    artkey: number
    candidate: (string | null)[]
}

export interface GetCmsPlaceholdersResponse {
    artkey: number
    placeholder: string
    description: string
    created_by_user_artkey: number
    created_by_user_name: string
    is_system_placeholder: boolean
    package: string
    source_variants?: PlaceholderSourceVariantResponse[]
    was_last_updated_on: string
    used_in_pending_batches?: number | null
    campaigns?: CampaignRef[]
    cms_pages?: CmsPageRef[]
    cms_fragments?: CmsFragmentRef[]
    used_in_jsx?: boolean | null
}

export interface GetContactPersonForRelationResponse {
    artkey: number
    name: string
    emailaddress: string
}

export interface GetCountryOfOriginAvailabilitiesResponse {
    case_artkey: number
    availabilities: Availability[]
}

export interface GetEmailBounceCollectionViewResponse {
    artkey: number
    last_event_on: string
    number_of_events: number
    email_address: string
    contact_person_artkey: number | null
    contact_person_name: string | null
    relation_artkey: number | null
    relation_name: string | null
    event_type: EmailBounceEventType
    event_summary: string
}

export interface GetEmailCollectionViewResponse {
    artkey: number
    to_relation_name?: string | null
    dispatch_on: string | null
    sent_on: string | null
    subject: string
    from_address?: string
    to_addresses?: string[]
    cc_addresses?: string[]
    bcc_addresses?: string[]
    sent_state: EmailSentState
    downloaded_price_list_count: number
    number_of_attachments: number
    attachment_file_names: string[]
}

export interface GetEmailPreviewRequest {
    body: string
    relation_artkey: number
    batch_type: EmailBatchType
    from_email_address_artkey?: number | null
    offer_artkey?: number | null
    contacts_filter?: EmailBatchContactsFilter | null
    contact_person_artkey?: number | null
}

export interface GetEmailPreviewResponse {
    body: string | null
    country_language: string
}

export interface GetExactAuthenticationStatusResponse {
    authentication_present: boolean
    expires_at: string | null
    token_needs_refresh: boolean
}

export interface GetExactAuthenticationUrlResponse {
    url: string
}

export interface GetExactSalesOrderCollectionViewResponse {
    artkey: number
    reference: string
    relation_name: string
    relation_artkey: number
    sales_order_status: SalesOrderStatus
    is_invoiced_on: string
    created_on: string
    was_sold_for: string
    was_sold_in: string
}

export interface GetFilterStatisticsRequest {
    offer_item_artkeys?: number[] | null
    search_terms?: string[]
    offer_hash?: string | null
    offer_item_type?: OfferItemFilterType | null
    category_artkeys?: number[]
    availabilities?: (AvailabilityType | TBODeliveryPeriod)[]
    volume?: number | null
    alcohol_percentage?: number | null
    packaging?: string[]
    gift_box_type?: GiftBoxType[]
    refill_status?: string | null
    brand_holder?: number | null
    brand?: number | null
}

export interface GetHiddenInformationResponse {
    hidden_country_codes: string[]
    hidden_relations: HiddenRelation[]
    implicit_hidden_information?: ImplicitHiddenInformation | null
}

export interface GetHiddenItemsResponse {
    artkey: number
    hidden_by_rule: RelationPriceListHiddenRule
    product_name: string
    product_category_name: string
    brand_name?: string | null
    brand_holder_name?: string | null
    case_article_code: string
    case_artkey: number
    case_customs_status: string
    case_number_of_bottles: number
    bottle_artkey: number
    bottle_gtins?: string | null
    bottle_volume: string
    bottle_alcohol_percentage: string
    bottle_refill_status: RefillStatus
}

export interface GetIncotermsResponse {
    code: string
    description: string
    transport_costs: boolean
}

export interface GetInsuranceTypeResponse {
    artkey: number
    name: string
    fee: string
}

export interface GetItemCollectionViewResponse {
    artkey: number
    reference: string
    entry_date: string | null
    lot: string
    remark: string | null
    bottle_gtin_code: string | null
    case_gtin_code: string | null
    country_of_origin: string | null
    number_of_cases_in_sales: number
    number_of_cases_in_purchase: number
    number_of_shipped_cases: number
    number_of_cases_available: number
    number_of_cases_in_stock: number
    stock_age: number | null
    euro_total_stock_value: string
    euro_was_bought_for: string
    number_of_product_photos: number
    cases_per_pallet_layer: number | null
    cases_per_pallet: number | null
    case_length: string | null
    case_height: string | null
    case_width: string | null
    case_weight: string | null
    warehouse_name: string | null
    warehouse_artkey: number | null
    account_slug: string
    account_artkey: number
    account_name: string
    price_per_case: string | null
    excise_nl_per_case: string | null
    item_mutation_reference: string | null
    product_name: string
    product_category_name: string
    case_artkey: number
    best_before_date: string | null
    article_code: string
    serialized_item_tags: string
    number_of_bottles: number
    gift_box_type: GiftBoxType | null
    tax_label: string | null
    customs_status: CustomsStatus
    bottle_artkey: number
    cbs_code: string | null
    alcohol_percentage: string
    volume: string
    refill_status: RefillStatus
    purchase_order_reference: string
    purchase_order_artkey: number
    supplier_artkey: number
    expected_delivery_date: string | null
    purchase_order_item_artkey: number
    total_costs_per_case: string
}

export interface GetItemResponse {
    artkey: number
    entry_date: string | null
    lot: string | null
    reference: string
    number_of_cases_in_sales: number
    number_of_cases: number
    number_of_cases_in_purchase: number
    number_of_cases_in_stock: number
    country_of_origin: string | null
    remark?: string | null
    bottle_gtin_code?: string | null
    case_gtin_code?: string | null
    bottle_coding?: string | null
    bottle_lot?: string | null
    cases_per_pallet?: number | null
    cases_per_pallet_layer?: number | null
    warehouse?: ItemWarehouseResponse | null
    case: ItemCaseResponse
    account: ItemAccountResponse
    purchase_order_item: ItemPurchaseOrderItemResponse
}

export interface GetItemTagResponse {
    artkey: number
    name: string
    abbreviation: string
    is_portal_filter: boolean
    category_artkey: ItemTagCategoryArtkey
    category_name: string
}

export interface GetLocationResponse {
    artkey: number
    name: string
    destination_type: LocationType
    can_handle_our_stock: boolean
    is_third_party_warehouse: boolean
    memo: string | null
    street_address: string
    zip_code: string
    city: string
    country_code: string
    region_code?: string | null
    emailaddress?: string | null
    excise_id?: string | null
    vat_id?: string | null
    warehouse_id?: string | null
    warehouse_base_costs?: string | null
    warehouse_costs_per_case?: string | null
    currency?: Currency | null
}

export interface GetLocationsCollectionViewResult {
    artkey: number
    name: string
    location_type: LocationType
    street_address: string
    zip_code: string
    city: string
    country_code: string
    region_code: string | null
    emailaddress: string | null
    is_third_party_warehouse: boolean
}

export interface GetLoenderslootMessage {
    artkey: number
    status: LoenderslootMessageStatus
    message_type: string
    created_on: string
    raw_xml: string
}

export interface GetLoenderslootStockReconResponse {
    artkey: number
    account_slug: string
    account_name: string
    file_name: string
    created_on: string
    total_items: number
    total_items_found_in_discover: number
    total_items_not_found_in_discover: number
    total_items_found_in_loendersloot: number
    total_items_not_found_in_loendersloot: number
}

export interface GetLoenderslootStockReconResultResponse {
    artkey: number
    lot?: string | null
    item_artkey?: number | null
    item_reference?: string | null
    number_of_cases?: number | null
    number_of_shipped_cases?: number | null
    number_of_cases_in_sales?: number | null
    purchase_order_reference?: string | null
    case_artkey?: number | null
    bottle_artkey?: number | null
    bottle_specs?: string | null
    product_name?: string | null
    result: StockReconciliationResult
    result_text: string
    line: string
}

export interface GetLoenderslootTagResponse {
    artkey: number
    code: string
    description: string
    unapprove_when_added: boolean
    show_as_feature: boolean
    forbid_in_stock: boolean
    is_gift_box: boolean
    item_tag_artkey: number
    gift_box_type: GiftBoxType | null
}

export interface GetLotAvailabilityResponse {
    artkey: number
    lot: string | null
    number_of_cases_available: number
    country_of_origin: string | null
    euro_was_bought_for: string
}

export interface GetMergeArticleResponse {
    source_artkeys: string[]
    proposal_artkey: string
}

export interface GetOTPSecretRequest {
    pre_auth_token: string
}

export interface GetOTPSecretResponse {
    otp_secret: string
    otp_secret_url: string
}

export interface GetOfferItemCompareWithMarketResponse {
    artkey: number
    price_per_case: string
    old_price_per_case: string
    is_hidden: boolean
    delivery_period_in_weeks: number | null
    maximum_order_quantity: number | null
    minimum_order_quantity: number | null
    price_age_in_days: number | null
    product_name: string
    case_artkey: number
    number_of_bottles: number
    gift_box_type: GiftBoxType | null
    customs_status: string
    tax_label: string | null
    article_code: string
    case_serialized_item_tags?: string | null
    best_before_date: string | null
    item_remark: string | null
    item_number_of_cases: number
    item_number_of_cases_in_stock: number
    item_number_of_cases_in_sales: number
    item_number_of_cases_in_purchase: number
    item_number_of_cases_available: number
    item_stock_age: number
    avg_purchase_price: string
    bottle_artkey: number
    volume: string
    alcohol_percentage: string
    refill_status: RefillStatus
    bulk_price: string | null
    bulk_offer_title: string | null
    bulk_offer_artkey: number | null
    competitor_price_list_artkey: number | null
    lowest_competitor_price_per_case: string | null
    competitor_artkey: number | null
    competitor_name: string | null
    competitor_delta: string | null
}

export interface GetOfferItemMarginsResponse {
    artkey: number
    avg_euro_was_bought_for: string | null
    avg_margin_percentage: string | null
}

export interface GetOfferItemRanksResponse {
    artkey: number
    market_rank: number
    market_total: number
    avg_competitor_diff: string | null
    avg_competitor_diff_percentage: string | null
}

export interface GetOfferItemResponse {
    artkey: number
    offer_item_type: OfferItemType
    is_hidden: boolean
    is_active: boolean
    needs_approval: boolean
    is_approved: boolean
    delivery_period: number | null
    minimum_quantity: number | null
    maximum_quantity: number | null
    step_size_quantity: number | null
    price_per_case: string
}

export interface GetOfferItemsCollectionViewResponse {
    artkey: number
    is_hidden: boolean
    is_active: boolean
    offer_item_type: OfferItemType
    minimum_quantity: number | null
    step_size_quantity?: number | null
    maximum_quantity: number | null
    delivery_period: number | null
    has_product_photos: boolean
    price_per_case: string
    spot_price_per_case: string | null
    spotlight_rank: number | null
    previous_price_per_case: string | null
    price_up: boolean
    price_down: boolean
    price_age_in_days: number
    market_rank: number | null
    market_total: number | null
    avg_competitor_diff: string | null
    avg_competitor_diff_percentage: string | null
    number_of_bottles: number
    article_code: string
    gift_box_type: GiftBoxType | null
    tax_label: string | null
    best_before_date: string | null
    customs_status: CustomsStatus
    case_quantity_sold_last_month: number
    case_quantity_sold_last_quarter: number
    case_quantity_sold_last_year: number
    case_quantity_bought_last_month: number
    case_quantity_bought_last_quarter: number
    case_quantity_bought_last_year: number
    case_excise_nl: string
    case_serialized_item_tags?: string | null
    bottle_artkey: number
    alcohol_percentage: string
    volume: string
    refill_status: RefillStatus
    product_category_name: string
    product_category_artkey: number
    product_name: string
    product_artkey: number
    number_of_cases_in_stock: number
    number_of_cases_available: number
    number_of_cases_in_sales: number
    number_of_cases_in_purchase: number
    max_stock_age: number
    min_stock_age: number
    avg_euro_was_bought_for: string | null
    avg_margin_percentage: string | null
    supplier_name: string | null
}

export interface GetOfferResponse {
    artkey: number
    hash?: string | null
    title: string
    remark: string
    start_date: string
    end_date: string | null
    incoterm: string | null
    incoterm_location: string | null
    offer_type: string
    offer_image_s3_key: string | null
    offer_portal_popup_title: string | null
    offer_portal_popup_text: string | null
    offer_portal_popup_image_s3_key: string | null
}

export interface GetOrderCollectionViewResponse {
    artkey: number
    reference: string
    account_slug: string
    portal_status: string
    created_on: string
    created_by: string | null
    number_of_bottles: number
    number_of_cases: number
    total_value: string
    currency: Currency
    is_invoiced_on: string | null
    invoice_number: number | null
}

export interface GetPlaceholdersResponse {
    artkey: number
    placeholder: string
    description: string
    created_by_user_artkey: number
    created_by_user_name: string
    is_system_placeholder: boolean
    package: string
    source_variants?: PlaceholderSourceVariantResponse[]
    was_last_updated_on: string
}

export interface GetPortalOfferItemResponse {
    artkey: number
    custom_offer_item_artkey?: number | null
    product_name: string
    product_category: string
    offer_item_type: AvailabilityType
    offer_type: OfferType
    favourite_artkey?: number | null
    validity_date?: string | null
    vat_percentage?: string | null
    delivery_period?: number | null
    minimum_quantity?: number | null
    step_size_quantity: number | null
    entry_date: string
    expected_entry_date_in_weeks: number | null
    list_quantity: number | null
    excise_per_case?: string | null
    list_price: string
    original_price_per_case: string
    bottle_gtin_code: string[]
    bottle_artkey: number
    bottle_volume: string
    bottle_alcohol_percentage: string
    bottle_refill_status: RefillStatus
    case_artkey: number
    case_article_code: string
    case_gift_box_type?: GiftBoxType | null
    case_number_of_bottles: number
    case_tax_label?: string | null
    item_best_before_date?: string | null
    case_customs_status: string
    item_damages?: string | null
    item_general_tags?: string | null
    item_pack_size?: string | null
    item_packaging?: string | null
    cases_per_pallet?: number | null
    cases_per_pallet_layer?: number | null
    case_weight?: string | null
    currency: Currency
}

export interface GetPortalOfferItemsRequest {
    offer_item_artkeys?: number[] | null
    search_terms?: string[]
    offer_hash?: string | null
    offer_item_type?: OfferItemFilterType | null
    category_artkeys?: number[]
    availabilities?: (AvailabilityType | TBODeliveryPeriod)[]
    volume?: number | null
    alcohol_percentage?: number | null
    packaging?: string[]
    gift_box_type?: GiftBoxType[]
    refill_status?: string | null
    brand_holder?: number | null
    brand?: number | null
    limit: number
    offset: number
    sort_by: string
    sort_ascending: boolean
}

export interface GetPortalOfferItemsResponse {
    total: number
    portal_offer_items: GetPortalOfferItemResponse[]
}

export interface GetPortalOrderItemResponse {
    sales_order_artkey: number
    number_of_cases: number
    price_per_case: string
    case_artkey: number
    case_number_of_bottles: number
    article_code: string
    gift_box_type: GiftBoxType | null
    tax_label: string | null
    best_before_date: string | null
    customs_status: CustomsStatus
    bottle_artkey: number
    alcohol_percentage: string
    refill_status: RefillStatus
    volume: string
    product_category_artkey: number
    product_category_name: string
    product_artkey: number
    product_name: string
}

export interface GetPortalProfileResponse {
    artkey: number
    username: string
    email_address: string
    language: string
    first_name: string | null
    last_name: string | null
    name: string
    phone_number: string | null
    mobile_phone_number: string | null
    timezone: string
    tawk_hash: string
    country_code: string
    currency: Currency
    minimum_order_amount: string | null
    price_preference: PricePreference
    include_excise_in_price: boolean
    show_excise: boolean
    company_type: string
    relation_name: string
    customs_visibility: string | null
    decimal_locale: string
    has_api_access: boolean
    sales_manager: GetPortalProfileSalesManager
}

export interface GetPortalProfileSalesManager {
    artkey: number
    name: string
    email_address: string
    mobile_telephone_number: string | null
    phone_number: string
}

export interface GetPortalUserDownloadHistoryResponse {
    artkey: number
    created_on: string
}

export interface GetPortalUserResponse {
    artkey: number
    name: string
    created_on: string
    is_deleted: boolean
    is_otp_validated: boolean
    requires_otp: boolean
    email_address: string
    first_name: string
    family_name: string | null
    language: SupportedLanguage
}

export interface GetPriceListCollectionViewResponse {
    artkey: number
    product_name: string
    product_category_name: string
    case_artkey: number
    case_customs_status: string
    case_article_code: string
    case_number_of_bottles: number
    case_serialized_item_tags?: string | null
    case_gift_box_type?: string | null
    case_best_before_date?: string | null
    case_tax_label?: string | null
    cases_per_pallet?: number | null
    remark?: string | null
    number_of_cases_in_stock: number
    number_of_cases_in_purchase: number
    number_of_cases_in_sales: number
    number_of_cases_available: number
    lots?: string | null
    bottle_artkey: number
    bottle_gtins?: string | null
    bottle_volume: string
    bottle_alcohol_percentage: string
    bottle_refill_status: RefillStatus
    relation_artkey: number
    euro_total_stock_value: string
    stock_age: number
    has_product_photos: boolean
    minimum_quantity?: number | null
    list_quantity: number | null
    delivery_period?: number | null
    list_price: string
    excise_per_case?: string | null
    includes_excise_in_price: boolean
    currency: Currency
    original_price_per_case: string
    offer_type: OfferType
    avg_was_bought_for?: string | null
}

export interface GetPriceListResponse {
    article_code: string
    gtins: string | null
    bottles_per_case: number
    bottle_volume_cl: string
    bottle_refill_status: RefillStatus
    alcohol_percentage: string
    product_name: string
    product_category_name: string
    gift_box: GiftBoxType | null
    customs_status: CustomsStatus
    best_before_date: string | null
    list_price_per_case: string
    list_price_currency: string
    list_quantity_in_cases: number | null
    offer_type: OfferItemType
    delivery_period_in_weeks: number | null
    minimum_order_quantity_in_cases: number | null
    incoterm: string
    incoterm_location: string
}

export interface GetProductCategoriesResponse {
    categories: Category[]
}

export interface GetProductCategoryCollectionResponse {
    artkey: number
    name: string
    be_vat_rate_percentage: string
    nl_vat_rate_percentage: string
    de_vat_rate_percentage: string
    is_spirit: boolean
    default_product_bottle_type: ProductBottleType
    parent_product_category_name: string | null
    product_group_name: string
}

export interface GetProductCategoryResponse {
    artkey: number
    name: string
    alternative_names?: string[]
    be_vat_rate_artkey: number
    nl_vat_rate_artkey: number
    de_vat_rate_artkey: number
    is_spirit: boolean
    default_product_bottle_type: ProductBottleType
    parent_artkey: number | null
    product_group_artkey: number
    priority?: number | null
}

export interface GetProductCategorySelectResponse {
    artkey: number
    name: string
}

export interface GetProductGroupResponse {
    artkey: number
    name: string
    description: string | null
}

export interface GetProductGroupsResponse {
    artkey: number
    name: string
}

export interface GetProductPhotoResponse {
    artkey: number
    file_name: string
    thumbnail_file_name?: string | null
    original_location: string
    portal_optimized_photos: boolean
    created_on: string
    created_by_name?: string | null
    was_last_updated_on: string
    was_last_updated_by_name?: string | null
    is_internal: boolean
    rank: number
    upload_timestamp: string
    verified_by_name?: string | null
}

export interface GetProductsResponse {
    artkey: number
    bottles: ProductBottle[]
    name: string
    default_country_code: string | null
    product_category: Fact2ServerApiDiscoverProductProductGetProductsResponseProductCategory
}

export interface GetPurchaseOrderCostResponse {
    additional_costs: string
    calculation_details: CalculationDetails
    total_costs: string
    total_costs_per_case: string
    transport_costs: string
    diesel_surcharge_amount: string
    pallet_costs: string
    other_costs: string
    waste_fund_costs: string | null
    warehouse_base_costs: string | null
    handover_costs: string | null
    spirits_costs: string | null
    non_spirits_costs: string | null
    inspection_costs: string | null
    duty_drawback: string | null
}

export interface GetPurchaseOrderForSOTIResult {
    soti_artkey: number
    purchase_order_artkey: number
    purchase_order_reference: string
    purchase_order_item_artkey: number
    number_of_cases: number
    supplier_name: string
    supplier_artkey: number
}

export interface GetPurchaseOrderForSPLIResult {
    spli_artkey: number
    purchase_order_artkey: number
    purchase_order_item_artkey: number
    purchase_order_reference: string
    purchase_order_status: PurchaseOrderStatus
    is_invoiced_on: string | null
    supplier_name: string
    supplier_artkey: number
    number_of_cases: number
}

export interface GetPurchaseOrderForSPLResult {
    spl_artkey: number
    spli_artkey: number
    purchase_order_artkey: number
    purchase_order_item_artkey: number
    purchase_order_reference: string
    purchase_order_status: PurchaseOrderStatus
    is_invoiced_on: string | null
    supplier_name: string
    supplier_artkey: number
    number_of_cases: number
}

export interface GetPurchaseOrderItemBottle {
    artkey: number
    product: GetPurchaseOrderItemProduct
    volume: string
    alcohol_percentage: string
    refill_status: RefillStatus
    cbs_code: string | null
}

export interface GetPurchaseOrderItemCase {
    artkey: number
    bottle: GetPurchaseOrderItemBottle
    number_of_bottles: number
    gift_box_type: GiftBoxType | null
    best_before_date: string | null
    tax_label: string | null
    customs_status: CustomsStatus
}

export interface GetPurchaseOrderItemForItemResult {
    item_artkey: number
    purchase_order_artkey: number
    purchase_order_reference: string
    purchase_order_item_artkey: number
    number_of_cases: number
    supplier_name: string
    supplier_artkey: number
}

export interface GetPurchaseOrderItemProduct {
    artkey: number
    name: string
}

export interface GetPurchaseOrderItemRefersToSpli {
    artkey: number
    price_per_case: string
}

export interface GetPurchaseOrderItemResponse {
    artkey: number
    number_of_cases: number
    was_bought_for: string
    show_bid_price_on_rfp: boolean
    show_as_new_on_rfp: boolean
    is_in_stock_loendersloot: boolean
    cases_per_pallet?: number | null
    cases_per_pallet_layer?: number | null
    country_of_origin?: string | null
    suggested_price_per_case?: string | null
    remark?: string | null
    case: GetPurchaseOrderItemCase
    refers_to: GetPurchaseOrderItemRefersToSpli | null
}

export interface GetPurchaseOrderItemsCollectionViewResponse {
    artkey: number
    remark?: string | null
    number_of_cases: number
    country_of_origin?: string | null
    bottle_gtin_code?: string | null
    case_gtin_code?: string | null
    number_of_cases_in_tbo: number
    number_of_cases_in_soi: number
    lots: string[]
    hidden_in_country_codes: string[]
    hidden_for_supplier_artkeys: number[]
    same_bottle_as_origin?: boolean | null
    purchase_order_artkey: number
    purchase_order_status: PurchaseOrderStatus
    was_bought_in: string
    euro_was_bought_for_plus_costs: string
    bought_against_rate: string
    supplier_artkey: number
    spli_price_per_case?: string | null
    spli_artkey?: number | null
    spli_hs_code?: string | null
    spli_suppliers_item_code?: string | null
    spli_case_gross_weight_in_kg?: string | null
    spli_aux_info?: string | null
    spl_artkey?: number | null
    was_bought_for: string
    was_bought_for_plus_costs: string
    total_price: string
    suggested_price_per_case?: string | null
    product_name: string
    requires_import_statement: boolean
    category_name: string
    case_artkey: number
    article_code: string
    number_of_bottles: number
    customs_status: string
    weight?: string | null
    dimensions?: string | null
    best_before_date?: string | null
    serialized_item_tags?: string | null
    tax_label?: string | null
    cases_per_pallet?: number | null
    cases_per_pallet_layer?: number | null
    bottle_artkey: number
    volume: string
    alcohol_percentage: string
    gift_box_type?: GiftBoxType | null
    refill_status: RefillStatus
    cbs_code: string | null
}

export interface GetPurchaseOrderResponse {
    artkey: number
    reference: string
    status: PurchaseOrderStatus
    remark: string | null
    supplier_reference: string | null
    incoterm: string
    incoterm_location: string
    created_on: string
    intake_date: string | null
    confirmation_date: string | null
    is_communicated_on: string | null
    was_sent_to_financial_information_system_on: string | null
    was_bought_in: string
    bought_against_rate: string
    was_bought_for: string
    number_of_euro_pallets: number | null
    number_of_block_pallets: number | null
    warehouse_instruction: string | null
    freight_instruction: string | null
    frontoffice_instruction: string | null
    requires_import_statement: boolean
    has_import_statement: boolean
    has_supplier_invoice: boolean
    rfp_comment: string | null
    import_statement_override: boolean
    override_reason: string | null
    sent_to_loendersloot_on: string | null
    last_warehouse_message: string | null
    planned_unloading_date: string | null
    expected_delivery_date: string | null
    warehouse_reference: string | null
    warehouse_status: string | null
    number_of_order_lines: number
    number_of_cases: number
    number_of_attachments: number
    number_of_edi_messages: number
    was_handled_by: WasHandledByUser
    supplier: Fact2ServerApiDiscoverPurchaseOrderGetGetPurchaseOrderResponseSupplier
    delivery: Delivery | null
    insurance_type: InsuranceType
    account: Fact2ServerApiDiscoverPurchaseOrderGetGetPurchaseOrderResponseAccount
    target_warehouse: Warehouse
    origin_warehouse: Warehouse | null
    is_part_of_buy_from_account_sales_order: BuyFromAccountSalesOrder | null
}

export interface GetPurchaseOrdersCollectionViewResponse {
    artkey: number
    reference: string
    warehouse_reference?: string | null
    supplier_reference?: string | null
    expected_delivery_date?: string | null
    created_on: string
    was_last_updated_on: string
    is_communicated_on?: string | null
    was_sent_to_financial_information_system_on?: string | null
    has_attachments: boolean
    remark?: string | null
    incoterm: string
    incoterm_location: string
    status: PurchaseOrderStatus
    warehouse_status?: string | null
    supplier_artkey: number
    supplier_name: string
    supplier_country_code: string
    target_warehouse_name: string
    target_warehouse_artkey: number
    purchase_manager_artkey: number
    purchase_manager_name: string
    number_of_cases: number
    was_bought_for: string
    was_bought_in: string
}

export interface GetRelatedSalesOrderItemResponse {
    created_on: string
    sales_order_artkey: number
    sales_order_reference: string
    number_of_cases: number
    case_artkey: number
    number_of_bottles: number
    sales_order_account_artkey: number
    sales_order_account_name: string
    sales_order_account_slug: string
    relation_name: string
    sales_manager_name: string
}

export interface GetRelatedSalesOrderTBOItemResponse {
    created_on: string
    sales_order_artkey: number
    sales_order_reference: string
    number_of_cases: number
    case_artkey: number
    number_of_bottles: number
    sales_order_account_artkey: number
    sales_order_account_name: string
    sales_order_account_slug: string
    relation_name: string
    sales_manager_name: string
    tbo_artkey: number
}

export interface GetRelationListPriceResponse {
    case_artkey: number
    list_price: string
    currency: Currency
    list_quantity: number | null
    excise_per_case: string
    in_unconfirmed_sales_orders: string | null
}

export interface GetRelationLocationResponse {
    artkey: number
    name: string
    destination_type: LocationType
    can_handle_our_stock: boolean
    is_third_party_warehouse: boolean
    memo: string | null
    street_address: string
    zip_code: string
    city: string
    country_code: string
    region_code?: string | null
    emailaddress?: string | null
    excise_id?: string | null
    vat_id?: string | null
    warehouse_id?: string | null
    warehouse_base_costs?: string | null
    warehouse_costs_per_case?: string | null
    currency?: Currency | null
    is_relations_warehouse: boolean
    is_primary: boolean
}

export interface GetRelationLogBookEntryResponse {
    artkey: number
    message: string
    log_type: RelationLogType
    was_last_updated_on: string
    created_on: string
    created_by_artkey: number
    profile_name: string
}

export interface GetRelationPurchaseOrderResponse {
    artkey: number
    reference: string
    was_bought_in: string
    is_communicated_on: string | null
    created_on: string
    purchase_order_status: PurchaseOrderStatus
    incoterm_location: string
    number_of_cases: number
    was_bought_for: string
}

export interface GetRelationPurchaseOrdersResponse {
    artkey: number
    reference: string
}

export interface GetRelationResponse {
    street_address: string
    zip_code: string
    city: string
    country_code: string
    region_code?: string | null
    artkey: number
    name: string
    is_verified: boolean
    incoterm: string | null
    include_excise_in_price?: boolean
    price_markup_percentage: string | null
    transport_costs_per_case: string | null
    transport_costs_per_bottle: string | null
    currency: Currency
    is_buyer: boolean
    is_supplier: boolean
    relation_price_list_generated_on: string | null
}

export interface GetRelationsResponse {
    artkey: number
    name: string
    city: string
    country_code: string
    currency: Currency
    include_excise_in_price?: boolean
    is_verified: boolean
}

export interface GetReviewableProductPhotoResponse {
    artkey: number
    lot: string
    reference: string
    product_photos: ReviewableProductPhoto[]
    purchase_order_item: ReviewablePurchaseOrderItem
}

export interface GetSPLAuditLogResponse {
    artkey: number
    type: SPLAuditLogType
    message: string
    spli_artkey: number | null
    sl_artkey: number | null
}

export interface GetSalesOrderAdditionalResponse {
    sales_order_artkey: number
    description: string
    quantity: number
    sales_order_additional_type: SalesOrderAdditionalType
    value_type: SalesOrderAdditionalValueType
    value_per_quantity: string
    vat_percentage: string | null
}

export interface GetSalesOrderCreditItemResponse {
    sales_order_artkey: number
    sales_order_item_artkey: number
    number_of_cases: number
    price_per_case: string
    number_of_cases_available: number
    from_item_artkey: number
    from_lot: string | null
    to_item_artkey: number | null
    to_lot: string | null
    case_artkey: number
    case_number_of_bottles: number
    article_code: string
    gift_box_type: GiftBoxType | null
    tax_label: string | null
    best_before_date: string | null
    customs_status: CustomsStatus
    bottle_artkey: number
    alcohol_percentage: string
    refill_status: RefillStatus
    volume: string
    product_category_artkey: number
    product_category_name: string
    product_artkey: number
    product_name: string
}

export interface GetSalesOrderFiguresResponse {
    saved_sales_orders: number
    pending_portal_orders: number
    confirmed_sales_orders: number
    in_progress_sales_orders: number
    invoiced_sales_orders: number
    old_orders: number
    saved_total: string
    pending_total: string
    confirmed_total: string
    in_progress_total: string
    old_total: string
    total_value: string
    average_order_age: number
}

export interface GetSalesOrderItemResponse {
    sales_order_artkey: number
    number_of_cases: number
    country_of_origin: string | null
    euro_was_bought_for: string
    excise_per_case: string | null
    price_per_case: string
    item_artkey: number
    lot: string | null
    number_of_cases_available: number
    case_artkey: number
    case_number_of_bottles: number
    article_code: string
    gift_box_type: GiftBoxType | null
    tax_label: string | null
    best_before_date: string | null
    customs_status: CustomsStatus
    bottle_artkey: number
    alcohol_percentage: string
    refill_status: RefillStatus
    volume: string
    product_category_artkey: number
    product_category_name: string
    product_artkey: number
    product_name: string
}

export interface GetSalesOrderItemsCollectionViewResponse {
    product_category_name: string | null
    product_artkey: number | null
    product_name: string | null
    product_country_of_origin: string | null
    bottle_artkey: number | null
    cbs_code: string | null
    alcohol_percentage: string | null
    refill_status: RefillStatus | null
    volume: string | null
    case_artkey: number | null
    case_number_of_bottles: number | null
    article_code: string | null
    case_gift_box_type: GiftBoxType | null
    case_tax_label: string | null
    case_best_before_date: string | null
    case_customs_status: CustomsStatus | null
    case_item_tags: number[] | null
    case_serialized_item_tags: string | null
    case_weight: string | null
    case_length: string | null
    case_height: string | null
    case_width: string | null
    case_no_eu_address: boolean | null
    case_dimensions: string | null
    sales_order_item_type: SalesOrderItemType
    artkey: string
    created_on: string
    was_last_updated_on: string
    last_updated_by_user_name: string | null
    last_updated_by_portal_user_name: string | null
    number_of_cases: number
    price_per_case: string
    price_per_case_excl_excise: string
    excise_per_case: string | null
    description: string | null
    portal_comment: string | null
    created_from_portal_timestamp: string | null
    was_first_sold_for: string | null
    account_slug: string | null
    account_name: string | null
    bottle_gtin_code: string | null
    cases_per_pallet: number | null
    cases_per_pallet_layer: number | null
    item_remark: string | null
    item_lot: string | null
    item_artkey: number | null
    item_euro_was_bought_for_plus_costs: string | null
    item_euro_was_bought_for: string | null
    item_country_of_origin: string | null
    purchase_order_reference: string | null
    purchase_order_account_slug: string | null
    purchase_order_account_name: string | null
    loendersloot_outtake_item_lot: string | null
    loendersloot_outtake_item_quantity: number | null
    loendersloot_outtake_item_article_lo: string | null
    loendersloot_outtake_item_description: string | null
    tbo_item_status: SalesOrderTBOItemStatus | null
    have_case_in_stock: boolean | null
    enough_cases_in_stock: boolean | null
    enough_cases_in_purchase: boolean | null
    confirmed_for_purchase_date: string | null
    purchase_order_date: string | null
    purchase_order_eta: string | null
    credit_number_of_cases: number | null
    credit_vat_total: string | null
    original_sales_order_artkey: number | null
    original_sales_order_reference: string | null
    original_sales_order_was_sold_in: string | null
    original_sales_order_sold_against_rate: string | null
    credit_target_item_artkey: number | null
    credit_target_item_country_of_origin: string | null
    credit_target_item_lot: string | null
    credit_target_item_bottle_gtin_code: string | null
    additional_value_type: string | null
}

export interface GetSalesOrderResponse {
    artkey: number
    reference: string
    created_on: string
    was_sold_in: Currency
    sold_against_rate: string
    incoterm: string
    incoterm_location: string
    incoterm_and_location: string
    is_invoiced_on: string | null
    invoice_number: number | null
    was_sent_to_financial_information_system_on: string | null
    remark: string | null
    requested_delivery_date: string | null
    escrow_loendersloot: boolean
    includes_excise: boolean
    sales_order_status: SalesOrderStatus
    combined_status: CombinedOrderStatus
    is_part_of_buy_from_account: boolean
    pre_advice_reference: string | null
    sent_pre_advice_to_loendersloot_on: string | null
    pre_advice_confirmed_on: string | null
    pre_advice_cancelled_on: string | null
    pre_advice_failure_reason: string | null
    warehouse_status: string | null
    warehouse_reference: string | null
    pallets_final: number | null
    weight_final_kg: string | null
    last_warehouse_message: string | null
    sent_to_loendersloot_on: string | null
    frontoffice_instruction: string | null
    warehouse_instruction: string | null
    freight_instruction: string | null
    planned_loading_date: string | null
    estimated_loading_date: string | null
    has_items_missing_eu_address: boolean
    number_of_confirmed_cases: number
    number_of_cases_in_basket_items: number
    turnover: string
    was_sold_for: string
    was_sold_for_excl_excise: string
    was_sold_for_incl_vat: string
    total_before_discounts: string
    vat_total: string
    vat_id: string | null
    vat_country_code: string | null
    is_vat_shifted: boolean
    excise_total: string
    euro_purchasing_value: string
    margin: string
    margin_percentage: string | null
    product_total_excl_excise: string
    number_of_edi_messages: number
    number_of_emails: number | null
    needs_buy_from_account: boolean
    is_buy_from_account_head: boolean | null
    all_items_in_stock: boolean
    all_tbo_items_are_confirmed: boolean
    all_credit_items_in_stock: boolean
    from_portal: boolean
    destination_location: string | null
    destination_artkey: number | null
    destination_name: string | null
    origin_artkey: number | null
    origin_name: string | null
    account_slug: string
    account_name: string
    insurance_type_artkey: number
    insurance_type_name: string
    was_handled_by_profile_name: string
    supplier_artkey: number
    supplier_name: string
    supplier_memo: string | null
    supplier_currency: Currency
    supplier_portal_customs_visibility: string | null
    supplier_requires_eu_address: boolean
    supplier_sales_manager_profile_name: string
    delivery_status: DeliveryStatus | null
    delivery_external_reference: string | null
    delivery_estimated_number_of_pallets: number | null
    delivery_estimated_weight_in_kilos: string | null
    delivery_pickup_timeslot_from: string | null
    is_part_of_buy_from_account_sales_order_artkey: number | null
    is_part_of_buy_from_account_sales_order_reference: string | null
    is_part_of_buy_from_account_sales_order_account_slug: string | null
    needs_settings_confirmation: boolean
    excise_ledger_artkey: number | null
    excise_ledger_description: string | null
    sales_ledger_artkey: number | null
    sales_ledger_description: string | null
    relation_sales_ledger_artkey: number | null
    relation_sales_ledger_description: string | null
}

export interface GetSalesOrderTBOItemResponse {
    sales_order_artkey: number
    number_of_cases: number
    price_per_case: string
    excise_per_case: string | null
    confirmed_for_purchase_date: string | null
    purchase_order_item_artkey?: number | null
    case_artkey: number
    case_number_of_bottles: number
    article_code: string
    gift_box_type: GiftBoxType | null
    tax_label: string | null
    best_before_date: string | null
    customs_status: CustomsStatus
    bottle_artkey: number
    alcohol_percentage: string
    refill_status: RefillStatus
    volume: string
    product_category_artkey: number
    product_category_name: string
    product_artkey: number
    product_name: string
    country_of_origin: string | null
}

export interface GetSalesOrderVoucherResponse {
    sales_order_artkey: number
    description: string
    quantity: number
    sales_order_additional_type: SalesOrderAdditionalType
    value_type: SalesOrderAdditionalValueType
    value_per_quantity: string
    vat_percentage: string | null
}

export interface GetSalesOrdersCollectionViewResponse {
    artkey: number
    reference: string
    created_on: string
    combined_status: CombinedOrderStatus
    incoterm: string
    incoterm_and_location: string
    supplier_name: string
    destination_name?: string | null
    destination_location?: string | null
    number_of_confirmed_cases: number
    was_sold_for: number
    was_sold_in: string
    sold_against_rate: number
    margin: number
    margin_percentage?: number | null
    sales_manager_name: string
    has_attachments: boolean
    supplier_account_slug: string
    supplier_account_name: string
    was_handled_by_name: string
    warehouse_status?: string | null
    warehouse_reference?: string | null
    is_complete: boolean
    invoice_number?: number | null
    is_invoiced_on?: string | null
    planned_loading_date?: string | null
    final_loading_date?: string | null
    delivery_status?: DeliveryStatus | null
}

export interface GetSalesTargetsResponse {
    month: number
    turnover: string
    gross_margin_percentage: string
}

export interface GetSearchRecipientResponse {
    artkey: number
    relation_name: string
}

export interface GetSellableBottlesResponse {
    artkey: number
    volume: string
    alcohol_percentage: string
    refill_status: RefillStatus
}

export interface GetSellableItemCollectionViewResponse {
    artkey: string
    bottle_artkey: number
    cases_per_pallet: number | null
    cases_per_pallet_layer: number | null
    sellable_item_type: SellableItemFilterType
    product_name: string
    product_category_name: string
    volume: string
    alcohol_percentage: string
    refill_status: RefillStatus
    case_artkey: number | null
    customs_status: CustomsStatus
    number_of_bottles: number
    gift_box_type: GiftBoxType | string | null
    serialized_item_tags: string | null
    best_before_date: string | null
    tax_label: string | null
    list_price: string | null
    list_price_per_bottle: string | null
    excise_per_case: string | null
    euro_was_bought_for: string | null
    currency: Currency
    original_price_per_case: string | null
    number_of_cases_available: number | null
    minimum_order_quantity: number | null
    country_of_origin: string | null
    source: string | null
    source_reference: string | null
    source_artkey: number | null
    hidden_by_rule: string | null
    spli_price_per_case: string | null
    spli_currency: string | null
}

export interface GetSnoozesResponse {
    item_artkey: number
    workflow_snoozes: WorkflowSnooze[]
}

export interface GetSpecialsPriceListCollectionViewResponse {
    artkey: number
    product_name: string
    product_category_name: string
    case_artkey: number
    case_customs_status: string
    case_article_code: string
    case_number_of_bottles: number
    bottle_artkey: number
    bottle_gtins?: string | null
    bottle_volume: string
    bottle_alcohol_percentage: string
    bottle_refill_status: RefillStatus
    relation_artkey: number
    euro_total_stock_value: string
    stock_age: number
    number_of_cases_available: number
    offer_artkey: number
    offer_title: string
    offer_end_date?: string | null
    offer_start_date: string
}

export interface GetSpliSimilarStockResponse {
    artkey: number
    number_of_cases_available: number
    number_of_cases_in_sales: number
    number_of_cases_in_purchase: number
    number_of_cases_in_stock: number
}

export interface GetSpliStockInfoResponse {
    artkey: number
    max_stock_age: number
    avg_recent_purchase_price: string | null
    avg_stock_purchase_price: string | null
}

export interface GetSpliThroughputResponse {
    artkey: number
    bought_last_month: number
    bought_last_quarter: number
    bought_last_year: number
    sold_last_month: number
    sold_last_quarter: number
    sold_last_year: number
}

export interface GetSplisByBottle {
    artkey: number
    supplier_price_list_artkey: number
    file_name: string | null
    supplier_artkey: number
    supplier_name: string
    supplier_company_type: string | null
    gift_box_type: GiftBoxType | null
    number_of_bottles_per_case: number
    price_per_bottle: string | null
    price_per_case: string | null
    currency: Currency
    volume: string
    alcohol_percentage: string
    product_name: string
    aux_info: string | null
}

export interface GetSupplierPriceListConfigResponse {
    cache_key: string
    column_mapping: {[key: string]: string}
    header: string[]
}

export interface GetSupplierPriceListItemCollectionResponse {
    artkey: number
    rank?: number | null
    total?: number | null
    score?: string | null
    product_artkey: number
    product_name: string
    product_category_artkey: number
    product_category: string
    number_of_bottles_per_case: number
    cases_per_pallet?: number | null
    cases_per_pallet_layer?: number | null
    bottle_artkey: number
    volume: string
    alcohol_percentage: string
    refill_status: string
    incoterm: string
    gift_box_type?: GiftBoxType | null
    number_of_cases?: number | null
    number_of_bottles?: number | null
    default_country_code?: string | null
    country_of_origin?: string | null
    currency: Currency
    euro_price_per_case?: string | null
    euro_price_per_bottle?: string | null
    number_of_matching_tbo_items: number
    price_per_case?: string | null
    price_per_bottle?: string | null
    customs_status: CustomsStatus
    aux_info?: string | null
    is_available: boolean
    availability_status?: string | null
    bottle_gtin_code?: string | null
    bottle_gtin_codes?: string | null
    case_gtin_code?: string | null
    line_content: string | null
    spsl_artkey?: number | null
}

export interface GetSupplierPriceListItemResponse {
    entity_alt: EntityAlt
    artkey: number
    gift_box_type: GiftBoxType | null
    aux_info: string | null
    customs_status: string
    number_of_bottles_per_case: number
    number_of_bottles: number | null
    number_of_cases: number | null
    price_per_bottle: string | null
    price_per_case: string | null
    currency: Currency
    volume: string | null
    alcohol_percentage: string | null
    refill_status: RefillStatus | null
    availability_status: string | null
    product_name: string
    country_of_origin: string | null
    incoterm: string
    bottle_gtin_code: string | null
    case_gtin_code: string | null
    availability_date: string | null
    supplier_artkey: number
    bottle_artkey: number
    product_artkey: number
    product_category: string
    product_category_artkey: number
    is_available: boolean
    cases_per_pallet: number | null
    cases_per_pallet_layer: number | null
    case_cases_per_pallet: number | null
    case_cases_per_pallet_layer: number | null
    trusted_supplier_cases_per_pallet: number | null
    trusted_supplier_cases_per_pallet_layer: number | null
    supplier: SupplierResponse
    bottle: BottleResponse
    supplier_price_list: Fact2ServerApiDiscoverSupplierPriceListSpliGetGetSupplierPriceListItemResponseSupplierPriceListResponse
}

export interface GetSupplierPriceListStatisticsResponse {
    spl_artkey: number
    total_items: number
    total_unresolved: number
}

export interface GetTBOCollectionViewResponse {
    artkey: number
    number_of_cases: number
    confirmed_for_purchase_date: string | null
    created_on: string
    status: SalesOrderTBOItemStatus
    price_per_case: string
    price_per_bottle: string
    excise_per_case: string | null
    includes_excise: boolean
    was_sold_in: Currency
    sold_against_rate: string
    portal_comment: string | null
    change_comment: string | null
    trader_comment: string | null
    sales_order_reference: string
    sales_order_account_slug: string
    sales_order_account_artkey: number
    sales_manager_name: string
    relation_name: string
    relation_artkey: number
    created_on_portal: boolean
    product_category_name: string | null
    product_artkey: number | null
    product_name: string | null
    product_country_of_origin: string | null
    bottle_artkey: number | null
    volume: number | null
    alcohol_percentage: number | null
    refill_status: string | null
    case_artkey: number | null
    number_of_bottles: number | null
    tax_label: string | null
    gift_box_type: string | null
    customs_status: string | null
    best_before_date: string | null
    item_tags: number[] | null
    serialized_item_tags: string | null
    weight: number | null
    length: number | null
    height: number | null
    width: number | null
    cases_per_pallet: number | null
    cases_per_pallet_layer: number | null
    dimensions: string | null
    article_code: string | null
    number_of_cases_available: number
    number_of_cases_in_purchase: number
    number_of_cases_in_sales: number
    number_of_cases_in_stock: number
}

export interface GetTBOItemResponse {
    artkey: number
    number_of_cases: number
    confirmed_for_purchase_date: string | null
    created_on: string
    status: SalesOrderTBOItemStatus
    price_per_case: string
    price_per_bottle: string
    excise_per_case: string | null
    includes_excise: boolean
    was_sold_in: Currency
    sold_against_rate: string
    sales_order_reference: string
    relation_name: string
    relation_artkey: number
    product_category_name: string | null
    product_artkey: number | null
    product_name: string | null
    product_country_of_origin: string | null
    bottle_artkey: number | null
    volume: number | null
    alcohol_percentage: number | null
    refill_status: string | null
    case_artkey: number | null
    number_of_bottles: number | null
    tax_label: string | null
    gift_box_type: string | null
    customs_status: string | null
    best_before_date: string | null
    item_tags: number[] | null
    serialized_item_tags: string | null
    weight: number | null
    length: number | null
    height: number | null
    width: number | null
    cases_per_pallet: number | null
    cases_per_pallet_layer: number | null
    dimensions: string | null
    article_code: string | null
}

export interface GetTBOOfferItemResponse {
    customs_status?: CustomsStatus | null
    gift_box_type: GiftBoxType | null
    number_of_bottles: number
    tax_label: string | null
    volume: string
    alcohol_percentage: string
    refill_status: RefillStatus
    product_name: string
    artkey: number
    is_hidden: boolean
    is_active: boolean
    tbo_has_active_spli: boolean
    needs_approval: boolean
    delivery_period: number | null
    minimum_quantity: number | null
    maximum_quantity: number | null
    price_per_case: string
}

export interface GetTopSuppliersForSOTIResponse {
    soti_artkey: number
    top_suppliers: TopSupplier[]
}

export interface GetUnAuthenticatedPortalProfileResponse {
    email_address: string
    language: string
    first_name: string | null
    last_name: string | null
    name: string
    phone_number: string | null
    mobile_phone_number: string | null
    timezone: string
}

export interface GetUnresolvedItemsResponse {
    entity_alt: EntityAlt
    artkey: number
    gift_box_type: string | null
    aux_info: string | null
    customs_status: string
    number_of_bottles_per_case: number | null
    number_of_bottles: number | null
    number_of_cases: number | null
    price_per_bottle: string | null
    price_per_case: string | null
    currency: Currency | null
    volume: string | null
    alcohol_percentage: string | null
    refill_status: string | null
    availability_status: string | null
    product_name: string | null
    country_of_origin: string | null
    incoterm: string | null
    bottle_gtin_code: string | null
    case_gtin_code: string | null
    availability_date: string | null
    line_content: string
    raw_product_name: string | null
    matching_score: string | null
    is_suppressed: boolean
    cases_per_pallet: number | null
}

export interface GetUserCollectionResponse {
    artkey: number
    email_address: string
    is_crm_manager: boolean
    is_deleted: boolean
    is_purchaser: boolean
    is_stock_manager: boolean
    is_superuser: boolean
    is_trader: boolean
    mobile_telephone_number: string | null
    name: string
    profile_image: string | null
    profile_name: string
    trading_countries: string[]
}

export interface GetUserDownloadLinkResponse {
    link: string
    valid_until: string
}

export interface GetUserDownloadsResponse {
    artkey: number
    created_on: string
    valid_until?: string | null
    status: UserDownloadStatus
    file_name: string
    file_size?: number | null
    warning_message?: string | null
    failure_reason?: string | null
}

export interface GetUserProfileResponse {
    a2bc_emailaddress: string | null
    address: string
    emailaddress: string
    gitlab_username: string | null
    mobile_telephone_number: string | null
    name: string
    telephone_number: string
}

export interface GetUserResponse {
    artkey: number
    daily_travel_distance: number
    decimal_locale: string
    get_bank_mail_a2bc: boolean
    get_bank_mail_msi: boolean
    is_compensable: boolean
    is_crm_manager: boolean
    is_deleted: boolean
    is_purchaser: boolean
    is_stock_manager: boolean
    is_superuser: boolean
    is_trader: boolean
    name: string
    otp_validated: boolean
    profile: GetUserProfileResponse
    profile_image: string | null
    schedule_friday: ScheduleSetting | null
    schedule_monday: ScheduleSetting | null
    schedule_thursday: ScheduleSetting | null
    schedule_tuesday: ScheduleSetting | null
    schedule_wednesday: ScheduleSetting | null
    trading_countries: string[]
}

export interface GetUserSubscriptionResponse {
    start_of_week: boolean
    wysiwyg: boolean
    arriving_soon: boolean
    pallet_deals: boolean
    new_in_stock: boolean
}

export interface GetVatRateResponse {
    artkey: number
    country_code: string
    percentage: string
}

export interface GetVoucherPromotionRelationResponse {
    relation_artkey: number
    relation_name: string
    voucher_promotion_artkey: number
    used: boolean
    code: string
}

export interface GetVoucherPromotionResponse {
    artkey: number
    name: string
    voucher_value_type: VoucherValueType
    value: string
    code: string
    created_on: string
    start_date: string
    end_date: string
    account_artkey: number
    account_slug: string
}

export interface GetVoucherRelationCollectionViewResult {
    artkey: number
    name: string
    country_code: string
    city: string
    supplier_status: SupplierStatus
    client_status: SupplierClientStatus | null
    company_type: RelationCompanyType
    sales_manager_name: string
    sales_manager_artkey: number
    is_in_voucher_promotion: boolean
}

export interface GiftBoxStatistic {
    name: string
    count: number
}

export enum GiftBoxType {
    GB = 'GB',
    GBGlassEs = 'GB + Glass(es)',
    ValueGlassEs = '+ Glass(es)',
    GBBag = 'GB Bag',
    GiftSet = 'Gift Set',
    GiftTin = 'Gift Tin',
    WoodenGB = 'Wooden GB',
    Cradle = 'Cradle',
}

export interface HTTPExceptionResponse {
    status_code: number
    detail?: string | null
    headers?: {[key: string]: unknown} | null
}

export enum HTTPMethod {
    CONNECT = 'CONNECT',
    DELETE = 'DELETE',
    GET = 'GET',
    HEAD = 'HEAD',
    OPTIONS = 'OPTIONS',
    PATCH = 'PATCH',
    POST = 'POST',
    PUT = 'PUT',
    TRACE = 'TRACE',
}

export interface HTTPValidationError {
    detail?: ValidationError[]
}

export interface HiddenRelation {
    artkey: number
    name: string
}

export interface HttpApi {
    usage: string
    public: HttpApiMethod[]
}

export interface HttpApiMethod {
    method: string
    path: string
    summary: string
    response: string
    query_params?: {[key: string]: string} | null
}

export interface ImplicitHiddenInformation {
    relation_information: ImplicitHiddenInformationEntry
}

export interface ImplicitHiddenInformationEntry {
    hidden_country_codes: string[]
    hidden_relations: HiddenRelation[]
}

export interface InsuranceType {
    artkey: number
    name: string
}

export interface InviteLoginRequest {
    invite_code: string
}

export interface ItemAccountResponse {
    slug: string
    name: string
}

export interface ItemBottleResponse {
    artkey: number
    volume: string
    alcohol_percentage: string
    refill_status: RefillStatus
    product: ItemProductResponse
}

export interface ItemCaseResponse {
    artkey: number
    number_of_bottles: number
    gift_box_type: GiftBoxType | null
    tax_label: string | null
    customs_status: string
    item_tag_artkeys: number[]
    best_before_date: string | null
    cases_per_pallet?: number | null
    cases_per_pallet_layer?: number | null
    bottle: ItemBottleResponse
}

export interface ItemProductResponse {
    name: string
}

export interface ItemPurchaseOrderItemResponse {
    was_bought_for: string
    was_bought_for_plus_costs: string
    purchase_order: ItemPurchaseOrderResponse
}

export interface ItemPurchaseOrderResponse {
    artkey: number
    reference: string
    was_bought_in: string
}

export enum ItemTagCategoryArtkey {
    Value4 = 4,
    Value3 = 3,
    Value2 = 2,
    Value5 = 5,
    Value1 = 1,
}

export interface ItemTagCollectionResponse {
    artkey: number
    name: string
    abbreviation: string
    category_name: string
}

export interface ItemTagResponse {
    artkey: number
    name: string
    abbreviation: string
    item_tag_category_artkey: number
}

export interface ItemWarehouseResponse {
    name: string | null
}

export interface JsxCatalogueResponse {
    catalog_revision: string
    catalog_guide: string
    runtime_bindings: RuntimeBinding[]
    http_api: HttpApi
    components: JsxComponent[]
}

export interface JsxComponent {
    artkey: number
    name: string
    tier: string
    summary: string
    props: string
    guidance: string
    example?: string
}

export enum LeadContactStatus {
    NOT_YET_APPROACHED = 'NOT_YET_APPROACHED',
    APPROACHED = 'APPROACHED',
    FINALIZED = 'FINALIZED',
}

export interface LeadRegistrationRequest {
    company_name: string
    country_code: string
    vat_id?: string | null
    street_address: string
    zip_code: string
    city: string
    website?: string | null
    message?: string | null
    first_name: string
    family_name: string
    position?: string | null
    emailaddress: string
    telephone?: string | null
    warehouse_name?: string | null
    warehouse_address?: string | null
    warehouse_postalcode?: string | null
    warehouse_city?: string | null
    excise_id?: string | null
    excise_location_id?: string | null
}

export interface LinkTBOToStockResponse {
    lot?: string | null
    purchase_order_reference?: string | null
}

export enum LocationType {
    Warehouse = 'warehouse',
    Seaport = 'seaport',
    Airport = 'airport',
}

export interface LoenderslootCosts {
    additional_per_case: number | string
    exw_handover_costs?: number | string | null
    spirits_costs_per_case: number | string
    spirits_minimum_costs: number | string
    spirits_minimum_cases: number
    spirits_maximum_costs: number | string
    spirits_maximum_cases: number
    inspection_costs_first_item: number | string
    inspection_costs_per_item: number | string
    has_duty_drawback: boolean
    duty_drawback: number | string
    duty_drawback_per_case: number | string
    non_spirits_costs_per_pallet: number | string
    non_spirits_minimum_costs: number | string
    non_spirits_minimum_pallets: number
}

export enum LoenderslootMessageStatus {
    Received = 'Received',
    Processed = 'Processed',
    Failed = 'Failed',
}

export enum LoginErrorMessage {
    ACCOUNT_DISABLED = 'Your account is disabled.',
    ACCOUNT_DISABLED_SUPPORT = 'Account you are trying to access is disabled.',
    CREDENTIALS_EMPTY = 'Password or username cannot be empty',
    CREDENTIALS_INVALID = 'Username or password is incorrect.',
    CREDENTIALS_INVALID_SUPPORT = 'Support Username or password is incorrect.',
    OTP_NOT_SET_UP = 'OTP is not set up.',
    OTP_INVALID = 'OTP code is invalid.',
    TOKEN_EXPIRED = 'Login token expired.',
    TOKEN_MALFORMED = 'Invalid login token.',
}

export interface MarkFavouriteUpdateSeenRequest {
    case_artkeys: number[]
}

export interface MarkItemProductPhotosAsReviewedRequest {
    artkey: number
    rank: number
    is_internal: boolean
}

export type MatchModel = unknown

export interface MatchedCandidate {
    bottle: Bottle
    gift_box_type: GiftBoxType | null
    number_of_bottles_per_case: number
    customs_status: string
}

export interface Media {
    data: string
    name?: string | null
    content_type: string
}

export enum MediaLibrary {
    Account = 'account',
    Shared = 'shared',
}

export interface MergeArticlesRequest {
    source_artkeys: string[]
}

export interface MisLinkedPlaceholder {
    placeholder: string
    pages: string[]
}

export interface MockGitLabIssueRequest {
    title: string
    description: string
    issue_type: string
    labels: string
}

export interface Model {
    currencyexchangerates: Currencyexchangerate[]
}

export interface ModifyBasketVoucherRequest {
    voucher_code: string
}

export interface ModifyCartItemRequest {
    case_artkey: number
    offer_item_artkey: number
    custom_offer_item_artkey?: number | null
    number_of_cases: number
    price_per_case: number | string
}

export interface MovePOIBulkRequest {
    source_poi_artkeys: number[]
    target_purchase_order_artkey?: number | null
}

export interface MovePOIRequest {
    source_poi_artkey: number
    number_of_cases_to_move: number
    target_purchase_order_artkey?: number | null
}

export interface OfferHistoryResponse {
    artkey: number
    product_name: string
    offer_artkey: number
    offer_title: string
    offer_start_date: string
    offer_end_date: string | null
    case_number_of_bottles: number
    case_customs_status: string
    case_gift_box_type: GiftBoxType | null
    case_tax_label: string | null
    euro_price_per_case: string
    bottle_volume: string
    bottle_alcohol_percentage: string
    bottle_refill_status: RefillStatus
}

export interface OfferHistoryTotalsResponse {
    count: number
}

export enum OfferItemFilterType {
    NEW_ARRIVALS = 'NEW_ARRIVALS',
    FAVOURITES = 'FAVOURITES',
    SPECIALS = 'SPECIALS',
    BROWSE_STOCK = 'BROWSE_STOCK',
}

export interface OfferItemStatistic {
    offer_item_type: OfferItemFilterType
    count: number
}

export enum OfferItemType {
    Tbo = 'tbo',
    Stock = 'stock',
    Purchase = 'purchase',
}

export interface OfferStatistic {
    hash: string | null
    name: string
    count: number
}

export enum OfferType {
    Spotlight = 'spotlight',
    Regular = 'regular',
    Offer = 'offer',
    Tbo = 'tbo',
    Purchase = 'purchase',
}

export interface OkResponse {
    detail: string
}

export interface Option {
    value: number | string | number[] | string[] | boolean | null
    label: string
}

export interface OptionWithChildren {
    value: number
    label: string
    children: Option[]
}

export interface OrderRatingResponse {
    comment: string | null
    rating: number
}

export interface PackagingStatistic {
    name: string
    count: number
}

export interface PagedApiResultGetPriceListResponse {
    total_count: number
    items: GetPriceListResponse[]
}

export interface PalletLayoutResponse {
    cases_per_pallet?: number | null
    cases_per_pallet_layer?: number | null
}

export interface ParseCandidatesRequest {
    cache_key?: string | null
    column_mapping: {[key: string]: string}
    offset: number
    limit: number
}

export interface PlaceholderImportResponse {
    created?: string[]
    replaced?: string[]
    skipped?: string[]
}

export enum PlaceholderPackage {
    Campaign = 'campaign',
    Common = 'common',
    Portal = 'portal',
    Discover = 'discover',
}

export enum PlaceholderScope {
    Discover = 'discover',
    Cms = 'cms',
    CmsPage = 'cms_page',
    CmsFragment = 'cms_fragment',
    Campaign = 'campaign',
    CampaignBatch = 'campaign_batch',
}

export interface PlaceholderSourceVariantResponse {
    artkey: number
    position: number
    source: string
    translations?: CampaignPlaceholderTranslation[]
}

export interface PortalLoginRequest {
    username: string
    password: string
    account_slug: AccountSlug
    username_support?: string | null
}

export interface PortalLoginResponse {
    token: string
    otp_secret_url?: string | null
    otp_required?: boolean
}

export interface PortalMenuCategory {
    artkey: number
    name: string
    priority?: number | null
    children: PortalMenuCategory[]
    number_of_products: number
    product_group_artkey: number
}

export interface PortalOfferItem {
    artkey: number
    related_offer_item_artkey?: number | null
    offer_item_type: string
    bottle_artkey: number
    bottle_volume: string
    bottle_alcohol_percentage: string
    bottle_refill_status: RefillStatus
    bottle_gtin_codes: string[]
    case_artkey: number
    case_article_code: string
    case_gift_box_type?: string | null
    case_number_of_bottles: number
    case_tax_label?: string | null
    item_best_before_date?: string | null
    case_customs_status: string
    item_damages?: string | null
    item_general_tags?: string | null
    item_pack_size?: string | null
    item_packaging?: string | null
    product_category: string
    product_name: string
    favourite_artkey?: number | null
    expired_on?: string | null
    list_quantity: number | null
    delivery_period?: number | null
    minimum_quantity?: number | null
    entry_date: string
    currency: Currency
    list_price: string
    original_price_per_case: string
    excise_per_case?: string | null
}

export interface PortalOrderItemResponse {
    artkey: number
    number_of_cases: number
    portal_comment: string | null
    vat_percentage: string | null
    product_name: string
    product_category: string
    bottle_volume: string
    bottle_alcohol_percentage: string
    bottle_refill_status: RefillStatus
    case_artkey: number
    case_article_code: string
    case_tax_label: string | null
    case_number_of_bottles: number
    case_gift_box_type: GiftBoxType | null
    case_customs_status: string
    item_best_before_date: string | null
    item_damages: string | null
    item_general_tags: string | null
    item_pack_size: string | null
    item_packaging: string | null
    delivery_period: string | null
    minimum_quantity: number | null
    offer_item_type: AvailabilityType
    offer_item_artkey: number | null
    list_price: string | null
    excise_per_case: string | null
    vat_total: string | null
}

export interface PortalUser {
    artkey: number
    contact_person: ContactPerson
}

export interface PortalUserCollectionViewResponse {
    artkey: number
    name: string
    full_name: string
    email_address: string
    language: SupportedLanguage
    last_seen_timestamp: string | null
    relation_name: string
    status: PortalUserStatus
    account_slug: string
}

export enum PortalUserStatus {
    Active = 'Active',
    Nudged = 'Nudged',
    AccountClosePending = 'Account close pending',
    Deleted = 'Deleted',
}

export interface PortalVerifyOTPRequest {
    pre_auth_token: string
    otp: string
}

export interface PostSalesTargetsRequest {
    sales_manager_artkey?: number | null
    targets: SalesTargetModel[]
}

export enum PricePreference {
    Bottle = 'bottle',
    Case = 'case',
}

export interface ProcessSupplierPriceListRequest {
    header: string[]
}

export interface Product {
    artkey: number | null
    product_category: Fact2ServerApiDiscoverSupplierPriceListCandidatesVerifiedCandidatesMatchedCandidateBottleProductProductCategory
    name: string
}

export interface ProductBottle {
    artkey: number
    volume: string
    alcohol_percentage: string
    refill_status: RefillStatus
}

export enum ProductBottleType {
    LIGHT_GLASS = 'LIGHT_GLASS',
    HEAVY_GLASS = 'HEAVY_GLASS',
    PET = 'PET',
    STONE = 'STONE',
    ALUMINIUM_CAN = 'ALUMINIUM_CAN',
    PREMIX_RTD_GLASS = 'PREMIX_RTD_GLASS',
    PREMIX_RTD_CAN = 'PREMIX_RTD_CAN',
    PREMIX_RTD_PET = 'PREMIX_RTD_PET',
}

export interface ProductCategoryData {
    artkey?: number | null
}

export interface ProductData {
    artkey?: number | null
    name?: string | null
    default_country_code?: string | null
    bottle_type?: ProductBottleType | null
    category?: ProductCategoryData | null
}

export interface ProductGroupMetaResponse {
    artkey: number
    product_group_artkey: number
    name: string
    type: ArticleValueType
    sortable: boolean
    filterable: boolean
    required: boolean
    description: string | null
}

export interface ProductGroupResponse {
    artkey: number
    name: string
    description: string | null
    product_category_count: number
    meta_count: number
}

export enum ProductPhotoType {
    PLACEHOLDER = 'PLACEHOLDER',
    PRODUCT_PHOTO = 'PRODUCT_PHOTO',
}

export interface ProductPhotosRequest {
    offer_item_artkeys: number[]
}

export interface ProductPhotosResponse {
    artkey: number
    rank: number
    photo_type: ProductPhotoType
    image_location?: string | null
    thumbnail_location?: string | null
}

export interface ProductResponse {
    artkey: number
    name: string
    default_country_code: string | null
}

export interface Profile {
    artkey: number
    name: string
}

export interface PromotionalOrder {
    promotion_item_id: string
    quantity: number
}

export interface PublicBrandHolderResponse {
    artkey: number
    name: string
}

export interface PublicBrandResponse {
    artkey: number
    brand_holder_artkey: number
    name: string
}

export interface PublicBrandStatisticsResponse {
    brand_count: number
}

export interface PublicCategoryResponse {
    artkey: number
    name: string
    priority?: number | null
    image_location?: string | null
    number_of_products?: number
}

export interface PublicCmsMediaFileResponse {
    name: string
    uri: string
}

export interface PublicCmsMediaFolderResponse {
    files: PublicCmsMediaFileResponse[]
}

export interface PublicCmsMediaFolderTreeResponse {
    folders: PublicCmsMediaSubfolderResponse[]
}

export interface PublicCmsMediaSubfolderResponse {
    name: string
    files: PublicCmsMediaFileResponse[]
}

export interface PublicPalletDealResponse {
    offer_item_artkey: number
    product_name: string
    bottle_volume: string
    bottle_alcohol_percentage: string
    product_category_image_location?: string | null
    case_number_of_bottles?: number | null
}

export interface PublicSearchCountsResponse {
    brand_holder: number
    category: number
}

export interface PublicStatisticsResponse {
    specials_count: number
    new_arrivals_count: number
    arriving_soon_count: number
}

export interface PublicStockTboResponse {
    stock_count: number
    tbo_count: number
}

export interface PurchaseHistoryResponse {
    product_artkey: number
    product_name: string
    bottle_artkey: number
    bottle_volume: string
    bottle_alcohol_percentage: string
    bottle_refill_status: RefillStatus
    case_artkey: number
    case_tax_label: string | null
    case_gift_box_type: GiftBoxType | null
    case_number_of_bottles: number
    case_excise_nl: string
    supplier_name: string
    purchase_order_item_artkey: number
    case_customs_status: string
    purchase_order_item_number_of_cases: number
    purchase_order_item_was_bought_for: string
    purchase_order_item_remark: string | null
    supplier_price_list_item_aux_info: string | null
    purchase_order_item_total_was_bought_for: string
    purchase_order_latest_status_update: string
    purchase_order_reference: string
    account_artkey: number
    account_slug: string
    account_name: string
    purchase_order_status: PurchaseOrderStatus
    purchase_order_was_bought_in: string
    purchase_order_bought_against_rate: string
    lots: (string | null)[]
    references: string[]
}

export interface PurchaseHistoryTotalsResponse {
    total: string | null
    count: number
}

export interface PurchaseOrderItemRFP {
    artkey: number
    show_bid_price_on_rfp: boolean
    show_as_new_on_rfp: boolean
}

export enum PurchaseOrderStatus {
    Saved = 'Saved',
    Confirmed = 'Confirmed',
    Cancelled = 'Cancelled',
    OnHold = 'On Hold',
    ReadyForFIS = 'Ready for FIS',
    StockedAndBooked = 'Stocked and Booked',
}

export interface RangeFilterValue {
    min_value: number | null
    max_value?: number | null
}

export enum RefillStatus {
    Nonref = 'nonref',
    Ref = 'ref',
}

export interface RefillStatusStatistic {
    refill_status: RefillStatus
    count: number
}

export enum RelationCompanyType {
    Competitor = 'Competitor',
    PricingCompetitor = 'Pricing Competitor',
    AgentImporterNL = 'Agent / Importer NL',
    AgentImporter = 'Agent / Importer',
    Retail = 'Retail',
    Wholesale = 'Wholesale',
    Trader = 'Trader',
    TravelRetailDutyFree = 'Travel Retail / Duty Free',
    MSI = 'MSI',
    MSP = 'MSP',
    LogisticsWarehouse = 'Logistics / Warehouse',
    ServicePartner = 'Service partner',
    Unknown = 'Unknown',
}

export interface RelationFavouriteResult {
    artkey: number | null
    custom_offer_item_artkey: number | null
    favourite_artkey: number
    product_name: string
    product_category: string
    offer_item_type: AvailabilityType
    offer_type: OfferType
    validity_date: string | null
    vat_percentage: string | null
    delivery_period: number | null
    minimum_quantity: number | null
    step_size_quantity: number | null
    entry_date: string | null
    expected_entry_date_in_weeks: number | null
    list_quantity: number | null
    excise_per_case: string | null
    list_price: string | null
    original_price_per_case: string | null
    bottle_gtin_code?: string[]
    bottle_artkey: number
    bottle_volume: string
    bottle_alcohol_percentage: string
    bottle_refill_status: RefillStatus
    case_artkey: number
    case_article_code: string
    case_gift_box_type: GiftBoxType | null
    case_number_of_bottles: number
    case_tax_label: string | null
    item_best_before_date: string | null
    case_customs_status: string
    item_damages: string | null
    item_general_tags: string | null
    item_pack_size: string | null
    item_packaging: string | null
    cases_per_pallet: number | null
    cases_per_pallet_layer: number | null
    case_weight: string | null
    currency: Currency
    created_on: string
    update_seen_on: string | null
}

export interface RelationFilter {
    search_terms?: string[]
    buyer_supplier?: BuyerSupplier[]
    client_status?: SupplierClientStatus[]
    company_type?: RelationCompanyType[]
    sales_manager_artkeys?: number[]
    show_mode?: ShowMode | null
    last_invoiced_sales_order?: AgeLastSalesOrder | null
    last_seen_on_portal?: AgeLastPortalLogin | null
}

export enum RelationLogType {
    CONTACT_UPDATE = 'CONTACT_UPDATE',
    MESSAGE = 'MESSAGE',
}

export enum RelationPriceListHiddenRule {
    RelationIsSupplier = 'Relation is supplier',
    RelationHasADifferentCustomsStatus = 'Relation has a different customs status',
    TheOfferItemIsNotYetApproved = 'The OfferItem is not yet approved',
    TheItemIsNotYetApproved = 'The Item is not yet approved',
    TheOfferItemIsHidden = 'The OfferItem is hidden',
    CountryOfTheRelationIsBlockedByTheSupplier = 'Country of the relation is blocked by the supplier',
    CountryOfTheRelationIsBlockedByPurchaseOrderItem = 'Country of the relation is blocked by PurchaseOrderItem',
    CountryOfTheRelationIsBlockedByItem = 'Country of the relation is blocked by Item',
    CountryOfTheRelationIsBlockedByTheProduct = 'Country of the relation is blocked by the Product',
    CountryOfTheRelationIsBlockedByTheBrand = 'Country of the relation is blocked by the Brand',
    CountryOfTheRelationIsBlockedByTheBrandHolder = 'Country of the relation is blocked by the BrandHolder',
    CountryOfTheRelationIsBlockedByTheOfferItem = 'Country of the relation is blocked by the OfferItem',
    CountryOfTheRelationRequiresAnEUAddressOnTheLabel = 'Country of the relation requires an EU address on the label',
    TheRelationIsBlockedByTheSupplier = 'The relation is blocked by the supplier',
    TheRelationIsBlockedByTheSupplierPriceList = 'The relation is blocked by the supplier price list',
    TheRelationIsBlockedByThePurchaseOrderItem = 'The relation is blocked by the PurchaseOrderItem',
    TheRelationIsBlockedByTheItem = 'The relation is blocked by the Item',
    TheRelationIsBlockedByTheProduct = 'The relation is blocked by the Product',
    TheRelationIsBlockedByTheBrand = 'The relation is blocked by the Brand',
    TheRelationIsBlockedByTheBrandHolder = 'The relation is blocked by the BrandHolder',
    TheRelationIsBlockedByTheOfferItem = 'The relation is blocked by the OfferItem',
}

export interface RepackagedPlaceholder {
    placeholder: string
    from_package: string
    to_package: string
}

export interface RephraseRequest {
    text: string
    target_lang: SupportedLanguage
    writing_style?: DeeplWritingStyle | null
    tone?: DeeplWritingTone | null
}

export interface RephraseResponse {
    improved_text: string
    target_language: string
    detected_source_language: string
}

export interface RepositionSpotlightRequest {
    rank: number
}

export interface ResetPasswordRequest {
    request_id: string
    new_password: string
}

export interface ResetUserOTPRequest {
    user_artkey: number
}

export interface RetrieveTokensRequest {
    auth_code: string
}

export interface ReviewableBottle {
    product: ReviewableProduct
}

export interface ReviewableCase {
    bottle: ReviewableBottle
}

export interface ReviewableProduct {
    name: string
}

export interface ReviewableProductPhoto {
    artkey: number
    rank: number
    is_internal: boolean
    original_location: string
    file_name: string
}

export interface ReviewablePurchaseOrder {
    artkey: number
    reference: string
}

export interface ReviewablePurchaseOrderItem {
    artkey: number
    purchase_order: ReviewablePurchaseOrder
    case: ReviewableCase
}

export enum RotateDirection {
    Left = 'left',
    Right = 'right',
}

export interface RotateProductPhotoRequest {
    rotate_direction: RotateDirection
}

export interface RotateProductPhotoResponse {
    artkey: number
    original_location: string
}

export interface RuntimeBinding {
    name: string
    description: string
}

export enum SPLAuditLogType {
    Matched = 'Matched',
    MatchedExactProductMap = 'Matched exact product map',
    NoProductsMatchedEnough = 'No products matched enough',
    NoPriceGivenForLine = 'No price given for line',
    NoBottlesPerCaseGivenForLine = 'No bottles per case given for line',
    NoMatchOnProduct = 'No match on product',
    NoBottleFound = 'No bottle found',
    NoMappingFound = 'No mapping found',
    NoSourceLineFound = 'No source line found',
    NoProductNameFound = 'No product name found',
    ParsingError = 'Parsing error',
    UnhandledException = 'Unhandled exception',
    BottleCreated = 'Bottle created',
    ProductCreated = 'Product created',
    ProductMapCreated = 'ProductMap created',
    ProductMapUpdated = 'ProductMap updated',
    Suppressed = 'Suppressed',
    GTINCreated = 'GTIN created',
    GTINNotFound = 'GTIN not found',
    GTINDifferentBottle = 'GTIN different bottle',
    GTINDifferentProduct = 'GTIN different product',
    NoRowsToEstimateBtlsCs = 'No rows to estimate btls/cs',
    PriceDiffersTooMuchFromMarket = 'Price differs too much from market',
}

export interface SalesHistoryResponse {
    sales_history_type: ExploreSalesHistoryType
    product_artkey: number
    product_name: string
    bottle_artkey: number
    bottle_alcohol_percentage: string
    bottle_volume: string
    bottle_refill_status: RefillStatus
    case_artkey: number
    case_tax_label: string | null
    case_gift_box_type: GiftBoxType | null
    case_number_of_bottles: number
    case_customs_status: string
    case_excise_nl: string
    supplier_name: string
    sales_manager_name: string
    item_reference: string | null
    item_euro_total_stock_value: string | null
    item_lot: string | null
    sales_order_item_artkey: number
    sales_order_item_euro_was_bought_for: string | null
    sales_order_item_number_of_cases: number
    sales_order_item_price_per_case_excl_excise: string
    sales_order_item_price_per_case_incl_excise: string
    sales_order_item_total_margin: string | null
    sales_order_item_total_euro_was_bought_for: string | null
    sales_order_item_total_was_sold_for_excl_excise: string
    sales_order_item_total_was_sold_for_incl_excise: string
    sales_order_latest_status_update: string
    sales_order_reference: string
    sales_order_sales_order_status: string
    sales_order_was_sold_in: string
    sales_order_sold_against_rate: string
    purchase_order_reference: string | null
    purchase_order_was_bought_in: string | null
    purchase_order_bought_against_rate: string | null
    account_slug: string
    account_name: string
}

export interface SalesHistoryTotalsResponse {
    total: string | null
    margin: string | null
    count: number
}

export interface SalesOrderAdditionalResponse {
    artkey: number
    description: string
    quantity: number
    value_per_quantity: string
    price_per_unit: string
    total: string
    basket_total: string
    value_type: SalesOrderAdditionalValueType
    vat_percentage: string | null
    sales_order_additional_type: string
}

export enum SalesOrderAdditionalType {
    Revenue = 'revenue',
    WasteFund = 'waste_fund',
    Discount = 'discount',
    Voucher = 'voucher',
    Transport = 'transport',
    Pallet = 'pallet',
    Other = 'other',
}

export enum SalesOrderAdditionalValueType {
    FIXED = 'FIXED',
    PERCENTAGE = 'PERCENTAGE',
}

export interface SalesOrderCreditItemResponse {
    artkey: number
    number_of_cases: number
    original_sales_order_artkey: number
    original_was_sold_in: string
    original_sold_against_rate: string
    original_number_of_cases: number
    original_price_per_case: string
    original_total_was_sold_for: string
    original_vat_percentage: string | null
    original_vat_per_case: string | null
    original_vat_total: string | null
    product_name: string
    bottle_artkey: number
    bottle_alcohol_percentage: string
    bottle_refill_status: RefillStatus
    bottle_volume: string
    case_artkey: number
    case_article_code: string
    case_gift_box_type: GiftBoxType | null
    case_number_of_bottles: number
    case_tax_label: string | null
    item_best_before_date: string | null
    case_customs_status: string
    item_damages: string | null
    item_general_tags: string | null
    item_pack_size: string | null
    item_packaging: string | null
}

export interface SalesOrderDetailsResponse {
    artkey: number
    created_on: string
    reference: string
    was_sold_in: string
    was_sold_for: string
    was_sold_for_incl_vat: string
    sold_against_rate: string
    vat_total: string
    incoterm: string
    incoterm_location: string
    includes_excise: boolean
    is_invoiced_on: string | null
    invoice_number: number | null
    is_complete: boolean
    requested_delivery_date: string | null
    portal_status: string
    additional_percentage_total: string
    number_of_cases: number
    num_items: number
    account_slug: string
}

export interface SalesOrderItemByBottle {
    artkey: number
    price_per_case: string
    excise_per_case: string | null
    price_per_case_excl_excise: string
    price_per_bottle: string
    excise_per_bottle: string | null
    price_per_bottle_excl_excise: string
    number_of_cases: number
    case_artkey: number
    case_number_of_bottles: number
    case_excise_nl: string
    bottle_excise_nl: string
    bottle_refill_status: string
    bottle_volume: string
    bottle_alcohol_percentage: string
    case_gift_box_type: GiftBoxType | null
    case_tax_label: string | null
    case_customs_status: string
    account_slug: string
    account_name: string
    account_informal_name: string
    supplier_name: string
    profile_name: string
    sales_order_artkey: number
    sales_order_reference: string
    sales_order_created_on: string
    sales_order_was_sold_in: string
    sales_order_sold_against_rate: string
    sales_order_is_invoiced_on: string | null
    sales_order_is_confirmed_on: string | null
    sales_order_status: string
    sales_order_latest_status_update: string
}

export interface SalesOrderItemResponse {
    artkey: number
    number_of_cases: number
    price_per_case: string
    excise_per_case: string | null
    total_was_sold_for: string
    vat_percentage: string | null
    vat_per_case: string | null
    vat_total: string | null
    is_shipped: boolean
    portal_comment: string | null
    product_category: string
    product_name: string
    bottle_artkey: number
    bottle_alcohol_percentage: string
    bottle_refill_status: RefillStatus
    bottle_volume: string
    case_artkey: number
    case_article_code: string
    case_tax_label: string | null
    case_number_of_bottles: number
    case_gift_box_type: GiftBoxType | null
    case_customs_status: string
    item_best_before_date: string | null
    item_damages: string | null
    item_general_tags: string | null
    item_pack_size: string | null
    item_packaging: string | null
    item_bottle_lot: string | null
    delivery_period: string | null
    credited_in_sales_orders: number[] | null
    offer_item_type: AvailabilityType
}

export enum SalesOrderItemType {
    AdditionalItem = 'Additional item',
    BasketItem = 'Basket item',
    CreditItem = 'Credit item',
    HistoricalItem = 'Historical item',
    SalesOrderItem = 'Sales order item',
    TBO = 'TBO',
    Voucher = 'Voucher',
}

export interface SalesOrderItemsForItemResponse {
    artkey: number
    sales_order_artkey: number
    sales_order_reference: string
    sales_order_created_on: string
    sales_order_was_sold_in: string
    sales_order_sold_against_rate: string
    sales_order_incoterm: string
    sales_order_status: SalesOrderStatus
    price_per_case_excl_excise: string
    number_of_cases: number
    case_gift_box_type: GiftBoxType | null
    case_customs_status: string
    case_number_of_bottles: number
    bottle_volume: string
    bottle_alcohol_percentage: string
    bottle_refill_status: string
    product_name: string
    account_slug: string
    account_name: string
    was_handled_by_name: string
    supplier_name: string
    destination_name: string | null
}

export interface SalesOrderPhotoDownloadRequest {
    include_attachments: boolean
    include_item_photos: boolean
}

export interface SalesOrderRatingResponse {
    rating: number
    comment: string | null
}

export enum SalesOrderStatus {
    Saved = 'Saved',
    Confirmed = 'Confirmed',
    Invoiced = 'Invoiced',
    Cancelled = 'Cancelled',
}

export interface SalesOrderTBOItemResponse {
    artkey: number
    number_of_cases: number
    price_per_case: string
    total_was_sold_for_incl_excise: string
    vat_percentage: string | null
    vat_total: string | null
    status: string
    expected_delivery_date: string | null
    portal_comment: string | null
    offer_item_type: AvailabilityType
    delivery_period: string | null
    product_name: string
    bottle_artkey: number
    bottle_alcohol_percentage: string
    bottle_refill_status: RefillStatus
    bottle_volume: string
    case_artkey: number
    case_article_code: string
    case_gift_box_type: GiftBoxType | null
    case_number_of_bottles: number
    case_tax_label: string | null
    case_customs_status: string
    item_best_before_date: string | null
    item_damages: string | null
    item_general_tags: string | null
    item_pack_size: string | null
    item_packaging: string | null
}

export enum SalesOrderTBOItemStatus {
    Open = 'Open',
    Ordered = 'Ordered',
    Confirmed = 'Confirmed',
    NotYetApproved = 'Not yet approved',
}

export interface SalesOrderWarehouseStatusResponse {
    is_outbound?: boolean
    is_release_outbound?: boolean
    warehouse_notified?: boolean
    picking_started?: boolean
    picking_finished?: boolean
    inspection_started?: boolean
    inspection_finished?: boolean
    loading_started?: boolean
    loading_finished?: boolean
    warehouse_done?: boolean
}

export interface SalesPaymentTerm {
    description: string
}

export interface SalesTargetModel {
    month: number
    turnover: number | string
    gross_margin_percentage: number | string
}

export interface Scale {
    min_value: number
    max_value: number | null
}

export enum ScheduleSetting {
    FREE = 'FREE',
    OFF = 'OFF',
    OFFICE = 'OFFICE',
    HOME = 'HOME',
    SICK = 'SICK',
    VACATION = 'VACATION',
    ABROAD = 'ABROAD',
}

export interface SearchStatisticsResponse {
    totals: {[key: string]: unknown}
    rows: {[key: string]: unknown}[]
}

export interface SelectMultiple {
    name: string
    filter_type?: FilterType
    help?: string | null
    widget?: string | null
    default: number | string | number[] | string[] | boolean | null
    options: Option[] | OptionWithChildren[]
    serialize: string
    type?: 'SELECT_MULTIPLE'
}

export interface SelectRange {
    name: string
    filter_type?: FilterType
    help?: string | null
    widget?: string | null
    default: RangeFilterValue
    infinity: boolean
    scale: Scale
    serialize: string
    unit?: string | null
    type?: 'SELECT_RANGE'
}

export interface SelectResponse {
    label: string
    value: number | string
}

export interface SelectSingle {
    name: string
    filter_type?: FilterType
    help?: string | null
    widget?: string | null
    default: number | string | number[] | string[] | boolean | null
    options: Option[]
    serialize: string
    type?: 'SELECT_SINGLE'
}

export interface SelectWorkflow {
    name: string
    filter_type?: FilterType
    help?: string | null
    widget?: string | null
    default: string | null
    options: Option[]
    serialize: string
    context: WorkflowDefinition[]
    type?: 'SELECT_SINGLE'
}

export enum SellableItemFilterType {
    Stock = 'Stock',
    Purchase = 'Purchase',
    TBO = 'TBO',
    Market = 'Market',
    Credit = 'Credit',
}

export interface SendDeletionRequestEmailRequest {
    new_contact_person_name?: string | null
    new_contact_person_contactdata?: string | null
}

export interface SetLeadStatusRequest {
    lead_artkeys: number[]
    new_contact_status: LeadContactStatus
}

export enum ShowMode {
    InVoucher = 'In voucher',
    NotInVoucher = 'Not in voucher',
}

export interface SkippedPlaceholder {
    placeholder: string
    reason: string
}

export interface SortDefinition {
    default_field: SortField
    fields?: {[key: string]: string}[]
}

export interface SortField {
    id: string
    label: string
    order: SortOrder
}

export enum SortOrder {
    ASC = 'ASC',
    DESC = 'DESC',
}

export interface SortProductPhotoRequest {
    artkeys: number[]
}

export interface StatisticsForFilterResponse {
    offer_statistics?: OfferStatistic[]
    volume_statistics?: VolumeStatistic[]
    alcohol_statistics?: AlcoholStatistic[]
    packaging_statistics?: PackagingStatistic[]
    category_statistics?: CategoryStatistic[]
    availability_statistics?: AvailabilityStatistic[]
    offer_item_statistics?: OfferItemStatistic[]
    refill_status_statistics?: RefillStatusStatistic[]
    brand_holder_statistics?: BrandHolderStatistic[]
    brand_statistics?: BrandStatistic[]
    gift_box_statistics?: GiftBoxStatistic[]
}

export interface StatusInformationResponse {
    vow?: Vow | null
    countries?: CountryStatusModel[] | null
}

export enum StockReconciliationResult {
    NotFoundInDiscover = 'Not found in discover',
    NotFoundInLoendersloot = 'Not found in loendersloot',
    AccountIsDifferent = 'Account is different',
    NumberOfCasesAreDifferent = 'Number of cases are different',
    ArticleCodeIsDifferent = 'Article code is different',
    BottleGTINIsDifferent = 'Bottle GTIN is different',
}

export interface StockValue {
    value: string
    in_percent: string
    number_of_cases: number
}

export interface StockValueResponse {
    total_stock_value: StockValue
    range_0_90_days: StockValue
    range_91_180_days: StockValue
    range_181_365_days: StockValue
    range_366_730_days: StockValue
    range_more_than_730_days: StockValue
}

export interface SuggestionsResponse {
    entity_alt: EntityAlt
    artkey: number
    ratio: string
    image_url?: string | null
    source_page_url?: string | null
    specs_match: boolean
    tags?: Tag[]
    source_type?: string | null
    alcohol_percentage: string | null
    volume: string | null
    refill_status: string | null
    bottle_artkey: number | null
    bottle_gtin: string | null
    bottle_gtins: string | null
    country_of_origin: string | null
    product_artkey: number | null
    product_name: string
    product_category_artkey: number | null
    product_category: string | null
}

export enum SupplierClientStatus {
    Lead = 'Lead',
    Client = 'Client',
    Prospect = 'Prospect',
    LowPotential = 'Low Potential',
    NotActive = 'Not Active',
    DoNotApproach = 'Do Not Approach',
}

export interface SupplierPriceListCollectionResponse {
    artkey: number
    created_on: string
    start_date: string
    end_date?: string | null
    due_date?: string | null
    is_current: boolean
    generate_tbo_for_spli: boolean
    supplier_price_list_status: string
    started_processing_on?: string | null
    failed_processing_message?: string | null
    file_name?: string | null
    description: string
    supplier_artkey: number
    supplier_name: string
    price_list_manager_name: string
}

export enum SupplierPriceListStatus {
    Active = 'active',
    Expired = 'expired',
    NotYetActive = 'not_yet_active',
    Processing = 'processing',
    FailedProcessing = 'failed_processing',
    AlwaysActive = 'always_active',
    Deleted = 'deleted',
}

export interface SupplierResponse {
    artkey: number
    name: string
}

export interface SupplierSalesAccount {
    artkey: number
    slug: string
}

export interface SupplierStatistic {
    name: string
    year_values: YearValue[]
}

export enum SupplierStatus {
    Active = 'active',
    Deleted = 'deleted',
}

export enum SupportedLanguage {
    AR = 'ar',
    NL = 'nl',
    EN_GB = 'en-GB',
    DE = 'de',
    FR = 'fr',
    IT = 'it',
    JA = 'ja',
    ES = 'es',
    ZH = 'zh',
}

export interface SuppressionListResponse {
    artkey: number
    key: string
}

export interface SwitchCostStructureRequest {
    cost_type: CostType
}

export interface SyncPlaceholdersRequest {
    dry_run?: boolean
    scope: PlaceholderScope
    cms_page_artkey?: number | null
    cms_fragment_artkey?: number | null
    campaign_artkey?: number | null
    delete_unused?: string[]
}

export interface SyncPlaceholdersResponse {
    created: CreatedPlaceholder[]
    repackaged: RepackagedPlaceholder[]
    skipped: SkippedPlaceholder[]
    not_used: string[]
    mis_linked: MisLinkedPlaceholder[]
    labelled: GeneratedLabel[]
    still_blank: number
    translated: TranslatedPlaceholder[]
    translate_characters: number
    translate_failed_languages: string[]
    multi_variant: string[]
    deleted: string[]
    duplicate_name: DuplicateNamePlaceholder[]
    name_conflict: string[]
    campaign_not_used: string[]
    source_available: boolean
    dry_run: boolean
}

export interface SystemParameterResponse {
    name: string
    value: string
    type: string
    description: string
}

export enum TBODeliveryPeriod {
    Value2Weeks = '2_weeks',
    Value3Weeks = '3_weeks',
    Value4Weeks = '4_weeks',
    Value5Weeks = '5_weeks',
    Value6Weeks = '6_weeks',
}

export interface TBOOfferItemCollectionViewResponse {
    artkey: number
    is_hidden: boolean
    is_active: boolean
    needs_approval: boolean
    is_approved: boolean
    tbo_has_active_spli: boolean
    minimum_quantity: number | null
    maximum_quantity: number | null
    step_size: number | null
    delivery_period: number | null
    price_per_case: string
    market_rank: number | null
    market_total: number | null
    market_rank_competitors_only: number | null
    market_total_competitors_only: number | null
    avg_competitor_diff: string | null
    avg_competitor_diff_percentage: string | null
    number_of_sales_order_tbo_items: number
    number_of_portal_order_items: number
    product_category_name: string
    product_category_artkey: number
    product_name: string
    product_artkey: number
    number_of_bottles: number
    article_code: string
    gift_box_type: GiftBoxType | null
    tax_label: string | null
    best_before_date: string | null
    customs_status: CustomsStatus
    case_serialized_item_tags?: string | null
    bottle_artkey: number
    alcohol_percentage: string
    volume: string
    refill_status: RefillStatus
    lowest_tbo_market_euro_price_per_bottle: string | null
}

export interface Tag {
    tag: string
    value: string
}

export interface TextFilter {
    name: string
    filter_type?: FilterType
    help?: string | null
    widget?: string | null
    default: string
    serialize: string
    type?: 'TEXT'
}

export interface ToggleFilter {
    name: string
    filter_type?: FilterType
    help?: string | null
    widget?: string | null
    default: number | string | number[] | string[] | boolean | null
    serialize: string
    type?: 'TOGGLE'
}

export interface TopSupplier {
    supplier_artkey: number
    supplier_price_list_artkey: number
    number_of_bottles_per_case: number
    spli_euro_price_per_case: string
    spli_euro_price_per_bottle: string
    supplier_name: string
    purchase_manager_name: string
    margin_percentage: string
}

export interface TranslateRequest {
    context?: string | null
    formality?: DeeplFormality | null
    ignore_tags?: string
    model_type?: DeeplModelType | null
    source_lang?: string | null
    tag_handling?: string
    target_lang: SupportedLanguage
    text: string
}

export interface TranslateResponse {
    translated_text: string
}

export interface Translated {
    language: SupportedLanguage
    translated_text: string
}

export interface TranslatedPlaceholder {
    placeholder: string
    languages: string[]
    stale: boolean
    page?: string | null
}

export interface TranspileJSXResponse {
    compiled_js?: string | null
    success?: boolean | null
    error?: string | null
    detail?: string | null
}

export enum UTMCampaign {
    MailingArrivingSoon = 'mailing-arriving-soon',
    MailingNewInStock = 'mailing-new-in-stock',
    MailingNewPrices = 'mailing-new-prices',
    MailingStartOfWeek = 'mailing-start-of-week',
    MailingWysiwyg = 'mailing-wysiwyg',
    MailingPalletDeals = 'mailing-pallet-deals',
    Custom = 'custom',
    PriceList = 'price-list',
    PurchaseEnquiry = 'purchase-enquiry',
}

export enum UTMMedium {
    Email = 'email',
    Excel = 'excel',
    Affiliate = 'affiliate',
    Cpc = 'cpc',
    Social = 'social',
}

export enum UTMSource {
    Campaign = 'campaign',
    Newsletter = 'newsletter',
    PriceList = 'price-list',
}

export enum UnlinkedFragmentKeyAction {
    Keep = 'keep',
    Delete = 'delete',
}

export enum UnlinkedKeyAction {
    MakeGlobal = 'make_global',
    Delete = 'delete',
}

export enum UnsubscribeReason {
    Migration = 'migration',
    TooFrequent = 'too_frequent',
    NotRelevant = 'not_relevant',
    TechnicalIssues = 'technical_issues',
    FoundAlternative = 'found_alternative',
    TemporaryPause = 'temporary_pause',
    PrivacyConcerns = 'privacy_concerns',
    ContentQuality = 'content_quality',
    Other = 'other',
}

export interface UnusedMediaFileResponse {
    artkey: number
    file_name: string
    library: string
    path: string
    uri: string
    byte_size: number
    is_shared: boolean
}

export interface UpdateArticleRequest {
    product_name: string
    product_category_artkey: number
    default_country_of_origin: string | null
    alcohol_percentage: number | string
    volume: number | string
    refill_status: RefillStatus
    cbs_code: string | null
    cbs_code_description: string | null
    bottle_gtins_as_joined_str: string | null
    best_before_date: string | null
    serialized_item_tags: string | null
    number_of_bottles: number | null
    gift_box_type: GiftBoxType | null
    tax_label: string | null
    customs_status: CustomsStatus | null
    cases_per_pallet: number | null
    cases_per_pallet_layer: number | null
    length: number | string | null
    height: number | string | null
    width: number | string | null
    weight: number | string | null
}

export interface UpdateAttachmentRequest {
    category: string | null
    description: string | null
    valid_until?: string | null
}

export interface UpdateCampaignSubscriptionRequest {
    is_unsubscribed: boolean
    reason?: UnsubscribeReason | null
    comment?: string | null
}

export interface UpdateItemRequest {
    country_of_origin: string
    cases_per_pallet: number | null
    cases_per_pallet_layer: number | null
    best_before_date?: string | null
    remark: string | null
    bottle_gtin: string | null
    case_gtin: string | null
    bottle_lot: string | null
    item_tag_artkeys: number[]
}

export interface UpdateOfferItemRequest {
    price_per_case: number | string
    delivery_period?: number | null
    maximum_quantity?: number | null
    minimum_quantity?: number | null
    step_size_quantity?: number | null
    silent_price_change?: boolean
    is_hidden: boolean
    needs_approval: boolean
}

export interface UpdateOfferMemoRequest {
    memo?: string | null
}

export interface UpdateOrCreatePurchaseOrderRequest {
    relation_artkey: number
    target_warehouse_artkey: number
    origin_warehouse_artkey: number
    incoterm: string
    incoterm_location: string
    currency: Currency
    exchange_rate: number | string
    insurance_type_artkey: number
    supplier_reference?: string | null
    expected_delivery_date?: string | null
    number_of_euro_pallets?: number | null
    number_of_block_pallets?: number | null
    import_statement_override?: boolean
    override_reason?: string | null
    remark?: string | null
}

export interface UpdateOrCreateSupplierPriceListRequest {
    relation_artkey: number
    start_date: string
    end_date: string | null
    always_active: boolean
    description?: string
    default_customs_status: CustomsStatus
    default_delivery_period?: number | null
    default_incoterm?: string
    default_incoterm_location?: string
    default_currency?: Currency
    file_holder?: FileHolder | null
    generate_tbo_for_spli: boolean
    use_availability?: boolean
}

export interface UpdatePortalOrderItemCommentRequest {
    comment: string | null
}

export interface UpdatePortalOrderItemRequest {
    number_of_cases: number
    price_per_case: number | string
}

export interface UpdatePortalProfileRequest {
    first_name: string
    last_name?: string | null
    phone_number?: string | null
    mobile_phone_number?: string | null
    email_address: string
    language: string
    price_preference: PricePreference
    timezone: string
}

export interface UpdatePortalUserRequest {
    name: string
    email_address: string
    first_name: string
    family_name: string | null
    language: SupportedLanguage
}

export interface UpdateProductPhotoRequest {
    is_internal: boolean
}

export interface UpdateProductPhotoResponse {
    artkey: number
    item_artkey?: number | null
    offer_item_artkey?: number | null
    file_name: string
    s3_location: string | null
    s3_location_thumbnail: string | null
    is_internal: boolean
}

export interface UpdatePurchaseOrderCostsRequest {
    loendersloot_costs?: LoenderslootCosts | null
    diesel_surcharge_percentage: number | string | null
    transport_costs: number | string
    pallet_costs: number | string
    other_costs: number | string
    waste_fund_costs: number | string | null
    warehouse_base_costs: number | string | null
    warehouse_costs_per_case: number | string | null
}

export interface UpdatePurchaseOrderItemRequest {
    number_of_cases: number
    refill_status: RefillStatus
    alcohol_percentage: number | string
    volume: number | string
    was_bought_for: number | string
    number_of_bottles_per_case: number
    tax_label: string | null
    customs_status: string
    gift_box_type: GiftBoxType | null
    suggested_price_per_case: number | string | null
    remark: string | null
    bottle_gtin_code: string | null
    case_gtin_code: string | null
    serialized_item_tags?: number[]
    country_of_origin: string | null
    best_before_date: string | null
    cases_per_pallet: number | null
    cases_per_pallet_layer: number | null
}

export interface UpdateRelationVoucherPromotionRequest {
    relation_filter?: RelationFilter | null
    relation_artkeys_to_use: number[]
    relation_artkeys_to_exclude: number[]
}

export interface UpdateRemarkPurchaseOrderRequest {
    remark?: string | null
}

export interface UpdateRemarkSalesOrderRequest {
    remark?: string | null
}

export interface UpdateRequestForProposalRequest {
    rfp_comment: string | null
    item_rfp: PurchaseOrderItemRFP[]
}

export interface UpdateSalesOrderCreditItem {
    number_of_cases: number
}

export interface UpdateSalesOrderItemRequest {
    number_of_cases: number
    price_per_case: number | string
    description?: string | null
}

export interface UpdateSalesOrderRequest {
    relation_artkey: number
    destination_artkey: number
    origin_artkey: number
    incoterm: string
    incoterm_location: string
    freight_instruction?: string | null
    warehouse_instruction?: string | null
    estimated_loading_date?: string | null
    currency: Currency
    exchange_rate: number | string
    insurance_type_artkey: number
    escrow_loendersloot: boolean
    includes_excise: boolean
    remark?: string | null
}

export interface UpdateSystemParameterRequest {
    name: string
    new_value: string
    new_description: string
}

export interface UpdateTBOOfferItemRequest {
    customs_status: CustomsStatus
    needs_approval: boolean
    gift_box_type?: GiftBoxType | null
    price_per_case: number | string
    delivery_period?: number | null
    maximum_quantity?: number | null
    minimum_quantity?: number | null
    step_size?: number | null
    silent_price_change?: boolean
}

export interface UpdateTraderCommentRequest {
    trader_comment?: string | null
}

export interface UpsertBrandHolderRequest {
    full_name: string | null
    name: string
    requires_import_statement: boolean | null
}

export interface UpsertProductGroupMetaRequest {
    name: string
    type: ArticleValueType
    sortable: boolean
    filterable: boolean
    required: boolean
    description: string | null
}

export interface UpsertProductGroupRequest {
    name: string
    description: string | null
}

export interface UpsertUserProfileRequest {
    a2bc_emailaddress: string | null
    address: string
    emailaddress: string
    gitlab_username: string | null
    mobile_telephone_number: string | null
    name: string
    telephone_number: string
}

export interface UpsertUserRequest {
    daily_travel_distance: number
    decimal_locale: string
    get_bank_mail_a2bc: boolean
    get_bank_mail_msi: boolean
    is_compensable: boolean
    is_crm_manager: boolean
    is_purchaser: boolean
    is_stock_manager: boolean
    is_superuser: boolean
    is_trader: boolean
    name: string
    profile: UpsertUserProfileRequest
    profile_image: string | null
    trading_countries: string[]
}

export interface User {
    artkey: number
    name: string
    profile: Profile
}

export enum UserDownloadStatus {
    DONE = 'DONE',
    PENDING = 'PENDING',
    FAILED = 'FAILED',
}

export interface ValidateRelationViesRequest {
    country_code: string
    vat_id: string
}

export interface ValidateRelationViesResponse {
    valid: boolean
    name: string | null
    address: string | null
    country_code: string | null
    vat_number: string | null
}

export interface ValidationError {
    loc: (string | number)[]
    msg: string
    type: string
    input?: unknown
    ctx?: {[key: string]: unknown}
}

export interface VerifiedCandidates {
    artkey: number
    candidate: (string | null)[]
    matched_as: MatchedCandidate | null
    audit_logs: AuditLog[]
}

export interface VerifyCandidatesResponse {
    cache_key: string
    items: VerifiedCandidates[]
}

export interface VerifyOTPRequest {
    otp: string
    pre_auth_token: string
}

export interface VerifyOTPResponse {
    token: string
}

export enum VolumeFormatting {
    Cl = 'cl',
    L = 'l',
    Ml = 'ml',
}

export interface VolumeStatistic {
    size_in_cl: number
    count: number
}

export enum VoucherValueType {
    FIXED = 'FIXED',
    PERCENTAGE = 'PERCENTAGE',
}

export interface Vow {
    available?: boolean | null
}

export interface Warehouse {
    artkey: number
    name: string
    street_address: string
    zip_code: string
    city: string
    country_code: string
    warehouse_id: string | null
    excise_id: string | null
}

export interface WasHandledByProfile {
    artkey: number
    name: string
}

export interface WasHandledByUser {
    artkey: number
    name: string
    profile: WasHandledByProfile
}

export enum WeekDay {
    SUN = 'SUN',
    MON = 'MON',
    TUE = 'TUE',
    WED = 'WED',
    THU = 'THU',
    FRI = 'FRI',
    SAT = 'SAT',
}

export interface WorkflowDefinition {
    workflow_id: string
    total_count: number
    sort_on: string
    filters: {[key: string]: number | string | number[] | string[] | boolean | null}
    filter_labels: {[key: string]: string}
    actions: Action[]
    is_default: boolean
}

export interface WorkflowSnooze {
    artkey: number
    snoozed_until: string
    workflow_id: string
}

export interface YearValue {
    year: number
    value: string
}

export interface Fact2ServerApiDiscoverMarketExploreCaseAndSupplierCaseAndSupplierResponseSupplier {
    name: string
    country_code: string
    artkey: number
}

export interface Fact2ServerApiDiscoverProductProductGetProductsResponseProductCategory {
    artkey: number
    name: string
}

export interface Fact2ServerApiDiscoverPurchaseOrderGetGetPurchaseOrderResponseAccount {
    artkey: number
    name: string
    slug: string
    informal_name: string
    address: string
    zip_code: string
    city: string
    country_code: string
    telephone_number: string
    emailaddress: string
    website_url: string
    vat_id: string
    chamber_of_commerce_number: string
}

export interface Fact2ServerApiDiscoverPurchaseOrderGetGetPurchaseOrderResponseBuyFromAccountSalesOrderAccount {
    artkey: number
    name: string
    slug: string
}

export interface Fact2ServerApiDiscoverPurchaseOrderGetGetPurchaseOrderResponseSupplier {
    artkey: number
    relation_nr: number
    name: string
    memo: string | null
    street_address: string
    zip_code: string
    city: string
    country_code: string
    purchase_manager: User
    number_of_countries_hidden: number
    number_of_hide_from_pricelist_for_suppliers: number
    signed_trademark_declaration_valid_until: string | null
    has_signed_trademark_declaration: boolean
    is_verified: boolean
    price_preference: PricePreference
    emailaddress_rfp_documents: string | null
}

export interface Fact2ServerApiDiscoverSupplierPriceListCandidatesVerifiedCandidatesMatchedCandidateBottleProductProductCategory {
    name: string
}

export interface Fact2ServerApiDiscoverSupplierPriceListGetSupplierPriceListResponse {
    artkey: number
    supplier: Fact2ServerApiDiscoverSupplierPriceListGetSupplierPriceListResponseSupplier
    created_on: string
    default_currency: Currency
    default_customs_status: CustomsStatus
    default_delivery_period: number | null
    default_incoterm: string
    default_incoterm_location: string
    description: string | null
    start_date: string | null
    end_date: string | null
    generate_tbo_for_spli: boolean
    use_availability: boolean
    file_name: string | null
    status: SupplierPriceListStatus
    suppressed_source_line_count: number
    supplier_price_list_items_count: number
    started_processing_on: string | null
    unresolved_source_lines_count: number
    unresolved_expert_source_lines_count: number
    header_as_list: string[]
}

export interface Fact2ServerApiDiscoverSupplierPriceListGetSupplierPriceListResponseSupplier {
    artkey: number
    name: string
    company_type?: RelationCompanyType | null
    generates_tbo_for_spli: boolean
    sales_account: SupplierSalesAccount
}

export interface Fact2ServerApiDiscoverSupplierPriceListSpliGetGetSupplierPriceListItemResponseSupplierPriceListResponse {
    artkey: number
}

export interface Fact2ServerApiPortalOrderAdditionalDetailsAdditionalSalesOrderDetailsResponseSupplier {
    artkey: number
    name: string
    street_address: string
    zip_code: string
    city: string
    country_code: string
    relation_nr: number
    sales_payment_term?: SalesPaymentTerm | null
}

export interface Routes {
    'discover/accounts': {get: {response: GetAllAccountResponse[]}}
    'discover/afvalfonds': {post: {response: OkResponse; body: AfvalfondsRequest}}
    'discover/articles/cbs-codes/collection-view': {get: {response: CollectionViewResultGetCBSCodeResponse}}
    'discover/articles/cbs-codes/collection-view/meta': {get: {response: CollectionViewMeta}}
    'discover/articles/cbs-codes/search': {get: {response: GetCBSCodeResponse[]}}
    'discover/articles/collection-view': {get: {response: CollectionViewResultGetArticleCollectionViewResponse}}
    'discover/articles/collection-view/meta': {get: {response: CollectionViewMeta}}
    'discover/articles/merge/proposal': {get: {response: GetMergeArticleResponse}}
    'discover/articles/merge/{target_case_bottle_artkey}': {post: {response: unknown; body: MergeArticlesRequest}}
    'discover/articles/{case_bottle_artkey}': {
        get: {response: GetArticleResponse}
        put: {response: OkResponse | CreateEntityResponse; body: UpdateArticleRequest}
    }
    'discover/articles/{case_bottle_artkey}/gtins': {post: {response: OkResponse; body: CreateGTINRequest}}
    'discover/articles/{case_bottle_artkey}/gtins/{gtin}': {delete: {response: OkResponse}}
    'discover/articles/{case_bottle_artkey}/hidden-information': {get: {response: GetHiddenInformationResponse}}
    'discover/articles/{case_bottle_artkey}/hidden-information/countries': {
        post: {response: OkResponse; body: AddHiddenCountryCodeRequest}
    }
    'discover/articles/{case_bottle_artkey}/hidden-information/countries/{country_code}': {delete: {response: OkResponse}}
    'discover/articles/{case_bottle_artkey}/hidden-information/relations': {
        post: {response: OkResponse; body: AddHiddenRelationRequest}
    }
    'discover/articles/{case_bottle_artkey}/hidden-information/relations/{relation_artkey}': {delete: {response: OkResponse}}
    'discover/assistant/cms': {post: {response: unknown; body: AssistantBody}}
    'discover/assistant/cms/fragments/{cms_fragment_artkey}': {post: {response: unknown; body: AssistantBody}}
    'discover/assistant/cms/{cms_page_artkey}': {post: {response: unknown; body: AssistantBody}}
    'discover/assistant/session': {delete: {response: OkResponse}; get: {response: AssistantTranscript}}
    'discover/attachments/categories': {get: {response: GetAttachmentCategoryResponse}}
    'discover/bottle-gtin/{bottle_gtin_str}/bottle': {get: {response: BottleByGTINResp}}
    'discover/bottle/{bottle_artkey}/supplier-price-list-items': {get: {response: GetSplisByBottle[]}}
    'discover/bottles/quantity-bought': {get: {response: BottleThroughputResponse}}
    'discover/bottles/quantity-sold': {get: {response: BottleThroughputResponse}}
    'discover/bottles/{bottle_artkey}/cases': {get: {response: GetBottleCasesResponse[]}}
    'discover/bottles/{bottle_artkey}/sales-order-items/collection-view': {
        get: {response: CollectionViewResultSalesOrderItemByBottle}
    }
    'discover/bottles/{bottle_artkey}/stock': {get: {response: BottleStockResponse[]}}
    'discover/brand-holders': {post: {response: unknown; body: UpsertBrandHolderRequest}}
    'discover/brand-holders/collection-view': {get: {response: CollectionViewResultBrandHolderCollectionViewResponse}}
    'discover/brand-holders/collection-view/meta': {get: {response: CollectionViewMeta}}
    'discover/brand-holders/{brand_holder_artkey}': {
        get: {response: GetBrandHolderResponse}
        put: {response: unknown; body: UpsertBrandHolderRequest}
    }
    'discover/brand_holders/{brand_holder_artkey}/hidden-information': {get: {response: GetHiddenInformationResponse}}
    'discover/brand_holders/{brand_holder_artkey}/hidden-information/countries': {
        post: {response: OkResponse; body: AddHiddenCountryCodeRequest}
    }
    'discover/brand_holders/{brand_holder_artkey}/hidden-information/countries/{country_code}': {delete: {response: OkResponse}}
    'discover/brand_holders/{brand_holder_artkey}/hidden-information/relations': {
        post: {response: OkResponse; body: AddHiddenRelationRequest}
    }
    'discover/brand_holders/{brand_holder_artkey}/hidden-information/relations/{relation_artkey}': {
        delete: {response: OkResponse}
    }
    'discover/brands/{brand_artkey}/hidden-information': {get: {response: GetHiddenInformationResponse}}
    'discover/brands/{brand_artkey}/hidden-information/countries': {
        post: {response: OkResponse; body: AddHiddenCountryCodeRequest}
    }
    'discover/brands/{brand_artkey}/hidden-information/countries/{country_code}': {delete: {response: OkResponse}}
    'discover/brands/{brand_artkey}/hidden-information/relations': {post: {response: OkResponse; body: AddHiddenRelationRequest}}
    'discover/brands/{brand_artkey}/hidden-information/relations/{relation_artkey}': {delete: {response: OkResponse}}
    'discover/campaigns': {post: {response: CreateEntityResponse; body: CreateOrUpdateCampaignRequest}}
    'discover/campaigns/collection-view': {get: {response: CollectionViewResultGetCampaignCollectionViewResponse}}
    'discover/campaigns/collection-view/meta': {get: {response: CollectionViewMeta}}
    'discover/campaigns/offers/{offer_artkey}': {get: {response: GetCampaignResponse}}
    'discover/campaigns/placeholders/collection-view': {get: {response: CollectionViewResultGetCampaignPlaceholdersResponse}}
    'discover/campaigns/placeholders/collection-view/meta': {get: {response: CollectionViewMeta}}
    'discover/campaigns/recipients/search': {get: {response: GetSearchRecipientResponse[]}}
    'discover/campaigns/view/preview': {put: {response: GetEmailPreviewResponse; body: GetEmailPreviewRequest}}
    'discover/campaigns/{artkey}/attachments/collection-view/meta': {get: {response: CollectionViewMeta}}
    'discover/campaigns/{email_batch_artkey}': {
        get: {response: GetCampaignResponse}
        put: {response: OkResponse; body: CreateOrUpdateCampaignRequest}
    }
    'discover/campaigns/{email_batch_artkey}/action': {put: {response: CampaignActionResponse; body: CampaignActionRequest}}
    'discover/campaigns/{email_batch_artkey}/attachments': {post: {response: CreateEntityResponse; body: CreateAttachmentRequest}}
    'discover/campaigns/{email_batch_artkey}/attachments/collection-view': {
        get: {response: CollectionViewResultGetAttachmentCollectionViewResponse}
    }
    'discover/campaigns/{email_batch_artkey}/attachments/download-all': {post: {response: OkResponse}}
    'discover/campaigns/{email_batch_artkey}/attachments/{email_batch_attachment_artkey}': {
        delete: {response: OkResponse}
        put: {response: OkResponse; body: UpdateAttachmentRequest}
    }
    'discover/campaigns/{email_batch_artkey}/attachments/{email_batch_attachment_artkey}/download': {
        get: {response: DownloadAttachmentResponse}
    }
    'discover/campaigns/{email_batch_artkey}/emails/collection-view': {
        get: {response: CollectionViewResultGetEmailCollectionViewResponse}
    }
    'discover/campaigns/{email_batch_artkey}/emails/collection-view/meta': {get: {response: CollectionViewMeta}}
    'discover/campaigns/{email_batch_artkey}/recipients/collection-view': {
        get: {response: CollectionViewResultGetCampaignRecipientsCollectionViewResponse}
    }
    'discover/campaigns/{email_batch_artkey}/recipients/collection-view/meta': {get: {response: CollectionViewMeta}}
    'discover/cases/find-pallet-layout': {get: {response: PalletLayoutResponse}}
    'discover/cases/{case_artkey}': {put: {response: unknown; body: CaseUpdateRequest}}
    'discover/cms/backup/fragments/export': {get: {response: unknown}}
    'discover/cms/backup/fragments/import': {post: {response: CmsFragmentImportResponse}}
    'discover/cms/backup/fragments/import/dry-run': {post: {response: CmsFragmentImportResponse}}
    'discover/cms/backup/media/export': {get: {response: unknown}}
    'discover/cms/backup/media/import': {post: {response: unknown}}
    'discover/cms/backup/media/import/dry-run': {post: {response: CmsMediaImportResponse}}
    'discover/cms/backup/pages/export': {get: {response: unknown}}
    'discover/cms/backup/pages/import': {post: {response: CmsPageImportResponse}}
    'discover/cms/backup/pages/import/dry-run': {post: {response: CmsPageImportResponse}}
    'discover/cms/backup/placeholders/export': {get: {response: unknown}}
    'discover/cms/backup/placeholders/import': {post: {response: PlaceholderImportResponse}}
    'discover/cms/cache/clear': {post: {response: ClearPortalCacheResponse; body: CmsCacheClearBody}}
    'discover/cms/fragments': {
        get: {response: CollectionViewResultCmsFragmentListItem}
        post: {response: CreateEntityResponse; body: CmsFragmentCreateRequest}
    }
    'discover/cms/fragments/collection-view': {get: {response: CollectionViewResultCmsFragmentListItem}}
    'discover/cms/fragments/collection-view/meta': {get: {response: CollectionViewMeta}}
    'discover/cms/fragments/name-availability': {get: {response: CmsFragmentNameAvailabilityResponse}}
    'discover/cms/fragments/{artkey}': {
        delete: {response: OkResponse}
        get: {response: CmsFragmentDetail}
        put: {response: OkResponse; body: CmsFragmentUpdateBody}
    }
    'discover/cms/fragments/{artkey}/placeholders/link': {post: {response: OkResponse; body: CmsFragmentPlaceholderLinkBody}}
    'discover/cms/fragments/{artkey}/placeholders/unlink': {post: {response: OkResponse; body: CmsFragmentPlaceholderUnlinkBody}}
    'discover/cms/fragments/{artkey}/publish': {put: {response: OkResponse}}
    'discover/cms/fragments/{artkey}/unpublish': {put: {response: OkResponse}}
    'discover/cms/fragments/{cms_fragment_artkey}/placeholders/collection-view': {
        get: {response: CollectionViewResultGetCmsPlaceholdersResponse}
    }
    'discover/cms/fragments/{cms_fragment_artkey}/placeholders/collection-view/meta': {get: {response: CollectionViewMeta}}
    'discover/cms/jsx-catalog': {get: {response: JsxCatalogueResponse}}
    'discover/cms/jsx-catalog/collection-view': {get: {response: CollectionViewResultJsxComponent}}
    'discover/cms/jsx-catalog/collection-view/meta': {get: {response: CollectionViewMeta}}
    'discover/cms/media/cleanup': {post: {response: CmsMediaCleanupResponse; body: CmsMediaCleanupRequest}}
    'discover/cms/media/files': {get: {response: CmsMediaFileResponse[]}}
    'discover/cms/media/files/describe': {post: {response: CmsMediaDescribeResult[]; body: CmsMediaDescribeBody}}
    'discover/cms/media/files/lock': {put: {response: OkResponse; body: CmsMediaFileLock}}
    'discover/cms/media/files/search': {get: {response: CmsMediaFileSearchResponse[]}}
    'discover/cms/media/files/strip-exif': {post: {response: CmsMediaStripExifResult[]; body: CmsMediaStripExifBody}}
    'discover/cms/media/files/upload': {post: {response: OkResponse}}
    'discover/cms/media/files/{artkey}': {delete: {response: OkResponse}; put: {response: OkResponse; body: CmsMediaFileMove}}
    'discover/cms/media/files/{artkey}/content': {put: {response: OkResponse}}
    'discover/cms/media/files/{artkey}/copy': {post: {response: CreateEntityResponse; body: CmsMediaFileCopy}}
    'discover/cms/media/files/{artkey}/resize': {post: {response: CmsMediaResizeResult; body: CmsMediaResizeBody}}
    'discover/cms/media/files/{artkey}/storage-key': {put: {response: OkResponse; body: CmsMediaFileStorageKey}}
    'discover/cms/media/folder': {get: {response: CmsMediaFolderResponse}}
    'discover/cms/media/folders': {
        get: {response: CmsMediaFolderResponse[]}
        post: {response: OkResponse | CreateEntityResponse; body: CmsMediaFolderCreate}
    }
    'discover/cms/media/folders/lock': {put: {response: OkResponse; body: CmsMediaFolderLock}}
    'discover/cms/media/folders/{artkey}': {delete: {response: OkResponse}; put: {response: unknown; body: CmsMediaFolderMove}}
    'discover/cms/media/folders/{artkey}/copy': {post: {response: CreateEntityResponse; body: CmsMediaFolderCopy}}
    'discover/cms/media/root': {get: {response: CmsMediaFolderResponse}}
    'discover/cms/pages': {
        get: {response: CollectionViewResultCmsPageListItem}
        post: {response: CreateEntityResponse; body: CmsPageCreateRequest}
    }
    'discover/cms/pages/collection-view': {get: {response: CollectionViewResultCmsPageListItem}}
    'discover/cms/pages/collection-view/meta': {get: {response: CollectionViewMeta}}
    'discover/cms/pages/path-availability': {get: {response: CmsPathAvailabilityResponse}}
    'discover/cms/pages/placeholders/collection-view': {get: {response: CollectionViewResultGetCmsPlaceholdersResponse}}
    'discover/cms/pages/placeholders/collection-view/meta': {get: {response: CollectionViewMeta}}
    'discover/cms/pages/{artkey}': {
        delete: {response: OkResponse}
        get: {response: CmsPageDetail}
        put: {response: OkResponse; body: CmsPageUpdateBody}
    }
    'discover/cms/pages/{artkey}/placeholders/link': {post: {response: OkResponse; body: CmsPagePlaceholderLinkBody}}
    'discover/cms/pages/{artkey}/placeholders/unlink': {post: {response: OkResponse; body: CmsPagePlaceholderUnlinkBody}}
    'discover/cms/pages/{artkey}/publish': {put: {response: OkResponse}}
    'discover/cms/pages/{artkey}/unpublish': {put: {response: OkResponse}}
    'discover/cms/transpile': {post: {response: TranspileJSXResponse; body: CmsTranspileBody}}
    'discover/crm/leads/export': {put: {response: OkResponse; body: ExportLeadsRequest}}
    'discover/crm/leads/set-contact-status': {post: {response: OkResponse; body: SetLeadStatusRequest}}
    'discover/dashboard/statistics': {get: {response: DashboardStatisticsResponse}}
    'discover/dashboard/stock/value-in-date-ranges': {get: {response: StockValueResponse}}
    'discover/data/brands/collection-view': {get: {response: BrandCollectionResponse[]}}
    'discover/data/bulk-translate': {post: {response: BulkTranslateResponse; body: BulkTranslateRequest}}
    'discover/data/currencies/latest': {get: {response: GetAllCurrenciesResponse[]}}
    'discover/data/incoterms': {get: {response: GetIncotermsResponse[]}}
    'discover/data/insurance-types': {get: {response: GetInsuranceTypeResponse[]}}
    'discover/data/item-tags': {post: {response: OkResponse; body: CreateOrUpdateItemTagRequest}}
    'discover/data/item-tags/collection-view': {get: {response: ItemTagCollectionResponse[]}}
    'discover/data/item-tags/{item_tag_artkey}': {
        get: {response: ItemTagResponse}
        put: {response: OkResponse; body: CreateOrUpdateItemTagRequest}
    }
    'discover/data/rephrase': {post: {response: RephraseResponse; body: RephraseRequest}}
    'discover/data/system-parameters': {post: {response: SystemParameterResponse; body: UpdateSystemParameterRequest}}
    'discover/data/system-parameters/collection-view': {get: {response: SystemParameterResponse[]}}
    'discover/data/timezones': {get: {response: string[]}}
    'discover/data/translate': {post: {response: TranslateResponse; body: TranslateRequest}}
    'discover/data/users/otp': {post: {response: VerifyOTPResponse; body: VerifyOTPRequest}}
    'discover/data/users/otp-secret-url': {post: {response: GetOTPSecretResponse; body: GetOTPSecretRequest}}
    'discover/data/users/reset-user-otp': {post: {response: OkResponse; body: ResetUserOTPRequest}}
    'discover/data/vat-rates': {get: {response: GetVatRateResponse[]}}
    'discover/diesel-surcharge': {get: {response: FuelPriceSurchargeResponse}}
    'discover/email/bounce/collection-view': {get: {response: GetEmailBounceCollectionViewResponse[]}}
    'discover/email/bounce/webhook': {post: {response: unknown}}
    'discover/email/bounce/{artkey}/set-processed': {post: {response: OkResponse}}
    'discover/emails/{email_artkey}': {get: {response: GetCampaignEmailResponse}}
    'discover/emails/{email_artkey}/price-list-download-history': {get: {response: GetPortalUserDownloadHistoryResponse[]}}
    'discover/exact/authentication': {get: {response: GetExactAuthenticationStatusResponse}}
    'discover/exact/authentication/retrieve-tokens': {post: {response: OkResponse; body: RetrieveTokensRequest}}
    'discover/exact/authentication/url': {get: {response: GetExactAuthenticationUrlResponse}}
    'discover/explore/get-case-and-supplier': {get: {response: CaseAndSupplierResponse}}
    'discover/explore/offer-history': {get: {response: OfferHistoryResponse[]}}
    'discover/explore/offer-history/totals': {get: {response: OfferHistoryTotalsResponse}}
    'discover/explore/pricelist-history': {get: {response: ExplorePricelistResponse[]}}
    'discover/explore/pricelist-history/totals': {get: {response: ExplorePricelistTotalsResponse}}
    'discover/explore/purchase-history': {get: {response: PurchaseHistoryResponse[]}}
    'discover/explore/purchase-history/totals': {get: {response: PurchaseHistoryTotalsResponse}}
    'discover/explore/sales-history': {get: {response: SalesHistoryResponse[]}}
    'discover/explore/sales-history/totals': {get: {response: SalesHistoryTotalsResponse}}
    'discover/explore/stock': {get: {response: ExploreStockResponse[]}}
    'discover/explore/stock/totals': {get: {response: ExploreStockTotalsResponse}}
    'discover/export-cbs': {post: {response: unknown; body: ExportCBSRequest}}
    'discover/issues': {post: {response: CreateIssueResponse; body: CreateIssueRequest}}
    'discover/item-mutations/{item_mutation_artkey}/attachments': {
        post: {response: CreateEntityResponse; body: CreateAttachmentRequest}
    }
    'discover/item-mutations/{item_mutation_artkey}/attachments/collection-view': {
        get: {response: CollectionViewResultGetAttachmentCollectionViewResponse}
    }
    'discover/item-mutations/{item_mutation_artkey}/attachments/collection-view/meta': {get: {response: CollectionViewMeta}}
    'discover/item-mutations/{item_mutation_artkey}/attachments/download-all': {post: {response: OkResponse}}
    'discover/item-mutations/{item_mutation_artkey}/attachments/{item_mutation_attachment_artkey}': {
        delete: {response: OkResponse}
        put: {response: OkResponse; body: UpdateAttachmentRequest}
    }
    'discover/item-mutations/{item_mutation_artkey}/attachments/{item_mutation_attachment_artkey}/download': {
        get: {response: DownloadAttachmentResponse}
    }
    'discover/item-mutations/{item_mutation_artkey}/outtake': {get: {response: OkResponse}}
    'discover/item-tags': {get: {response: GetItemTagResponse[]}}
    'discover/items/collection-view': {get: {response: CollectionViewResultGetItemCollectionViewResponse}}
    'discover/items/collection-view/meta': {get: {response: CollectionViewMeta}}
    'discover/items/export': {get: {response: OkResponse}}
    'discover/items/purchase-orders': {get: {response: GetPurchaseOrderItemForItemResult[]}}
    'discover/items/reviewable-product-photos/collection-view': {
        get: {response: CollectionViewResultGetReviewableProductPhotoResponse}
    }
    'discover/items/{artkey}/mark-as-reviewed': {post: {response: OkResponse; body: MarkItemProductPhotosAsReviewedRequest[]}}
    'discover/items/{artkey}/product-photos': {
        get: {response: GetProductPhotoResponse[]}
        post: {response: CreateProductPhotoResponse; body: CreateProductPhotoRequest}
    }
    'discover/items/{artkey}/product-photos/download': {get: {response: unknown}}
    'discover/items/{artkey}/sales-order-items': {get: {response: SalesOrderItemsForItemResponse[]}}
    'discover/items/{artkey}/sales-order-items/export': {get: {response: unknown}}
    'discover/items/{item_artkey}': {get: {response: GetItemResponse}; put: {response: OkResponse; body: UpdateItemRequest}}
    'discover/items/{item_artkey}/hidden-information': {get: {response: GetHiddenInformationResponse}}
    'discover/items/{item_artkey}/hidden-information/countries': {post: {response: OkResponse; body: AddHiddenCountryCodeRequest}}
    'discover/items/{item_artkey}/hidden-information/countries/{country_code}': {delete: {response: OkResponse}}
    'discover/items/{item_artkey}/hidden-information/relations': {post: {response: OkResponse; body: AddHiddenRelationRequest}}
    'discover/items/{item_artkey}/hidden-information/relations/{relation_artkey}': {delete: {response: OkResponse}}
    'discover/leads/{artkey}/attachments/collection-view/meta': {get: {response: CollectionViewMeta}}
    'discover/leads/{lead_artkey}/attachments': {post: {response: CreateEntityResponse; body: CreateAttachmentRequest}}
    'discover/leads/{lead_artkey}/attachments/collection-view': {
        get: {response: CollectionViewResultGetAttachmentCollectionViewResponse}
    }
    'discover/leads/{lead_artkey}/attachments/download-all': {post: {response: OkResponse}}
    'discover/leads/{lead_artkey}/attachments/{lead_attachment_artkey}': {
        delete: {response: OkResponse}
        put: {response: OkResponse; body: UpdateAttachmentRequest}
    }
    'discover/leads/{lead_artkey}/attachments/{lead_attachment_artkey}/download': {get: {response: DownloadAttachmentResponse}}
    'discover/locations/third-parties': {post: {response: OkResponse | CreateEntityResponse; body: CreateOrUpdateLocationRequest}}
    'discover/locations/third-parties/collection-view': {get: {response: CollectionViewResultGetLocationsCollectionViewResult}}
    'discover/locations/third-parties/collection-view/meta': {get: {response: CollectionViewMeta}}
    'discover/locations/third-parties/{artkey}': {
        delete: {response: OkResponse}
        get: {response: GetLocationResponse}
        put: {response: OkResponse; body: CreateOrUpdateLocationRequest}
    }
    'discover/locations/{artkey}/attachments/collection-view/meta': {get: {response: CollectionViewMeta}}
    'discover/locations/{warehouse_artkey}/attachments': {post: {response: CreateEntityResponse; body: CreateAttachmentRequest}}
    'discover/locations/{warehouse_artkey}/attachments/collection-view': {
        get: {response: CollectionViewResultGetAttachmentCollectionViewResponse}
    }
    'discover/locations/{warehouse_artkey}/attachments/download-all': {post: {response: OkResponse}}
    'discover/locations/{warehouse_artkey}/attachments/{warehouse_attachment_artkey}': {
        delete: {response: OkResponse}
        put: {response: OkResponse; body: UpdateAttachmentRequest}
    }
    'discover/locations/{warehouse_artkey}/attachments/{warehouse_attachment_artkey}/download': {
        get: {response: DownloadAttachmentResponse}
    }
    'discover/loendersloot-messages/collection-view': {get: {response: CollectionLoenderslootMessageResponse[]}}
    'discover/loendersloot-messages/{loendersloot_message_artkey}': {get: {response: GetLoenderslootMessage}}
    'discover/loendersloot-stock/recons/collection-view': {get: {response: GetLoenderslootStockReconResponse[]}}
    'discover/loendersloot-stock/recons/reschedule': {post: {response: GetLoenderslootStockReconResultResponse[]}}
    'discover/loendersloot-stock/recons/{artkey}/collection-view': {get: {response: GetLoenderslootStockReconResultResponse[]}}
    'discover/loendersloot-stock/{loendersloot_lot}/product-photos': {get: {response: GetProductPhotoResponse[]}}
    'discover/loendersloot-stock/{loendersloot_lot}/product-photos/download': {get: {response: unknown}}
    'discover/loendersloot-tags': {post: {response: OkResponse; body: CreateLoenderslootTagRequest}}
    'discover/loendersloot-tags/{artkey}': {
        delete: {response: OkResponse}
        get: {response: GetLoenderslootTagResponse}
        put: {response: OkResponse; body: CreateLoenderslootTagRequest}
    }
    'discover/market': {get: {response: BottleMarketResult; body: string[] | null}}
    'discover/mock-services/abn-amro-currency-exchange/rates': {post: {response: Model; body: CurrencyExchangeRequest}}
    'discover/mock-services/aws/{bucket}': {post: {response: unknown}}
    'discover/mock-services/aws/{bucket}/{directory}/{object_name}': {put: {response: unknown}}
    'discover/mock-services/aws/{bucket}/{object_path}': {get: {response: unknown}}
    'discover/mock-services/exact/api/oauth2/auth': {get: {response: unknown}}
    'discover/mock-services/exact/api/oauth2/token': {post: {response: unknown}}
    'discover/mock-services/exact/api/v1/{division}/crm/Accounts': {get: {response: unknown}}
    'discover/mock-services/exact/api/v1/{division}/crm/Accounts{guid}': {put: {response: unknown}}
    'discover/mock-services/exact/api/v1/{division}/financial/GLAccounts': {get: {response: unknown}}
    'discover/mock-services/exact/api/v1/{division}/financialtransaction/BankEntryLines': {get: {response: unknown}}
    'discover/mock-services/exact/api/v1/{division}/purchaseentry/PurchaseEntries': {post: {response: unknown}}
    'discover/mock-services/exact/api/v1/{division}/salesentry/SalesEntries': {post: {response: unknown}}
    'discover/mock-services/gitlab/projects/{project_id}/issues': {
        get: {response: unknown}
        post: {response: unknown; body: MockGitLabIssueRequest}
    }
    'discover/mock-services/gitlab/projects/{project_id}/issues/{issue_id}': {put: {response: unknown}}
    'discover/mock-services/gitlab/projects/{project_id}/uploads': {post: {response: unknown}}
    'discover/mock-services/green/api/MovingSpirits/Shipment': {post: {response: unknown}}
    'discover/mock-services/green/api/MovingSpirits/UnitTypes': {get: {response: unknown}}
    'discover/mock-services/loendersloot/02809001/ep02809001-test-001.php': {post: {response: unknown}}
    'discover/mock-services/loendersloot/02809001/ep02809001-test-002.php': {post: {response: unknown}}
    'discover/mock-services/loendersloot/02809001/ep02809001-test-003.php': {post: {response: unknown}}
    'discover/mock-services/loendersloot/02809001/ep02809001-test-004.php': {post: {response: unknown}}
    'discover/mock-services/nominatim/search': {get: {response: unknown}}
    'discover/mock-services/slack/slack/services/secret/secret/secret': {post: {response: unknown}}
    'discover/mock-services/swift/auth/tokens': {post: {response: unknown}}
    'discover/mock-services/swift/store/{account}/{container}/{object_name}': {
        delete: {response: unknown}
        get: {response: unknown}
        put: {response: unknown}
    }
    'discover/offer-items/collection-view': {get: {response: CollectionViewResultGetOfferItemsCollectionViewResponse}}
    'discover/offer-items/collection-view/meta': {get: {response: CollectionViewMeta}}
    'discover/offer-items/compare-with-market/collection-view': {
        get: {response: CollectionViewResultGetOfferItemCompareWithMarketResponse}
    }
    'discover/offer-items/margins': {get: {response: GetOfferItemMarginsResponse[]}}
    'discover/offer-items/ranks': {get: {response: GetOfferItemRanksResponse[]}}
    'discover/offer-items/tbo/collection-view': {get: {response: CollectionViewResultTBOOfferItemCollectionViewResponse}}
    'discover/offer-items/tbo/collection-view/meta': {get: {response: CollectionViewMeta}}
    'discover/offer-items/tbo/{offer_item_artkey}': {
        delete: {response: unknown}
        get: {response: GetTBOOfferItemResponse}
        put: {response: OkResponse; body: UpdateTBOOfferItemRequest}
    }
    'discover/offer-items/tbo/{offer_item_artkey}/approve': {put: {response: unknown}}
    'discover/offer-items/tbo/{offer_item_artkey}/hide': {put: {response: unknown}}
    'discover/offer-items/tbo/{offer_item_artkey}/recalculate-price': {put: {response: unknown}}
    'discover/offer-items/tbo/{offer_item_artkey}/unapprove': {put: {response: unknown}}
    'discover/offer-items/tbo/{offer_item_artkey}/unhide': {put: {response: unknown}}
    'discover/offer-items/{artkey}/product-photos': {
        get: {response: GetProductPhotoResponse[]}
        post: {response: CreateProductPhotoResponse; body: CreateProductPhotoRequest}
    }
    'discover/offer-items/{artkey}/product-photos/download': {get: {response: unknown}}
    'discover/offer-items/{offer_item_artkey}': {
        get: {response: GetOfferItemResponse}
        put: {response: OkResponse; body: UpdateOfferItemRequest}
    }
    'discover/offer-items/{offer_item_artkey}/hidden-information': {get: {response: GetHiddenInformationResponse}}
    'discover/offer-items/{offer_item_artkey}/hidden-information/countries': {
        post: {response: OkResponse; body: AddHiddenCountryCodeRequest}
    }
    'discover/offer-items/{offer_item_artkey}/hidden-information/countries/{country_code}': {delete: {response: OkResponse}}
    'discover/offer-items/{offer_item_artkey}/hidden-information/relations': {
        post: {response: OkResponse; body: AddHiddenRelationRequest}
    }
    'discover/offer-items/{offer_item_artkey}/hidden-information/relations/{relation_artkey}': {delete: {response: OkResponse}}
    'discover/offer-items/{offer_item_artkey}/spotlight': {post: {response: OkResponse | CreateEntityResponse}}
    'discover/offer-items/{offer_item_artkey}/spotlight/reposition': {
        post: {response: OkResponse | CreateEntityResponse; body: RepositionSpotlightRequest}
    }
    'discover/offers/{offer_artkey}/memo': {put: {response: OkResponse; body: UpdateOfferMemoRequest}}
    'discover/offers/{offer_artkey}/relations/{relation_artkey}/price-list/generate': {
        post: {response: ErrorResponse | OkResponse}
    }
    'discover/placeholders/bulk-delete': {post: {response: DeletePlaceholdersResponse; body: DeletePlaceholdersRequest}}
    'discover/placeholders/sync-from-code': {post: {response: SyncPlaceholdersResponse; body: SyncPlaceholdersRequest}}
    'discover/placeholders/{placeholder_artkey}': {delete: {response: OkResponse}}
    'discover/portal-user-download/{artkey}/download': {get: {response: unknown}}
    'discover/portal-user/{portal_user_artkey}/start-reset-password': {post: {response: unknown}}
    'discover/portal-users/collection-view': {get: {response: CollectionViewResultPortalUserCollectionViewResponse}}
    'discover/portal-users/collection-view/meta': {get: {response: CollectionViewMeta}}
    'discover/portal-users/{artkey}': {
        delete: {response: OkResponse}
        get: {response: GetPortalUserResponse}
        put: {response: OkResponse; body: UpdatePortalUserRequest}
    }
    'discover/portal-users/{portal_user_artkey}/generate-invite': {get: {response: GeneratePortalUserInviteResponse}}
    'discover/product-categories': {
        get: {response: GetProductCategoriesResponse}
        post: {response: OkResponse; body: CreateProductCategoryRequest}
    }
    'discover/product-categories/collection-view': {get: {response: CollectionViewResultGetProductCategoryCollectionResponse}}
    'discover/product-categories/collection-view/meta': {get: {response: CollectionViewMeta}}
    'discover/product-categories/select': {get: {response: GetProductCategorySelectResponse[]}}
    'discover/product-categories/{artkey}': {
        delete: {response: OkResponse}
        get: {response: GetProductCategoryResponse}
        put: {response: OkResponse; body: CreateOrUpdateProductCategoryRequest}
    }
    'discover/product-categories/{artkey}/alternative': {
        put: {response: GetProductCategoriesResponse[]; body: AddAlternativeNameRequest}
    }
    'discover/product-categories/{artkey}/alternative/{alternative_name}': {delete: {response: GetProductCategoriesResponse[]}}
    'discover/product-categories/{artkey}/product-photos': {
        get: {response: GetProductPhotoResponse[]}
        post: {response: CreateProductPhotoResponse; body: CreateProductPhotoRequest}
    }
    'discover/product-categories/{artkey}/product-photos/download': {get: {response: unknown}}
    'discover/product-groups': {
        get: {response: GetProductGroupsResponse[]}
        post: {response: CreateEntityResponse; body: UpsertProductGroupRequest}
    }
    'discover/product-groups/collection-view': {get: {response: CollectionViewResultProductGroupResponse}}
    'discover/product-groups/collection-view/meta': {get: {response: CollectionViewMeta}}
    'discover/product-groups/{artkey}': {
        delete: {response: OkResponse}
        get: {response: GetProductGroupResponse}
        put: {response: OkResponse; body: UpsertProductGroupRequest}
    }
    'discover/product-groups/{product_group_artkey}/product-group-meta': {
        post: {response: CreateEntityResponse; body: UpsertProductGroupMetaRequest}
    }
    'discover/product-groups/{product_group_artkey}/product-group-meta/collection-view': {
        get: {response: CollectionViewResultProductGroupMetaResponse}
    }
    'discover/product-groups/{product_group_artkey}/product-group-meta/collection-view/meta': {
        get: {response: CollectionViewMeta}
    }
    'discover/product-groups/{product_group_artkey}/product-group-meta/{artkey}': {
        delete: {response: OkResponse}
        get: {response: ProductGroupMetaResponse}
        put: {response: OkResponse; body: UpsertProductGroupMetaRequest}
    }
    'discover/product-photos/sort': {post: {response: OkResponse; body: SortProductPhotoRequest}}
    'discover/product-photos/{artkey}': {
        delete: {response: OkResponse}
        put: {response: UpdateProductPhotoResponse; body: UpdateProductPhotoRequest}
    }
    'discover/product-photos/{artkey}/approve': {post: {response: OkResponse}}
    'discover/product-photos/{artkey}/download': {get: {response: OkResponse}}
    'discover/product-photos/{artkey}/rotate': {post: {response: RotateProductPhotoResponse; body: RotateProductPhotoRequest}}
    'discover/products': {get: {response: GetProductsResponse[]}}
    'discover/products/{artkey}/bottles': {get: {response: ProductBottle[]}}
    'discover/products/{product_artkey}/hidden-information': {get: {response: GetHiddenInformationResponse}}
    'discover/products/{product_artkey}/hidden-information/countries': {
        post: {response: OkResponse; body: AddHiddenCountryCodeRequest}
    }
    'discover/products/{product_artkey}/hidden-information/countries/{country_code}': {delete: {response: OkResponse}}
    'discover/products/{product_artkey}/hidden-information/relations': {
        post: {response: OkResponse; body: AddHiddenRelationRequest}
    }
    'discover/products/{product_artkey}/hidden-information/relations/{relation_artkey}': {delete: {response: OkResponse}}
    'discover/products/{product_artkey}/sellable-bottles': {get: {response: ProductBottle[]}}
    'discover/purchase-orders': {
        get: {response: GetPurchaseOrdersCollectionViewResponse[]}
        post: {response: CreateEntityResponse; body: UpdateOrCreatePurchaseOrderRequest}
    }
    'discover/purchase-orders/{artkey}': {put: {response: OkResponse; body: UpdateOrCreatePurchaseOrderRequest}}
    'discover/purchase-orders/{artkey}/attachments/collection-view/meta': {get: {response: CollectionViewMeta}}
    'discover/purchase-orders/{artkey}/costs': {
        get: {response: GetPurchaseOrderCostResponse}
        post: {response: GetPurchaseOrderCostResponse[]; body: SwitchCostStructureRequest}
        put: {response: GetPurchaseOrderCostResponse[]; body: UpdatePurchaseOrderCostsRequest}
    }
    'discover/purchase-orders/{artkey}/move-items': {post: {response: OkResponse | CreateEntityResponse; body: MovePOIRequest}}
    'discover/purchase-orders/{artkey}/move-items-in-bulk': {
        post: {response: OkResponse | CreateEntityResponse; body: MovePOIBulkRequest}
    }
    'discover/purchase-orders/{artkey}/update-remark': {post: {response: OkResponse; body: UpdateRemarkPurchaseOrderRequest}}
    'discover/purchase-orders/{purchase_order_artkey}': {get: {response: GetPurchaseOrderResponse}}
    'discover/purchase-orders/{purchase_order_artkey}/arrival-notice': {get: {response: OkResponse}}
    'discover/purchase-orders/{purchase_order_artkey}/attachments': {
        post: {response: CreateEntityResponse; body: CreateAttachmentRequest}
    }
    'discover/purchase-orders/{purchase_order_artkey}/attachments/collection-view': {
        get: {response: CollectionViewResultGetAttachmentCollectionViewResponse}
    }
    'discover/purchase-orders/{purchase_order_artkey}/attachments/download-all': {post: {response: OkResponse}}
    'discover/purchase-orders/{purchase_order_artkey}/attachments/{purchase_order_attachment_artkey}': {
        delete: {response: OkResponse}
        put: {response: OkResponse; body: UpdateAttachmentRequest}
    }
    'discover/purchase-orders/{purchase_order_artkey}/attachments/{purchase_order_attachment_artkey}/download': {
        get: {response: DownloadAttachmentResponse}
    }
    'discover/purchase-orders/{purchase_order_artkey}/items/collection-view': {
        get: {response: CollectionViewResultGetPurchaseOrderItemsCollectionViewResponse}
    }
    'discover/purchase-orders/{purchase_order_artkey}/items/collection-view/meta': {get: {response: CollectionViewMeta}}
    'discover/purchase-orders/{purchase_order_artkey}/items/{purchase_order_item_artkey}': {
        put: {response: OkResponse; body: UpdatePurchaseOrderItemRequest}
    }
    'discover/purchase-orders/{purchase_order_artkey}/items/{purchase_order_item_artkey}/hidden-information': {
        get: {response: GetHiddenInformationResponse}
    }
    'discover/purchase-orders/{purchase_order_artkey}/items/{purchase_order_item_artkey}/hidden-information/countries': {
        post: {response: OkResponse; body: AddHiddenCountryCodeRequest}
    }
    'discover/purchase-orders/{purchase_order_artkey}/items/{purchase_order_item_artkey}/hidden-information/countries/{country_code}': {
        delete: {response: OkResponse}
    }
    'discover/purchase-orders/{purchase_order_artkey}/items/{purchase_order_item_artkey}/hidden-information/relations': {
        post: {response: OkResponse; body: AddHiddenRelationRequest}
    }
    'discover/purchase-orders/{purchase_order_artkey}/items/{purchase_order_item_artkey}/hidden-information/relations/{relation_artkey}': {
        delete: {response: OkResponse}
    }
    'discover/purchase-orders/{purchase_order_artkey}/items/{purchase_order_item_artkey}/sales-order-items': {
        get: {response: GetRelatedSalesOrderItemResponse[]}
    }
    'discover/purchase-orders/{purchase_order_artkey}/items/{purchase_order_item_artkey}/sales-order-tbo-items': {
        get: {response: GetRelatedSalesOrderTBOItemResponse[]}
    }
    'discover/purchase-orders/{purchase_order_artkey}/purchase-order-items': {get: {response: GetPurchaseOrderItemResponse[]}}
    'discover/purchase-orders/{purchase_order_artkey}/request-for-proposal': {get: {response: OkResponse}}
    'discover/purchase-orders/{purchase_order_artkey}/update-request-for-proposal': {
        post: {response: OkResponse; body: UpdateRequestForProposalRequest}
    }
    'discover/relations': {get: {response: GetRelationsResponse[]}}
    'discover/relations/vat-id/validate': {post: {response: ValidateRelationViesResponse; body: ValidateRelationViesRequest}}
    'discover/relations/{artkey}': {get: {response: GetRelationResponse}}
    'discover/relations/{artkey}/attachments/collection-view/meta': {get: {response: CollectionViewMeta}}
    'discover/relations/{artkey}/hidden-information': {get: {response: GetHiddenInformationResponse}}
    'discover/relations/{artkey}/hidden-information/countries': {post: {response: OkResponse; body: AddHiddenCountryCodeRequest}}
    'discover/relations/{artkey}/hidden-information/countries/{country_code}': {delete: {response: OkResponse}}
    'discover/relations/{artkey}/price-list/excel': {get: {response: OkResponse}}
    'discover/relations/{relation_artkey}/active-vouchers': {get: {response: GetActiveVoucherResponse[]}}
    'discover/relations/{relation_artkey}/attachments': {post: {response: CreateEntityResponse; body: CreateAttachmentRequest}}
    'discover/relations/{relation_artkey}/attachments/collection-view': {
        get: {response: CollectionViewResultGetAttachmentCollectionViewResponse}
    }
    'discover/relations/{relation_artkey}/attachments/download-all': {post: {response: OkResponse}}
    'discover/relations/{relation_artkey}/attachments/{relation_attachment_artkey}': {
        delete: {response: OkResponse}
        put: {response: OkResponse; body: UpdateAttachmentRequest}
    }
    'discover/relations/{relation_artkey}/attachments/{relation_attachment_artkey}/download': {
        get: {response: DownloadAttachmentResponse}
    }
    'discover/relations/{relation_artkey}/contact-persons': {get: {response: GetContactPersonForRelationResponse[]}}
    'discover/relations/{relation_artkey}/contact-persons/{contact_person_artkey}/emails/collection-view': {
        get: {response: CollectionViewResultGetEmailCollectionViewResponse}
    }
    'discover/relations/{relation_artkey}/contact-persons/{contact_person_artkey}/emails/collection-view/meta': {
        get: {response: CollectionViewMeta}
    }
    'discover/relations/{relation_artkey}/contact-persons/{contact_person_artkey}/subscriptions': {
        get: {response: DiscoGetUserSubscriptionResponse}
    }
    'discover/relations/{relation_artkey}/contact-persons/{contact_person_artkey}/subscriptions/{campaign_mnemonic}': {
        post: {response: OkResponse; body: DiscoUpdateCampaignSubscriptionRequest}
    }
    'discover/relations/{relation_artkey}/hidden-information/collection-view': {get: {response: GetHiddenItemsResponse[]}}
    'discover/relations/{relation_artkey}/list-prices': {get: {response: GetRelationListPriceResponse[]}}
    'discover/relations/{relation_artkey}/locations': {
        get: {response: GetRelationLocationResponse[]}
        post: {response: OkResponse | CreateEntityResponse; body: CreateOrUpdateLocationRequest}
    }
    'discover/relations/{relation_artkey}/locations/{location_artkey}': {
        delete: {response: OkResponse}
        get: {response: GetLocationResponse}
        put: {response: OkResponse; body: CreateOrUpdateLocationRequest}
    }
    'discover/relations/{relation_artkey}/log-entries': {
        get: {response: GetRelationLogBookEntryResponse[]}
        post: {response: CreateEntityResponse; body: CreateRelationLogBookEntryRequest}
    }
    'discover/relations/{relation_artkey}/log-entries/{log_entry_artkey}': {delete: {response: OkResponse}}
    'discover/relations/{relation_artkey}/offer/{offer_artkey}/price-list/excel': {get: {response: OkResponse}}
    'discover/relations/{relation_artkey}/offers/{offer_artkey}/excel': {get: {response: OkResponse}}
    'discover/relations/{relation_artkey}/price-list/collection-view': {get: {response: GetPriceListCollectionViewResponse[]}}
    'discover/relations/{relation_artkey}/price-list/generate': {post: {response: OkResponse}}
    'discover/relations/{relation_artkey}/purchase-orders': {get: {response: GetRelationPurchaseOrderResponse[]}}
    'discover/relations/{relation_artkey}/purchase-orders/collection-view': {
        get: {response: CollectionViewResultGetRelationPurchaseOrderResponse}
    }
    'discover/relations/{relation_artkey}/specials-price-list/collection-view': {
        get: {response: GetSpecialsPriceListCollectionViewResponse[]}
    }
    'discover/relations/{supplier_artkey}/hidden-information/relations': {
        post: {response: OkResponse; body: AddHiddenRelationRequest}
    }
    'discover/relations/{supplier_artkey}/hidden-information/relations/{relation_artkey}': {delete: {response: OkResponse}}
    'discover/sales-orders': {post: {response: CreateEntityResponse; body: UpdateSalesOrderRequest}}
    'discover/sales-orders/collection-view': {get: {response: CollectionViewResultGetSalesOrdersCollectionViewResponse}}
    'discover/sales-orders/collection-view/meta': {get: {response: CollectionViewMeta}}
    'discover/sales-orders/exact/collection-view': {get: {response: GetExactSalesOrderCollectionViewResponse}}
    'discover/sales-orders/key-figures': {get: {response: GetSalesOrderFiguresResponse}}
    'discover/sales-orders/{artkey}': {
        get: {response: GetSalesOrderResponse}
        put: {response: OkResponse; body: UpdateSalesOrderRequest}
    }
    'discover/sales-orders/{artkey}/attachments/collection-view/meta': {get: {response: CollectionViewMeta}}
    'discover/sales-orders/{artkey}/items/collection-view': {
        get: {response: CollectionViewResultGetSalesOrderItemsCollectionViewResponse}
    }
    'discover/sales-orders/{sales_order_artkey}/additionals': {
        post: {response: OkResponse; body: CreateOrUpdateAdditionalRequest}
    }
    'discover/sales-orders/{sales_order_artkey}/additionals/{sales_order_additional_artkey}': {
        delete: {response: CreateEntityResponse}
        put: {response: unknown; body: CreateOrUpdateAdditionalRequest}
    }
    'discover/sales-orders/{sales_order_artkey}/additionals/{sales_order_item_artkey}': {
        get: {response: GetSalesOrderAdditionalResponse}
    }
    'discover/sales-orders/{sales_order_artkey}/attachments': {
        post: {response: CreateEntityResponse; body: CreateAttachmentRequest}
    }
    'discover/sales-orders/{sales_order_artkey}/attachments/collection-view': {
        get: {response: CollectionViewResultGetAttachmentCollectionViewResponse}
    }
    'discover/sales-orders/{sales_order_artkey}/attachments/download-all': {post: {response: OkResponse}}
    'discover/sales-orders/{sales_order_artkey}/attachments/{sales_order_attachment_artkey}': {
        delete: {response: OkResponse}
        put: {response: OkResponse; body: UpdateAttachmentRequest}
    }
    'discover/sales-orders/{sales_order_artkey}/attachments/{sales_order_attachment_artkey}/download': {
        get: {response: DownloadAttachmentResponse}
    }
    'discover/sales-orders/{sales_order_artkey}/buy-from-account/purchase-orders': {
        get: {response: GetBuyFromAccountPurchaseOrderResponse[]}
    }
    'discover/sales-orders/{sales_order_artkey}/buy-from-account/sales-orders': {
        get: {response: GetBuyFromAccountSalesOrderResponse[]}
    }
    'discover/sales-orders/{sales_order_artkey}/confirm-settings': {post: {response: OkResponse; body: ConfirmSettingsRequest}}
    'discover/sales-orders/{sales_order_artkey}/credit-items': {
        post: {response: CreateEntityResponse; body: CreateSalesOrderCreditItem}
    }
    'discover/sales-orders/{sales_order_artkey}/credit-items/{sales_order_credit_item_artkey}': {
        delete: {response: CreateEntityResponse}
        put: {response: OkResponse; body: UpdateSalesOrderCreditItem}
    }
    'discover/sales-orders/{sales_order_artkey}/credit-items/{sales_order_item_artkey}': {
        get: {response: GetSalesOrderCreditItemResponse}
    }
    'discover/sales-orders/{sales_order_artkey}/export': {get: {response: unknown}}
    'discover/sales-orders/{sales_order_artkey}/invoice': {get: {response: OkResponse}}
    'discover/sales-orders/{sales_order_artkey}/items/collection-view/meta': {get: {response: unknown}}
    'discover/sales-orders/{sales_order_artkey}/outtake': {get: {response: OkResponse}}
    'discover/sales-orders/{sales_order_artkey}/portal-order-items/{portal_order_item_artkey}': {
        delete: {response: CreateEntityResponse}
        get: {response: GetPortalOrderItemResponse}
        put: {response: CreateEntityResponse; body: UpdatePortalOrderItemRequest}
    }
    'discover/sales-orders/{sales_order_artkey}/portal-order-items/{portal_order_item_artkey}/confirm': {
        post: {response: CreateEntityResponse}
    }
    'discover/sales-orders/{sales_order_artkey}/products/collection-view': {
        get: {response: CollectionViewResultGetSellableItemCollectionViewResponse}
    }
    'discover/sales-orders/{sales_order_artkey}/products/collection-view/meta': {get: {response: CollectionViewMeta}}
    'discover/sales-orders/{sales_order_artkey}/products/country-of-origin-availabilities': {
        get: {response: GetCountryOfOriginAvailabilitiesResponse[]}
    }
    'discover/sales-orders/{sales_order_artkey}/products/lot-availabilities': {get: {response: GetLotAvailabilityResponse[]}}
    'discover/sales-orders/{sales_order_artkey}/proforma': {get: {response: OkResponse}}
    'discover/sales-orders/{sales_order_artkey}/queue-photo-download': {
        post: {response: OkResponse; body: SalesOrderPhotoDownloadRequest}
    }
    'discover/sales-orders/{sales_order_artkey}/rating': {get: {response: SalesOrderRatingResponse}}
    'discover/sales-orders/{sales_order_artkey}/sales-order-items': {
        post: {response: OkResponse; body: CreateSalesOrderItemRequest}
    }
    'discover/sales-orders/{sales_order_artkey}/sales-order-items/{sales_order_item_artkey}': {
        delete: {response: CreateEntityResponse}
        get: {response: GetSalesOrderItemResponse}
        put: {response: OkResponse; body: UpdateSalesOrderItemRequest}
    }
    'discover/sales-orders/{sales_order_artkey}/tbo-items': {
        post: {response: OkResponse | CreateEntityResponse; body: CreateSalesOrderTBOItemRequest}
    }
    'discover/sales-orders/{sales_order_artkey}/tbo-items/{artkey}/link-to-stock': {post: {response: LinkTBOToStockResponse}}
    'discover/sales-orders/{sales_order_artkey}/tbo-items/{sales_order_item_artkey}': {
        get: {response: GetSalesOrderTBOItemResponse}
    }
    'discover/sales-orders/{sales_order_artkey}/tbo-items/{sales_order_tbo_item_artkey}': {delete: {response: unknown}}
    'discover/sales-orders/{sales_order_artkey}/tbo-items/{tbo_item_artkey}': {
        put: {response: OkResponse; body: EditSalesOrderTBOItemRequest}
    }
    'discover/sales-orders/{sales_order_artkey}/tbo-items/{tbo_item_artkey}/approve': {post: {response: LinkTBOToStockResponse}}
    'discover/sales-orders/{sales_order_artkey}/tbo-items/{tbo_item_artkey}/available-purchase': {
        get: {response: GetAvailablePurchaseOrderItemsResponse[]}
    }
    'discover/sales-orders/{sales_order_artkey}/update-remark': {
        post: {response: OkResponse; body: UpdateRemarkSalesOrderRequest}
    }
    'discover/sales-orders/{sales_order_artkey}/vouchers': {post: {response: OkResponse; body: CreateVoucherRequest}}
    'discover/sales-orders/{sales_order_artkey}/vouchers/{sales_order_additional_artkey}': {delete: {response: OkResponse}}
    'discover/sales-orders/{sales_order_artkey}/vouchers/{sales_order_item_artkey}': {
        get: {response: GetSalesOrderVoucherResponse}
    }
    'discover/sales-targets': {get: {response: GetSalesTargetsResponse[]}}
    'discover/sales-targets/{year}': {post: {response: OkResponse; body: PostSalesTargetsRequest}}
    'discover/selects/cms-fragments': {get: {response: SelectResponse[]}}
    'discover/selects/cms-pages': {get: {response: SelectResponse[]}}
    'discover/settings/placeholders/collection-view': {get: {response: CollectionViewResultGetPlaceholdersResponse}}
    'discover/settings/placeholders/collection-view/meta': {get: {response: CollectionViewMeta}}
    'discover/statistics': {get: {response: SearchStatisticsResponse}}
    'discover/statistics/export': {get: {response: unknown}}
    'discover/stock/locations': {get: {response: GetLocationResponse[]}}
    'discover/supplier-price-list-items/purchase-orders': {get: {response: GetPurchaseOrderForSPLIResult[]}}
    'discover/supplier-price-list-items/{spli_artkey}': {delete: {response: unknown}}
    'discover/supplier-price-list-items/{spli_artkey}/mark-available': {put: {response: OkResponse}}
    'discover/supplier-price-list-items/{spli_artkey}/mark-unavailable': {put: {response: OkResponse}}
    'discover/supplier-price-lists': {post: {response: CreateEntityResponse; body: UpdateOrCreateSupplierPriceListRequest}}
    'discover/supplier-price-lists/collection-view': {get: {response: CollectionViewResultSupplierPriceListCollectionResponse}}
    'discover/supplier-price-lists/collection-view/meta': {get: {response: CollectionViewMeta}}
    'discover/supplier-price-lists/collection-view/statistics': {get: {response: GetSupplierPriceListStatisticsResponse[]}}
    'discover/supplier-price-lists/columns': {get: {response: unknown}}
    'discover/supplier-price-lists/purchase-orders': {get: {response: GetPurchaseOrderForSPLResult[]}}
    'discover/supplier-price-lists/{artkey}': {
        delete: {response: OkResponse}
        get: {response: Fact2ServerApiDiscoverSupplierPriceListGetSupplierPriceListResponse}
    }
    'discover/supplier-price-lists/{artkey}/candidates/collection-view': {
        get: {response: CollectionViewResultGetCandidatesCollectionResponse}
    }
    'discover/supplier-price-lists/{artkey}/candidates/verify': {
        post: {response: VerifyCandidatesResponse; body: ParseCandidatesRequest}
    }
    'discover/supplier-price-lists/{artkey}/config': {
        get: {response: GetSupplierPriceListConfigResponse}
        put: {response: unknown; body: CreateOrUpdateSupplierPriceListConfig}
    }
    'discover/supplier-price-lists/{artkey}/export': {get: {response: OkResponse}}
    'discover/supplier-price-lists/{artkey}/generate-tbo': {post: {response: OkResponse}}
    'discover/supplier-price-lists/{artkey}/items/collection-view': {
        get: {response: CollectionViewResultGetSupplierPriceListItemCollectionResponse}
    }
    'discover/supplier-price-lists/{artkey}/items/similar-stock': {get: {response: GetSpliSimilarStockResponse[]}}
    'discover/supplier-price-lists/{artkey}/items/stock-info': {get: {response: GetSpliStockInfoResponse[]}}
    'discover/supplier-price-lists/{artkey}/items/throughput': {get: {response: GetSpliThroughputResponse[]}}
    'discover/supplier-price-lists/{artkey}/process': {post: {response: unknown; body: ProcessSupplierPriceListRequest}}
    'discover/supplier-price-lists/{artkey}/reactivate': {post: {response: OkResponse}}
    'discover/supplier-price-lists/{artkey}/source-lines/collection-view': {
        get: {response: CollectionViewResultGetUnresolvedItemsResponse}
    }
    'discover/supplier-price-lists/{artkey}/source-lines/{source_line_artkey}': {get: {response: GetUnresolvedItemsResponse}}
    'discover/supplier-price-lists/{artkey}/source-lines/{source_line_artkey}/suppressed': {post: {response: CollectionViewMeta}}
    'discover/supplier-price-lists/{artkey}/source-lines/{source_line_artkey}/unsuppressed': {
        post: {response: CollectionViewMeta}
    }
    'discover/supplier-price-lists/{spl_artkey}/source-lines/{sl_artkey}/audit-logs': {get: {response: GetSPLAuditLogResponse[]}}
    'discover/supplier-price-lists/{spl_artkey}/source-lines/{splsl_artkey}/dg-suggestions': {
        get: {response: SuggestionsResponse[]}
    }
    'discover/supplier-price-lists/{spl_artkey}/source-lines/{splsl_artkey}/discover-suggestions': {
        get: {response: SuggestionsResponse[]}
    }
    'discover/supplier-price-lists/{spl_artkey}/supplier-price-list-items': {
        post: {response: OkResponse; body: CreateOrUpdateSupplierPriceListItemRequest}
    }
    'discover/supplier-price-lists/{spl_artkey}/supplier-price-list-items/{spli_artkey}': {
        get: {response: GetSupplierPriceListItemResponse}
        put: {response: OkResponse; body: CreateOrUpdateSupplierPriceListItemRequest}
    }
    'discover/supplier-price-lists/{spl_artkey}/supplier-price-list-items/{spli_artkey}/audit-logs': {
        get: {response: GetSPLAuditLogResponse[]}
    }
    'discover/supplier-price-lists/{supplier_price_list_artkey}': {
        put: {response: OkResponse; body: UpdateOrCreateSupplierPriceListRequest}
    }
    'discover/supplier-price-lists/{supplier_price_list_artkey}/hidden-information': {
        get: {response: GetHiddenInformationResponse}
    }
    'discover/supplier-price-lists/{supplier_price_list_artkey}/hidden-information/countries': {
        post: {response: OkResponse; body: AddHiddenCountryCodeRequest}
    }
    'discover/supplier-price-lists/{supplier_price_list_artkey}/hidden-information/countries/{country_code}': {
        delete: {response: OkResponse}
    }
    'discover/supplier-price-lists/{supplier_price_list_artkey}/hidden-information/relations': {
        post: {response: OkResponse; body: AddHiddenRelationRequest}
    }
    'discover/supplier-price-lists/{supplier_price_list_artkey}/hidden-information/relations/{relation_artkey}': {
        delete: {response: OkResponse}
    }
    'discover/supplier-price-lists/{supplier_price_list_artkey}/items/collection-view/meta': {get: {response: CollectionViewMeta}}
    'discover/supplier-price-lists/{supplier_price_list_artkey}/source-lines/collection-view/meta': {
        get: {response: CollectionViewMeta}
    }
    'discover/suppressed-product-keys/collection-view': {get: {response: CollectionViewResultSuppressionListResponse}}
    'discover/suppressed-product-keys/collection-view/meta': {get: {response: CollectionViewMeta}}
    'discover/suppressed-product-keys/{artkey}': {delete: {response: OkResponse}}
    'discover/tbo-items/collection-view': {get: {response: CollectionViewResultGetTBOCollectionViewResponse}}
    'discover/tbo-items/collection-view/meta': {get: {response: CollectionViewMeta}}
    'discover/tbo-items/collection-view/top-suppliers': {get: {response: GetTopSuppliersForSOTIResponse[]}}
    'discover/tbo-items/purchase-orders': {get: {response: GetPurchaseOrderForSOTIResult[]}}
    'discover/tbo-items/{sales_order_tbo_item_artkey}': {get: {response: GetTBOItemResponse}}
    'discover/tbo-items/{sales_order_tbo_item_artkey}/trader-comment': {
        put: {response: OkResponse; body: UpdateTraderCommentRequest}
    }
    'discover/users': {get: {response: GetAllUsersResponse[]}; post: {response: CreateEntityResponse; body: UpsertUserRequest}}
    'discover/users/collection-view': {get: {response: CollectionViewResultGetUserCollectionResponse}}
    'discover/users/collection-view/meta': {get: {response: CollectionViewMeta}}
    'discover/users/downloads': {get: {response: GetUserDownloadsResponse[]}}
    'discover/users/downloads/{user_download_artkey}': {delete: {response: GetUserDownloadsResponse[]}}
    'discover/users/downloads/{user_download_artkey}/download-link': {get: {response: GetUserDownloadLinkResponse}}
    'discover/users/{artkey}': {
        delete: {response: OkResponse}
        get: {response: GetUserResponse}
        put: {response: OkResponse; body: UpsertUserRequest}
    }
    'discover/users/{user_artkey}/access-tokens': {
        get: {response: AccessTokenListItem[]}
        post: {response: CreateAccessTokenResponse; body: CreateAccessTokenRequest}
    }
    'discover/users/{user_artkey}/access-tokens/{artkey}': {delete: {response: OkResponse}}
    'discover/vouchers/{artkey}': {get: {response: GetVoucherPromotionResponse}}
    'discover/vouchers/{artkey}/relations': {
        get: {response: GetVoucherPromotionRelationResponse[]}
        post: {response: OkResponse; body: UpdateRelationVoucherPromotionRequest}
    }
    'discover/vouchers/{artkey}/relations/collection-view': {
        get: {response: CollectionViewResultGetVoucherRelationCollectionViewResult}
    }
    'discover/vouchers/{artkey}/relations/collection-view/meta': {get: {response: CollectionViewMeta}}
    'discover/vouchers/{artkey}/relations/remove': {
        post: {response: OkResponse; body: UpdateRelationVoucherPromotionRequest | null}
    }
    'discover/workflows/snooze': {
        get: {response: GetSnoozesResponse[]}
        post: {response: OkResponse | CreateEntityResponse; body: CreateWorkflowSnoozeRequest}
    }
    'discover/workflows/snooze/{snooze_artkey}': {delete: {response: unknown}}
    'maintenance/ping': {get: {response: unknown}}
    'mock-services/vies/rest-api/check-status': {get: {response: StatusInformationResponse}}
    'mock-services/vies/rest-api/check-vat-number': {post: {response: CheckVatResponse; body: CheckVatRequest}}
    'partners/loe/ftp-trigger': {post: {response: OkResponse}}
    'partners/loe/inbound/confirmation': {post: {response: OkResponse}}
    'partners/loe/inbound/status': {post: {response: OkResponse}}
    'partners/loe/lot': {post: {response: OkResponse}}
    'partners/loe/outbound/confirmation': {post: {response: OkResponse}}
    'partners/loe/outbound/status': {post: {response: OkResponse}}
    'partners/loe/preadvice/confirmation': {post: {response: OkResponse}}
    'partners/loe/release-outbound/confirmation': {post: {response: OkResponse}}
    'portal/account/{slug}': {get: {response: GetAccountResponse}}
    'portal/activity': {post: {response: unknown}}
    'portal/brand-holders': {get: {response: BrandHoldersResponse[]}}
    'portal/brands': {get: {response: PublicBrandResponse[]}}
    'portal/brands/statistics': {get: {response: PublicBrandStatisticsResponse}}
    'portal/categories': {get: {response: PublicCategoryResponse[]}}
    'portal/cms/fragments': {get: {response: CmsFragmentRuntimeItem[]}}
    'portal/cms/i18n': {get: {response: CmsAllPlaceholdersResourcesResponse}}
    'portal/cms/media-folder': {get: {response: PublicCmsMediaFolderResponse}}
    'portal/cms/media-folder-tree': {get: {response: PublicCmsMediaFolderTreeResponse}}
    'portal/cms/page': {get: {response: CmsRuntimeViewResponse}}
    'portal/cms/pages': {get: {response: CmsPagePublicListItem[]}}
    'portal/create_registration': {post: {response: unknown; body: LeadRegistrationRequest}}
    'portal/data/timezones': {get: {response: string[]}}
    'portal/download': {get: {response: OkResponse}}
    'portal/external/price-list': {get: {response: PagedApiResultGetPriceListResponse}}
    'portal/favourites/collection-view': {get: {response: CollectionViewResultRelationFavouriteResult}}
    'portal/favourites/collection-view/meta': {get: {response: CollectionViewMeta}}
    'portal/filter/statistics': {post: {response: StatisticsForFilterResponse; body: GetFilterStatisticsRequest}}
    'portal/groups/{product_group_artkey}/categories': {get: {response: CategoriesResponse}}
    'portal/invite-login': {post: {response: PortalLoginResponse; body: InviteLoginRequest}}
    'portal/login': {post: {response: PortalLoginResponse; body: PortalLoginRequest}}
    'portal/offer-items': {post: {response: GetPortalOfferItemsResponse; body: GetPortalOfferItemsRequest}}
    'portal/offer-items/countries-of-origin': {post: {response: CountriesOfOriginResponse[]; body: CountriesOfOriginRequest}}
    'portal/offer-items/favourites/mark-update-seen': {post: {response: unknown; body: MarkFavouriteUpdateSeenRequest}}
    'portal/offer-items/favourites/statistics': {get: {response: FavouritesStatisticsResponse}}
    'portal/offer-items/price-list': {post: {response: OkResponse; body: ExportPortalPriceListRequest}}
    'portal/offer-items/product-photos': {post: {response: ProductPhotosResponse[]; body: ProductPhotosRequest}}
    'portal/offer-items/spotlight/collection-view': {get: {response: CollectionViewResultGetPortalOfferItemResponse}}
    'portal/offer-items/spotlight/collection-view/meta': {get: {response: CollectionViewMeta}}
    'portal/offer-items/{case_artkey}/favourite': {delete: {response: OkResponse}; post: {response: OkResponse}}
    'portal/offers': {get: {response: GetOfferResponse[]}}
    'portal/offers/{offer_artkey}/price-list': {get: {response: OkResponse}}
    'portal/orders/collection-view': {get: {response: CollectionViewResultGetOrderCollectionViewResponse}}
    'portal/orders/{artkey}': {get: {response: SalesOrderDetailsResponse}}
    'portal/orders/{artkey}/additionals': {get: {response: SalesOrderAdditionalResponse[]}}
    'portal/orders/{artkey}/credit-items': {get: {response: SalesOrderCreditItemResponse[]}}
    'portal/orders/{artkey}/invoice-details': {get: {response: AdditionalSalesOrderDetailsResponse}}
    'portal/orders/{artkey}/portal-order-items': {get: {response: PortalOrderItemResponse[]}}
    'portal/orders/{artkey}/repeat-order': {post: {response: SalesOrderDetailsResponse}}
    'portal/orders/{artkey}/sales-order-items': {get: {response: SalesOrderItemResponse[]}}
    'portal/orders/{artkey}/tbo-items': {get: {response: SalesOrderTBOItemResponse[]}}
    'portal/orders/{sales_order_artkey}/confirm': {post: {response: unknown; body: ConfirmOrderRequest}}
    'portal/orders/{sales_order_artkey}/export': {get: {response: unknown}}
    'portal/orders/{sales_order_artkey}/invoice': {get: {response: OkResponse}}
    'portal/orders/{sales_order_artkey}/outtake': {get: {response: OkResponse}}
    'portal/orders/{sales_order_artkey}/portal-order-items': {post: {response: OkResponse; body: ModifyCartItemRequest}}
    'portal/orders/{sales_order_artkey}/portal-order-items/{portal_order_item_artkey}': {delete: {response: OkResponse}}
    'portal/orders/{sales_order_artkey}/portal-order-items/{portal_order_item_artkey}/comment': {
        put: {response: OkResponse; body: UpdatePortalOrderItemCommentRequest}
    }
    'portal/orders/{sales_order_artkey}/proforma': {get: {response: OkResponse}}
    'portal/orders/{sales_order_artkey}/rating': {
        get: {response: OrderRatingResponse}
        put: {response: OkResponse; body: CreateOrUpdateOrderRatingRequest}
    }
    'portal/orders/{sales_order_artkey}/recommendations/collection-view': {
        get: {response: CollectionViewResultGetPortalOfferItemResponse}
    }
    'portal/orders/{sales_order_artkey}/recommendations/collection-view/meta': {get: {response: CollectionViewMeta}}
    'portal/orders/{sales_order_artkey}/validate': {get: {response: CartValidationResponse}}
    'portal/orders/{sales_order_artkey}/vouchers': {
        get: {response: GetActiveVouchersResponse[]}
        post: {response: OkResponse; body: ModifyBasketVoucherRequest}
    }
    'portal/orders/{sales_order_artkey}/vouchers/{voucher_artkey}': {delete: {response: OkResponse}}
    'portal/orders/{sales_order_artkey}/warehouse-status': {get: {response: SalesOrderWarehouseStatusResponse}}
    'portal/pallet-deals': {get: {response: PublicPalletDealResponse[]}}
    'portal/product-names': {get: {response: string[]}}
    'portal/promotions/active': {get: {response: GetActivePromotionResponse | OkResponse}}
    'portal/promotions/{promotion_artkey}/order': {post: {response: OkResponse; body: CreateOrderForPromotionRequest}}
    'portal/public/brand-holders': {get: {response: PublicBrandHolderResponse[]}}
    'portal/public/product-names': {get: {response: string[]}}
    'portal/refresh-portal-token': {get: {response: PortalLoginResponse}}
    'portal/search-counts': {get: {response: PublicSearchCountsResponse}}
    'portal/statistics': {get: {response: PublicStatisticsResponse}}
    'portal/stock-tbo-counts': {get: {response: PublicStockTboResponse}}
    'portal/user/access-tokens': {
        get: {response: AccessTokenListItem[]}
        post: {response: CreateAccessTokenResponse; body: CreateAccessTokenRequest}
    }
    'portal/user/access-tokens/{artkey}': {delete: {response: OkResponse}}
    'portal/user/change-password': {post: {response: OkResponse; body: ChangePasswordRequest}}
    'portal/user/current-order': {get: {response: SalesOrderDetailsResponse}}
    'portal/user/forgot-password': {post: {response: OkResponse; body: ForgotPasswordRequest}}
    'portal/user/profile': {
        get: {response: GetPortalProfileResponse}
        post: {response: OkResponse; body: UpdatePortalProfileRequest}
    }
    'portal/user/reset-password': {post: {response: OkResponse; body: ResetPasswordRequest}}
    'portal/user/send-deletion-request-email': {post: {response: OkResponse; body: SendDeletionRequestEmailRequest}}
    'portal/user/subscriptions': {get: {response: GetUserSubscriptionResponse}}
    'portal/user/subscriptions/{campaign_mnemonic}': {post: {response: OkResponse; body: UpdateCampaignSubscriptionRequest}}
    'portal/verify-otp': {post: {response: PortalLoginResponse; body: PortalVerifyOTPRequest}}
}
